{
  "common": {
    "app_name": "Tago",
    "welcome": "Bienvenido",
    "continue": "Continuar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "search": "Buscar",
    "filter": "Filtrar",
    "loading": "Cargando...",
    "error": "Error",
    "success": "Éxito",
    "confirm": "Confirmar",
    "back": "Atrás",
    "next": "Siguiente",
    "done": "Listo",
    "close": "Cerrar",
    "retry": "Reintentar",
    "yes": "Sí",
    "no": "No",
    "security": "Seguridad",
    "preferences": "Preferencias",
    "optional": "opcional",
    "actions": "Acciones",
    "pending": "Pendiente",
    "saved": "Guardado",
    "verified": "Verificado",
    "you": "vos",
    "or": "o",
    "toggle_language": "Cambiar idioma",
    "clear": "Borrar",
    "default_location": "Ubicación actual",
    "error_title": "No pudimos cargar esto",
    "error_description": "Revisá tu conexión y probá de nuevo."
  },
  "account_status": {
    "eyebrow": "Estado de cuenta",
    "archived_title": "Cuenta archivada",
    "suspended_title": "Cuenta en revisión",
    "suspended_until_title": "Cuenta pausada temporalmente",
    "archived_body": "Esta cuenta ya no puede operar en Tago. Conservamos el historial por seguridad y cumplimiento.",
    "suspended_body": "Por seguridad, pausamos temporalmente el acceso operativo. Nuestro equipo puede revisar el caso contigo.",
    "suspended_until_body": "Podrás volver a usar Tago cuando termine la pausa, salvo que nuestro equipo necesite una revisión adicional.",
    "reason_label": "Motivo",
    "until_label": "Disponible de nuevo",
    "support": "Contactar soporte",
    "sign_out": "Cerrar sesión",
    "support_subject": "Revisión de cuenta Tago",
    "support_body": "Hola Tago, necesito ayuda con el estado de mi cuenta: {{email}}."
  },
  "auth": {
    "login": "Iniciar Sesión",
    "register": "Registrarse",
    "logout": "Cerrar Sesión",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "password_placeholder": "Tu contraseña",
    "forgot_password": "¿Olvidaste tu contraseña?",
    "reset_password": "Restablecer Contraseña",
    "phone": "Teléfono",
    "verify_phone": "Verificar teléfono",
    "verify_email": "Verificar Correo",
    "verification_code": "Código de Verificación",
    "create_account": "Crear Cuenta",
    "already_have_account": "¿Ya tenés una cuenta?",
    "dont_have_account": "¿No tenés una cuenta?",
    "onboarding": "Bienvenido a Tago",
    "welcome_title": "Bienvenido a Tago",
    "welcome_subtitle": "Tu mejor opción para movilizarte en El Salvador",
    "sign_in_button": "Iniciar Sesión",
    "create_account_button": "Crear Cuenta",
    "first_name": "Nombres",
    "last_name": "Apellidos",
    "first_name_placeholder": "Ej: Carlos",
    "last_name_placeholder": "Ej: Ávila",
    "confirm_password": "Confirmar contraseña",
    "phone_placeholder": "+503 XXXX XXXX",
    "phone_optional": "Teléfono (opcional)",
    "phone_optional_hint": "Podés agregarlo después. Primero verificamos tu correo — sin código por teléfono en este paso.",
    "register_progressive_hint": "Después podés agregar nombre, teléfono y fecha de nacimiento — solo una vez, cuando haga falta.",
    "email_placeholder": "correo@ejemplo.com",
    "dob_label": "Fecha de nacimiento",
    "dob_day": "DD",
    "dob_month": "MM",
    "dob_year": "AAAA",
    "dob_helper": "DD / MM / AAAA · Mínimo 18 años para reservar",
    "dob_day_a11y": "Día",
    "dob_month_a11y": "Mes",
    "dob_year_a11y": "Año",
    "continue_with_google": "Continuar con Google",
    "continue_with_apple": "Continuar con Apple",
    "continue_with_phone": "Continuar con Teléfono",
    "or_divider": "o",
    "forgot_password_title": "Restablecer Contraseña",
    "forgot_password_desc": "Ingresá tu correo y te enviamos un enlace para restablecer tu contraseña.",
    "forgot_password_sent": "Si el correo existe, recibirás un enlace para restablecer tu contraseña.",
    "send_reset_link": "Enviar Enlace",
    "verify_phone_title": "Verificá tu teléfono",
    "verify_phone_desc": "Ingresá el código de 6 dígitos que te enviamos por WhatsApp a {{phone}}",
    "verify_phone_sending_title": "Estamos enviando tu código",
    "verify_phone_sending_desc": "Estamos solicitando un código por WhatsApp para {{phone}}. Esperá esta confirmación antes de ingresarlo.",
    "verify_phone_sending_button": "Enviando código…",
    "verify_current_phone_desc": "Antes de cambiarlo, confirmá tu número actual: {{phone}}. Te enviamos un código por WhatsApp.",
    "verify_phone_sms_unavailable_title": "No pudimos enviar el código",
    "verify_phone_sms_unavailable_body": "El envío falló; no está “en camino”. Reintentá en un momento o seguí por otro camino.",
    "verify_phone_sms_unavailable_send_body": "El envío falló; no está “en camino”. Reintentá en un momento o seguí por otro camino.",
    "verify_phone_sms_unavailable_resend_body": "El reenvío falló; no está “en camino”. Reintentá en un momento o seguí por otro camino.",
    "verify_phone_sms_busy_title": "Demasiados códigos por ahora",
    "verify_phone_sms_busy_body": "El sistema está saturado. Tu número está bien: esperá un momento y reintentá.",
    "verify_phone_sms_quota_title": "Límite temporal de envíos",
    "verify_phone_sms_quota_body": "Pediste varios códigos seguidos. Esperá un poco y reintentá, o escribinos por WhatsApp y te verificamos a mano.",
    "verify_phone_sms_provider_title": "Falla del envío, no de tu número",
    "verify_phone_sms_provider_body": "Nuestro proveedor rechazó el envío. No esperes un código que no va a llegar: continuá con correo o Google, o escribinos y te activamos a mano.",
    "otp_recovery_sign_in_email": "Continuar con correo",
    "otp_recovery_create_account_email": "Continuar con correo",
    "otp_recovery_continue_email": "Continuar con correo",
    "otp_recovery_continue_google": "Continuar con Google",
    "otp_recovery_continue_app": "Entrar a la app",
    "otp_recovery_verify_email": "Verificar mi correo",
    "otp_recovery_hint": "Podés seguir con correo o Google. No perdés el progreso.",
    "verify_phone_sms_unavailable_retry": "Reintentar envío",
    "verify_phone_sms_unavailable_retry_in": "Reintentar en {{seconds}}s",
    "verify_phone_sms_unavailable_change_number": "Usar otro número",
    "verify_phone_sms_unavailable_support": "Escribinos por WhatsApp",
    "verify_phone_sms_unavailable_support_short": "WhatsApp",
    "verify_phone_sms_support_message": "Hola, no me llega el código de verificación de Tago.",
    "verify_phone_sms_support_unavailable": "No pudimos abrir WhatsApp. Intentá de nuevo o escribinos desde la web.",
    "verify_email_title": "Verificar Correo",
    "verify_email_desc": "Hemos enviado un enlace de verificación a {{email}}",
    "verify_email_code_desc": "Ingresá el código de 6 dígitos enviado a {{email}}",
    "verify_email_check": "Revisar Correo",
    "verify_email_send_code": "Enviar código al correo",
    "verify_email_sent": "Te enviamos un código a tu correo.",
    "link_email_title": "Agregá tu correo",
    "link_email_desc": "Tu cuenta nació con teléfono. Agregá un correo real para recuperar acceso, recibir recibos y completar la verificación.",
    "link_phone_title": "Agregá tu teléfono",
    "link_phone_desc": "Tu correo ya está verificado. Agregá y verificá tu teléfono para proteger tu cuenta y completar la verificación.",
    "resend_code": "Reenviar código",
    "resend_in": "Reenviar en {{seconds}}s",
    "session_expired": "Tu sesión expiró. Iniciá sesión de nuevo.",
    "enter_phone_title": "Iniciar con Teléfono",
    "enter_phone_desc": "Ingresá tu número de teléfono y te enviamos un código de verificación por WhatsApp.",
    "phone_auth_unavailable_title": "Verificación no disponible",
    "phone_auth_unavailable_desc": "No pudimos preparar la verificación por teléfono en este momento. Volvé a iniciar sesión e intentá de nuevo en un minuto.",
    "phone_signup_title": "Crear cuenta con Teléfono",
    "phone_signup_desc": "Ingresá tu número. Te enviamos un código por WhatsApp — nombre y demás, solo cuando haga falta.",
    "send_code": "Enviar código",
    "phone_signup_send_code": "Crear cuenta y enviar código",
    "new_password": "Nueva contraseña",
    "reset_password_title": "Nueva Contraseña",
    "reset_password_desc": "Ingresá tu nueva contraseña.",
    "reset_password_button": "Restablecer Contraseña",
    "reset_password_success": "Contraseña restablecida exitosamente.",
    "reset_password_success_title": "Contraseña Actualizada",
    "reset_password_success_desc": "Tu contraseña fue cambiada. Iniciá sesión con tus nuevas credenciales.",
    "biometric_unlock_required": "Desbloqueo requerido",
    "errors": {
      "invalid_credentials": "Esos datos no coinciden. Revisalos e intentá de nuevo, o recuperá el acceso a tu cuenta.",
      "too_many_attempts": "Demasiados intentos. Intentá en {{minutes}} minutos.",
      "otp_invalid": "Código incorrecto",
      "otp_expired": "Ese código venció. Pedí uno nuevo.",
      "otp_send_failed": "No pudimos enviar el código. Intentá de nuevo.",
      "phone_undeliverable": "Ese número no puede recibir el código. Usá el celular donde tenés WhatsApp.",
      "otp_recently_sent": "Ya te mandamos un código hace un momento. Esperá antes de pedir otro.",
      "otp_rate_limited": "Demasiados intentos. Esperá un momento y volvé a probar.",
      "otp_service_unavailable": "La verificación no está disponible en este momento. Probá de nuevo en unos minutos.",
      "otp_too_many_attempts": "Demasiados códigos incorrectos. Pedí uno nuevo.",
      "phone_account_uses_email": "Ese número pertenece a una cuenta con correo. Entrá con tu correo o con Google.",
      "otp_resend_failed": "No pudimos reenviar el código. Intentá de nuevo.",
      "session_missing": "Tu sesión no está lista. Cerrá sesión, volvé a entrar e intentá de nuevo.",
      "signup_failed": "No se pudo crear la cuenta",
      "account_exists": "Ya existe una cuenta con este correo. Iniciá sesión o restablecé tu contraseña.",
      "email_in_use": "Ese correo ya está vinculado a otra cuenta. Iniciá sesión con ese correo o usá otro.",
      "phone_in_use": "Ese teléfono ya está vinculado a otra cuenta. Iniciá sesión con ese número o usá otro.",
      "phone_link_failed": "No pudimos vincular tu número. Probá de nuevo.",
      "phone_link_refresh_failed": "Tu número se verificó, pero no pudimos actualizar tu sesión. Probá de nuevo.",
      "consent_write_failed": "Cuenta creada pero no pudimos guardar tus preferencias de consentimiento. Intentá de nuevo.",
      "network": "Error de conexión",
      "reset_failed": "No pudimos guardar tu contraseña. Intentá de nuevo.",
      "password_unchanged": "Esa ya es tu contraseña actual. Podés iniciar sesión con ella o elegir una distinta para cambiarla.",
      "password_weak": "Elegí una contraseña más segura, con mayúsculas, minúsculas y números.",
      "reset_link_expired": "El enlace de restablecimiento expiró. Solicitá uno nuevo.",
      "email_verification_failed": "No pudimos enviar el código al correo. Intentá de nuevo.",
      "social_failed": "No se pudo iniciar sesión. Intentá de nuevo.",
      "service_unavailable": "No podemos iniciar sesión en este momento. Probá de nuevo en unos minutos.",
      "google_failed": "No se pudo iniciar sesión con Google. Intentá de nuevo o usá correo o teléfono.",
      "google_not_configured": "Google no está configurado correctamente. Ya fuimos notificados; usá correo o teléfono por ahora.",
      "google_play_services": "Google Play Services no está disponible o está desactualizado. Actualizalo e intentá de nuevo.",
      "google_internal": "No pudimos completar el ingreso con Google. Probá una vez más o entrá con tu correo y contraseña.",
      "google_access_blocked": "Google bloqueó el acceso de esta cuenta a Tago. Si el proyecto de Google está en modo Prueba, agregá este correo como usuario de prueba o publicá la app. También podés entrar con correo o teléfono.",
      "google_server_error": "Google respondió bien, pero el servidor de Tago no pudo abrir la sesión. Esperá unos segundos e intentá de nuevo. Si sigue, usá correo o teléfono.",
      "google_email_exists": "Ese correo de Google ya está en Tago con otro método. Entrá con correo y contraseña, o recuperá la contraseña.",
      "apple_failed": "No se pudo iniciar sesión con Apple. Intentá de nuevo o usá correo o teléfono.",
      "apple_unavailable": "Iniciar sesión con Apple no está disponible en este dispositivo. Usá correo, teléfono o Google.",
      "phone_account_not_found": "No hay una cuenta con ese número. Creá una cuenta o revisá el número.",
      "phone_in_use_title": "Este número ya tiene cuenta",
      "phone_in_use_body": "Ese teléfono ya está vinculado a otra cuenta de Tago. Podés entrar con ese número o probar con otro.",
      "phone_in_use_enter": "Entrar con este número",
      "phone_in_use_other": "Usar otro número",
      "phone_change_needs_current": "Para cambiar tu número, primero confirmá el que tenés hoy. Te mandamos un código a ese número."
    },
    "validation": {
      "first_name_min": "Mínimo 2 caracteres",
      "first_name_max": "Máximo 50 caracteres",
      "last_name_min": "Mínimo 2 caracteres",
      "last_name_max": "Máximo 50 caracteres",
      "email_invalid": "Correo inválido",
      "phone_format": "Usá un número válido de Centroamérica, México, EE.UU. o Canadá.",
      "phone_unsupported_country": "Todavía no verificamos números de ese país. Usá uno de Centroamérica, México, EE.UU. o Canadá.",
      "phone_not_mobile": "Ese número es fijo y no recibe WhatsApp. Usá el celular donde tenés WhatsApp.",
      "phone_unreachable": "Ese número no puede recibir el código. Revisalo o probá con otra línea móvil.",
      "password_min": "Mínimo 8 caracteres",
      "password_max": "Máximo 128 caracteres",
      "password_letter": "Al menos una letra",
      "password_lowercase": "Al menos una minúscula",
      "password_uppercase": "Al menos una mayúscula",
      "password_number": "Al menos un número",
      "passwords_mismatch": "Las contraseñas no coinciden",
      "dob_required": "La fecha de nacimiento es obligatoria",
      "dob_too_young": "Debés tener al menos 18 años para usar Tago",
      "accept_terms_required": "Aceptá los Términos y la Política de Privacidad para continuar"
    },
    "existing_phone_signed_in": "Ya tenías una cuenta con este número. Entraste con ella.",
    "oauth_failed": "No pudimos completar el inicio de sesión. Intentá de nuevo.",
    "verify_phone_later": "Verificar después — lo vas a necesitar antes de reservar o publicar",
    "verify_phone_later_a11y": "Verificar el teléfono después. Es obligatorio antes de reservar o publicar."
  },
  "phone": {
    "country_picker_label": "País: {{country}}",
    "country_picker_hint": "Tocá para cambiar el código de país",
    "country_picker_title": "Elegí tu país",
    "country_picker_search": "Buscar país o código",
    "country_picker_empty": "Sin resultados"
  },
  "consent": {
    "title": "Aviso de Privacidad",
    "terms_and_privacy": "Acepto los Términos de Servicio y Política de Privacidad",
    "data_processing": "Autorizo el tratamiento de mis datos personales (D.L. 144/2024)",
    "cross_border": "Autorizo la transferencia internacional de datos (AWS us-west-2, EE.UU.)",
    "marketing": "Acepto recibir comunicaciones de marketing",
    "view_privacy": "Ver política de privacidad",
    "view_terms": "Ver términos de servicio",
    "required": "(obligatorio)",
    "optional": "(opcional)"
  },
  "biometric": {
    "prompt_title": "Desbloqueo Biométrico",
    "prompt_message": "¿Activar desbloqueo con huella/Face ID?",
    "prompt_desc": "Accede a Tago sin ingresar tu contraseña.",
    "enable": "Activar",
    "skip": "Ahora no",
    "unlock": "Desbloquear Tago",
    "failed": "No se pudo verificar tu identidad",
    "fallback": "Demasiados intentos. Usá tu contraseña."
  },
  "tabs": {
    "explore": "Explorar",
    "trips": "Viajes",
    "messages": "Mensajes",
    "services": "Servicios",
    "hosting": "Anfitrión",
    "profile": "Perfil",
    "tours": "Tours"
  },
  "tours": {
    "route": "{{origin}} → {{destination}}",
    "per_person": "por persona",
    "up_to": "hasta {{price}}",
    "from": "desde",
    "tariffs": "Tarifas por vehículo",
    "no_dates": "Sin fechas disponibles por ahora",
    "host_verified": "Anfitrión verificado",
    "seats": "asientos",
    "available": "libres",
    "full": "Completo",
    "departure": "Elegí tu salida",
    "choose_vehicle": "Elegí tu transporte",
    "choose_vehicle_hint": "Te mostramos las opciones con espacio para todo tu grupo.",
    "choose_date": "¿Cuándo querés ir?",
    "date": "Fecha",
    "time": "Hora",
    "vehicle_total": "Total del vehículo",
    "passengers": "Pasajeros",
    "increase_passengers": "Aumentar pasajeros",
    "decrease_passengers": "Disminuir pasajeros",
    "max": "Máximo {{count}}",
    "passenger_range": "Mínimo {{min}} · máximo {{max}}",
    "capacity": "Hasta {{count}} pasajeros",
    "luggage": "Equipaje",
    "luggage_hint": "Elegí lo que va a llevar cada persona.",
    "luggage_light": "Liviano",
    "luggage_beach": "Playa",
    "luggage_luggage": "Maletas",
    "luggage_sports": "Deportivo",
    "book_now": "Cotizar",
    "reserve": "Reservar",
    "reserve_hint": "Te apartamos los lugares 15 minutos para que completés el pago.",
    "reserve_sign_in_hint": "Iniciá sesión para continuar con tu reserva.",
    "minimum_lead_time_hint": "La primera fecha disponible ya está seleccionada; dejamos un día calendario completo para preparar tu tour.",
    "minimum_group_unavailable": "Este tour no tiene por ahora transporte disponible para el mínimo de {{count}} personas.",
    "requirements": {
      "title": "Antes de reservar",
      "phone": "Verificá tu teléfono para reservar. Es una sola vez y protege tu compra.",
      "email": "Verificá tu correo para reservar.",
      "cta": "Verificar para reservar"
    },
    "checkout": {
      "title": "Pago",
      "hold_remaining": "Tenés {{time}} para completar el pago",
      "hold_soon": "Apurate: quedan {{time}}",
      "date": "Fecha",
      "total": "Total",
      "method": "Método de pago",
      "pay_full": "Pago completo",
      "pay_split": "Dividir el pago",
      "how_many_pay": "¿Cuántos van a pagar?",
      "each_pays": "Cada uno paga {{amount}}",
      "create_split": "Crear división",
      "split_created": "División lista",
      "split_created_hint": "Compartí estos links con tu grupo para que cada uno pague su parte.",
      "pay_my_share": "Pagar mi parte ({{amount}})",
      "share": "Compartir",
      "share_part": "Parte {{n}}",
      "card_option": "Tarjeta de crédito o débito",
      "card_number": "Número de tarjeta",
      "card_expiry": "Vencimiento",
      "card_cvv": "CVV",
      "card_name": "Nombre en la tarjeta",
      "email": "Correo",
      "secure_note": "Pago protegido por Tago. No guardamos los datos de tu tarjeta.",
      "pay": "Pagar {{amount}}",
      "email_required": "Necesitamos tu correo para continuar con PayPal.",
      "invalid_card": "Revisá los datos de la tarjeta.",
      "success_title": "¡Pago confirmado!",
      "success_body": "Tu reserva está lista. Te vamos a avisar con los detalles de la salida.",
      "failed_title": "No pudimos cobrar",
      "failed_body": "El pago fue rechazado. Probá con otra tarjeta o volvé a intentarlo.",
      "pending_title": "Pago en proceso",
      "pending_body": "Estamos confirmando tu pago. Te avisamos en cuanto se acredite.",
      "back_to_tours": "Volver a Tours",
      "view_bookings": "Ver mis reservas"
    },
    "bookings": {
      "title": "Mis reservas",
      "empty_title": "Todavía no tenés reservas",
      "empty_body": "Cuando reservés un tour, lo vas a ver acá.",
      "error_title": "No pudimos cargar tus reservas",
      "error_body": "Revisá tu conexión e intentá de nuevo.",
      "unknown": "Tour",
      "cancel": "Cancelar y reembolsar",
      "complete_payment": "Completar pago",
      "view_trip": "Ver operación del viaje",
      "cancel_confirm_title": "¿Cancelar esta reserva?",
      "cancel_confirm_body": "Si estás dentro del plazo, te devolvemos el 100% al medio de pago original.",
      "cancel_confirm_yes": "Sí, cancelar",
      "cancel_confirm_no": "No, volver"
    },
    "booking_status": {
      "draft": "Borrador",
      "capacity_held": "Reservada",
      "awaiting_payment": "Por pagar",
      "partially_paid": "Pago parcial",
      "paid": "Pagada",
      "in_progress": "En curso",
      "completed": "Completada",
      "cancelled": "Cancelada",
      "expired": "Expirada"
    },
    "split": {
      "title": "Pagá tu parte",
      "subtitle": "Te invitaron a dividir un tour de Tago.",
      "your_share": "Tu parte",
      "secure_brand": "Pago protegido de Tago",
      "part_context": "Parte {{position}} de {{total}}",
      "of_total": "de un total de {{amount}}",
      "pay": "Pagar {{amount}}",
      "paid_title": "¡Listo!",
      "paid_body": "Tu parte quedó pagada. El organizador se encarga del resto.",
      "pending_title": "Confirmando pago…",
      "pending_body": "Estamos esperando la confirmación segura del banco. Esta pantalla se actualizará sola."
    },
    "host": {
      "title": "Anfitrión de Tours",
      "subtitle": "Registrate como anfitrión para publicar tus tours, unidades y salidas.",
      "documents_hint": "Podés empezar sin documentos. Para publicar tours necesitamos tu RNT y permiso VMT.",
      "register": "Registrarme como anfitrión",
      "display_name": "Nombre público",
      "business_name": "Empresa (opcional)",
      "rnt": "RNT / CORSATUR (opcional)",
      "vmt": "Permiso VMT (opcional)",
      "insurance": "Póliza de seguro (opcional)",
      "status_pending": "Pendiente",
      "status_documents": "Documentos enviados",
      "status_verified": "Verificado",
      "status_suspended": "Suspendido",
      "units_title": "Mis unidades",
      "no_units": "Todavía no cargaste unidades.",
      "unit_label": "Nombre de la unidad",
      "unit_plate": "Placa",
      "unit_seats": "Asientos",
      "unit_cargo": "Equipaje (m³)",
      "add_unit": "Agregar unidad",
      "edit_unit": "Editar unidad",
      "save_changes": "Guardar cambios",
      "cancel": "Cancelar",
      "departures_title": "Salidas",
      "no_experiences": "Todavía no tenés tours publicados.",
      "no_departures": "Sin fechas cargadas.",
      "new_departure": "Nueva salida",
      "departure_time": "Hora",
      "add_departure": "Agregar salida",
      "host_bookings_title": "Reservas recibidas",
      "no_bookings": "Todavía no hay reservas.",
      "start_booking": "Iniciar",
      "complete_booking": "Completar",
      "open_operation": "Abrir operación",
      "operator_only_title": "Operación interna de Tago",
      "operator_only_body": "Por ahora Tago es el único operador autorizado de Tours.",
      "available": "Disponible",
      "earned": "Ganado",
      "disbursed": "Liquidado",
      "error": "No pudimos cargar tu perfil de anfitrión."
    },
    "reviews": {
      "title": "Reseñas",
      "empty": "Todavía no hay reseñas.",
      "write": "Dejar reseña",
      "your_rating": "Tu calificación",
      "comment_label": "Comentario",
      "comment_placeholder": "Contá cómo te fue (opcional)",
      "submit": "Enviar reseña",
      "thanks": "¡Gracias por tu reseña!",
      "rating_count": "{{count}} reseñas",
      "no_reviews_yet": "Sé el primero en reseñar",
      "reviewed": "Reseñado",
      "error": "No pudimos enviar tu reseña."
    },
    "custom_quote": {
      "cta_title": "Diseñá tu propio tour",
      "cta_body": "Elegí recorrido, paradas y grupo. Cotizalo al instante.",
      "title": "Tu tour a medida",
      "subtitle": "Armá un recorrido privado, a tu ritmo.",
      "national_note": "La salida, las paradas y el destino deben estar en El Salvador.",
      "itinerary": "Tu recorrido",
      "origin": "Punto de salida",
      "destination": "Destino final",
      "stop": "Parada {{count}}",
      "choose_place": "Elegí un lugar",
      "add_stop": "Agregar parada",
      "remove_stop": "Quitar parada",
      "search_placeholder": "Buscá un lugar en El Salvador",
      "searching": "Buscando lugares…",
      "search_error": "No pudimos buscar lugares. Probá de nuevo.",
      "no_places": "No encontramos un lugar con ese nombre.",
      "transport": "Tu transporte",
      "vehicle_microbus": "Microbús",
      "vehicle_microbus_detail": "Cómodo para grupos de hasta 15",
      "vehicle_coaster": "Coaster",
      "vehicle_coaster_detail": "Espacio para grupos de hasta 26",
      "vehicle_bus": "Bus",
      "vehicle_bus_detail": "Ideal para grupos de hasta 45",
      "vehicle_choice_hint": "Elegí el vehículo ideal para tu grupo.",
      "get_quote": "Ver mi cotización",
      "quote_summary": "Tu cotización privada",
      "quote_locked": "El recorrido, el grupo y el transporte ya están incluidos en esta cotización.",
      "detail_eyebrow": "Cotización privada",
      "detail_title": "Tu recorrido, listo para reservar",
      "detail_subtitle": "Un viaje nacional diseñado para tu grupo.",
      "route_points": "{{count}} puntos",
      "expires_at": "Válida hasta {{time}}",
      "expired_title": "Esta cotización venció",
      "expired_body": "Las tarifas y la disponibilidad cambian. Armemos una nueva cotización para tu recorrido.",
      "new_quote": "Crear otra cotización",
      "error_national": "Este recorrido debe ser completamente dentro de El Salvador.",
      "error_route": "No pudimos trazar una ruta segura para esos lugares. Probá con otros puntos.",
      "error_capacity": "Ese vehículo no alcanza para todo el grupo. Elegí uno más grande.",
      "error_unavailable": "La cotización a medida se está preparando. Probá de nuevo en unos minutos.",
      "error_conflict": "Esta cotización cambió mientras la preparábamos. Probá de nuevo.",
      "error": "No pudimos crear tu cotización. Probá de nuevo."
    },
    "start_point": {
      "title": "Punto de inicio",
      "hint": "Elegí dónde te recogemos o mantené el punto de encuentro del tour.",
      "default_badge": "Punto de encuentro del tour",
      "choose": "Elegir otro punto",
      "change": "Cambiar",
      "pickup_hint": "El conductor te recogerá acá.",
      "use_default": "Usar el punto de encuentro del tour",
      "search_title": "¿Dónde te recogemos?",
      "search_placeholder": "Dirección, hotel o punto de referencia",
      "searching": "Buscando lugares…",
      "search_empty": "No encontramos un lugar con ese nombre.",
      "search_error": "No pudimos buscar lugares. Probá de nuevo.",
      "reference_points": "Puntos de referencia"
    },
    "quote_title": "Tu cotización",
    "quote_meta": "{{origin}} → {{destination}} · {{date}}",
    "quote_breakdown": "{{count}} × {{price}}",
    "quote_remaining": "Quedan {{seats}} asientos y {{cargo}} m³ en esa salida.",
    "quote_error": "No pudimos cotizar. Probá de nuevo.",
    "quote_capacity": "No hay espacio para esa cantidad en esa salida. Elegí otra fecha o menos pasajeros.",
    "catalog_empty_title": "Tours próximamente",
    "catalog_empty_description": "Estamos armando las primeras rutas de Tago Tours. Volvé pronto.",
    "catalog_empty_country_title": "Próximamente en {{country}}",
    "catalog_empty_country_description": "Todavía no hay salidas desde este país. Podés cambiar de país arriba en cualquier momento.",
    "catalog_view_el_salvador": "Ver tours en El Salvador",
    "catalog_error_title": "No pudimos cargar los tours",
    "catalog_error_description": "Revisá tu conexión e intentá de nuevo.",
    "detail_error_title": "No encontramos ese tour",
    "detail_error_description": "Puede que ya no esté disponible. Volvé al listado.",
    "loading": "Cargando…",
    "retry": "Reintentar",
    "back": "Volver",
    "stops": "Recorrido",
    "travel_info": {
      "title": "Antes de viajar",
      "meeting_point": "Punto de encuentro",
      "what_to_bring": "Qué llevar",
      "documents": "Documentos",
      "documents_recommended": "Recomendado",
      "border_crossing": "Frontera",
      "policies": "Políticas del tour",
      "legal_notice": "Aviso legal",
      "international_title": "Viaje internacional",
      "international_banner": "Este tour cruza la frontera de El Salvador. Prepará tus documentos y revisá las condiciones antes de reservar.",
      "consent_label": "Declaro que leí los requisitos y los términos del viaje.",
      "consent_label_international": "Declaro que leí los requisitos de documentos y frontera y que acepto los términos del viaje.",
      "consent_required": "Para reservar tenés que aceptar los requisitos del viaje."
    },
    "photo_gallery": {
      "title": "Postales del recorrido",
      "hint": "Deslizá para explorar las paradas",
      "count": "{{count}} fotos",
      "scroll_label": "Galería de fotos del tour",
      "open_photo": "Abrir foto de {{label}}",
      "show_credits": "Ver créditos de las fotos",
      "hide_credits": "Ocultar créditos de las fotos",
      "credits_intro": "Estas fotografías se usan con licencia abierta. Tago las recortó, redimensionó y convirtió a WebP.",
      "credit_line": "{{title}} · {{author}}",
      "source": "Fuente",
      "license": "Licencia",
      "open_source": "Abrir fuente de {{label}}",
      "open_license": "Abrir licencia de {{label}}",
      "link_error": "No pudimos abrir ese enlace. Intentá de nuevo."
    },
    "catalog_subtitle": "Experiencias en {{country}}",
    "catalog_count": "{{count}} experiencias",
    "catalog_count_one": "{{count}} experiencia",
    "catalog_count_other": "{{count}} experiencias",
    "catalog_empty_filter_title": "Nada en este filtro",
    "catalog_empty_filter_description": "Probá con Todos o cambiá de país arriba.",
    "catalog_host_action": "Anfitrión",
    "catalog_country": "País: {{country}}",
    "catalog_country_title": "Elegí el país del catálogo",
    "cover_alt": "Foto de {{title}}",
    "all": "Todos",
    "scope_national": "Nacionales",
    "scope_regional": "Centroamérica",
    "stop_pickup": "Salida",
    "stop_waypoint": "Parada",
    "stop_destination": "Destino",
    "stop_marker": "Parada {{number}}: {{label}}",
    "map": {
      "driving_route": "Ruta en auto",
      "loading_route": "Trazando la ruta…",
      "route_unavailable": "Ruta por carretera no disponible",
      "load_error": "No pudimos cargar el mapa. Revisá tu conexión.",
      "gesture_hint": "Arrastrá para mover · pellizcá para acercar",
      "gesture_hint_web": "Usá la rueda o pellizcá para acercar",
      "live_location": "Ubicación en vivo"
    },
    "trip": {
      "title": "Operación del viaje",
      "route": "{{origin}} → {{destination}}",
      "not_found": "No encontramos este viaje",
      "not_found_body": "La operación aparece cuando la reserva está pagada y lista para salir.",
      "action_error": "No pudimos actualizar el viaje. Intentá de nuevo.",
      "people_short": "personas",
      "location_updated": "Ubicación actualizada a las {{time}}",
      "operator_verified": "Operación verificada por Tago",
      "driver_verified": "Conductor verificado: {{name}}",
      "driver_required": "Asigná un conductor verificado antes de iniciar el abordaje.",
      "driver_not_eligible": "Este conductor ya no cumple los requisitos de identidad o licencia para la salida.",
      "driver_busy": "Este conductor ya tiene otro viaje durante ese horario.",
      "driver_picker_label": "Conductor asignado",
      "driver_picker_placeholder": "Elegí un conductor",
      "driver_picker_title": "Asignar conductor",
      "driver_license_expires": "Licencia vigente hasta {{date}}",
      "driver_none_available": "No hay conductores internos con identidad, licencia y horario disponibles para esta salida.",
      "map_unavailable": "El mapa estará disponible cuando configuremos la cartografía para esta plataforma.",
      "itinerary": "Recorrido",
      "operation": "Control del viaje",
      "operation_body": "Los cambios se sincronizan en tiempo real con los pasajeros y Guardian.",
      "start_boarding": "Iniciar abordaje",
      "start_trip": "Iniciar viaje",
      "mark_arrival": "Marcar llegada",
      "pause": "Pausar viaje",
      "resume": "Reanudar viaje",
      "complete": "Completar viaje",
      "mark_next_stop": "Parada: {{stop}}",
      "share_location": "Compartir ubicación",
      "stop_location": "Dejar de compartir ubicación",
      "location_foreground_hint": "La ubicación se comparte únicamente mientras esta pantalla está abierta.",
      "location_permission": "Necesitamos permiso de ubicación mientras usás Tago para compartir el recorrido.",
      "location_error": "No pudimos actualizar la ubicación. Revisá tu conexión.",
      "live_activity_enable": "Ver progreso en la pantalla bloqueada",
      "acknowledge_emergency": "Confirmar atención de emergencia",
      "resolve_emergency": "Marcar emergencia como resuelta",
      "emergency_button": "Necesito ayuda",
      "emergency_confirm_title": "¿Activar alerta de emergencia?",
      "emergency_confirm_body": "Tago recibirá la alerta junto con la ubicación más reciente del viaje.",
      "emergency_confirm_yes": "Activar alerta",
      "status": {
        "scheduled": "Viaje programado",
        "boarding": "Abordaje en curso",
        "in_progress": "Viaje en curso",
        "paused": "Viaje pausado",
        "arrived": "Llegamos al destino",
        "completed": "Viaje completado",
        "cancelled": "Viaje cancelado"
      },
      "emergency": {
        "triggered": "Alerta enviada a Tago",
        "acknowledged": "Tago está atendiendo la alerta"
      }
    },
    "guardian": {
      "title": "Tago Guardian",
      "body": "Compartí el progreso del viaje con una persona de confianza mediante un enlace privado.",
      "setup": "Crear enlace Guardian",
      "active": "{{name}} puede ver el progreso de este viaje.",
      "replace_link": "Reemplazar enlace",
      "revoke": "Revocar acceso",
      "setup_title": "Activar Tago Guardian",
      "setup_body": "El enlace muestra únicamente el recorrido, el estado y la última ubicación del viaje.",
      "guardian_name": "Nombre de la persona de confianza",
      "responsible_adult": "Nombre del adulto responsable",
      "emergency_contact": "Contacto de emergencia",
      "emergency_phone": "Teléfono de emergencia",
      "includes_minors": "Viajan menores de edad",
      "consent": "Autorizo compartir el seguimiento de este viaje con la persona indicada.",
      "consent_required": "Necesitás autorizar el acceso antes de crear el enlace.",
      "adult_required": "Para compartir un viaje con menores, la cuenta organizadora debe tener 18 años o más y una fecha de nacimiento registrada.",
      "create_link": "Crear y compartir enlace",
      "share_title": "Seguimiento Tago Guardian",
      "share_message": "Podés seguir mi viaje de Tago aquí: {{url}}",
      "create_error": "No pudimos crear el enlace Guardian. Intentá de nuevo.",
      "public_title": "Tago Guardian",
      "shared_with": "Seguimiento privado compartido con {{name}}.",
      "privacy_note": "Este enlace es privado y temporal. No muestra datos personales ni información de pago.",
      "link_invalid": "Este enlace ya no está disponible.",
      "link_invalid_body": "Puede haber vencido o haber sido revocado por quien lo compartió."
    },
    "errors": {
      "generic": "Algo salió mal. Probá de nuevo.",
      "bad_request": "Los datos de la reserva no son válidos.",
      "forbidden": "No tenés permiso para realizar esta acción.",
      "operator_required": "Esta función está reservada al equipo interno de Tago.",
      "minimum_lead_time": "Elegí la primera fecha disponible o una posterior. Debe quedar un día calendario completo de por medio.",
      "minimum_passengers": "Los tours requieren un mínimo de 10 personas.",
      "start_point_outside_country": "Por ahora solo recogemos dentro de El Salvador.",
      "start_point_unverified": "No pudimos verificar el punto de recogida. Probá de nuevo en un momento.",
      "unauthorized": "Tu sesión expiró. Volvé a iniciar sesión.",
      "method_not_allowed": "Operación no permitida.",
      "provider_unsupported": "Ese método de pago no está disponible.",
      "booking_not_found": "No encontramos esa reserva.",
      "booking_not_payable": "Esta reserva ya no se puede pagar.",
      "booking_not_paid": "Esta reserva todavía no está pagada.",
      "payment_already_settled": "Esta reserva ya está pagada.",
      "payment_not_found": "No encontramos ese pago.",
      "hold_expired": "Se venció el tiempo para pagar. Elegí tu salida de nuevo.",
      "capacity_exceeded": "Ya no hay lugar para esa cantidad en esa salida.",
      "departure_cancelled": "Esa salida fue cancelada.",
      "departure_started": "Esa salida ya comenzó.",
      "unit_unavailable": "Ese vehículo no está disponible para este tour.",
      "unit_busy": "Ese vehículo ya está reservado a esa hora. Elegí otro horario o vehículo.",
      "custom_quote_mismatch": "Esta cotización ya no coincide con tu grupo o recorrido. Creá una nueva para continuar.",
      "custom_quote_conflict": "No pudimos reutilizar esta cotización de forma segura. Creá una nueva para continuar.",
      "terms_required": "Para reservar tenés que aceptar los requisitos y términos del viaje.",
      "not_found": "No encontramos ese tour.",
      "amount_mismatch": "El precio cambió. Revisá el total e intentá de nuevo.",
      "payment_failed": "No pudimos procesar el pago. Probá con otra tarjeta.",
      "refund_not_allowed": "Ya pasó el plazo para cancelar con reembolso.",
      "refund_failed": "No pudimos procesar el reembolso. Intentá de nuevo.",
      "refund_reconciliation_required": "El reembolso requiere revisión del equipo de Tago. No vuelvas a pagarlo.",
      "split_failed": "No pudimos dividir el pago. Intentá de nuevo.",
      "split_not_found": "No encontramos esa invitación de pago.",
      "split_already_paid": "Esta parte ya fue pagada.",
      "host_required": "Primero registrate como anfitrión.",
      "review_not_allowed": "Solo podés reseñar un tour que ya completaste.",
      "review_exists": "Ya dejaste una reseña para este tour.",
      "webhook_invalid": "No pudimos verificar el pago.",
      "db_error": "Tuvimos un problema al guardar. Probá de nuevo.",
      "internal_error": "Algo salió mal de nuestro lado. Probá de nuevo."
    }
  },
  "screens": {
    "explore": "Explorar",
    "vehicle_details": "Detalles del Vehículo",
    "trips": "Viajes",
    "trip_details": "Detalles del Viaje",
    "messages": "Mensajes",
    "conversation": "Conversación",
    "hosting": "Anfitrión",
    "listings": "Mis Vehículos",
    "earnings": "Ganancias",
    "new_listing_details": "Detalles del Vehículo",
    "new_listing_photos": "Fotos",
    "new_listing_features": "Características",
    "new_listing_pricing": "Precio",
    "new_listing_location": "Ubicación",
    "new_listing_review": "Revisar",
    "hosting_calendar": "Calendario",
    "profile": "Perfil",
    "settings": "Configuración",
    "verification": "Verificación",
    "notifications": "Notificaciones",
    "payment_methods": "Métodos de Pago",
    "privacy": "Privacidad",
    "data_export": "Exportar Datos",
    "booking": "Reserva",
    "insurance": "Seguro",
    "checkout": "Pagar",
    "confirmation": "Confirmación",
    "checkin": "Check-in",
    "checkout_trip": "Check-out",
    "coming_soon": "Próximamente",
    "vehicle_detail": "Detalle del vehículo",
    "trip_detail": "Detalle del viaje",
    "checkout_checkin": "Check-out"
  },
  "profile": {
    "edit_profile": "Editar Perfil",
    "verification": "Verificación",
    "payment_methods": "Métodos de Pago",
    "notifications": "Notificaciones",
    "privacy": "Privacidad y Datos",
    "data_export": "Descargar mis datos",
    "data_export_subtitle": "Obtené una copia de toda la información de tu cuenta",
    "terms_of_service": "Términos de Servicio",
    "cancellation_policy": "Política de Cancelación",
    "settings": "Configuración",
    "logout": "Cerrar Sesión",
    "logout_confirm_title": "Cerrar Sesión",
    "logout_confirm_message": "¿Seguro que querés cerrar sesión?",
    "member_since": "Miembro desde {{date}}",
    "profile_completion": "Perfil {{percent}}% completo",
    "completion": {
      "see_all": "Ver {{count}} más",
      "see_less": "Ver menos",
      "field": {
        "first_name": "Agregá tus nombres",
        "last_name": "Agregá tus apellidos",
        "date_of_birth": "Agregá tu fecha de nacimiento",
        "phone": "Verificá tu teléfono",
        "avatar": "Subí una foto de perfil",
        "verification": "Verificá tu identidad",
        "country": "Indicá tu país",
        "city": "Indicá tu ciudad",
        "language": "Elegí tu idioma"
      }
    },
    "date_of_birth": "Fecha de nacimiento",
    "first_names_placeholder": "Ej: Carlos Eduardo",
    "last_names_placeholder": "Ej: Ávila Renderos",
    "language": "Idioma",
    "city": "Ciudad",
    "select_city": "Elegí tu ciudad",
    "country": "País",
    "select_country": "Elegí tu país",
    "change_avatar": "Cambiar foto",
    "avatar_updated": "Foto actualizada",
    "avatar_upload_failed": "No se pudo subir la foto",
    "avatar_read_failed": "No pudimos leer la foto desde tu teléfono. Probá con otra imagen.",
    "avatar_storage_failed": "No pudimos subir la foto al servidor. Revisá tu conexión e intentá de nuevo.",
    "avatar_save_failed": "Subimos la foto pero no pudimos guardarla en tu perfil. Intentá de nuevo.",
    "avatar_session_expired": "Tu sesión expiró. Cerrá sesión y volvé a entrar, luego probá de nuevo.",
    "profile_updated": "Perfil actualizado",
    "update_failed": "No se pudo actualizar el perfil",
    "imprint": "Información legal",
    "version": "Versión {{version}}",
    "validation": {
      "min_age": "Tenés que tener al menos 18 años"
    },
    "change_verified_phone": "Cambiar teléfono verificado",
    "phone_not_verified": "Sin teléfono verificado",
    "phone_verified_hint": "Verificado por código. Tocá para cambiarlo.",
    "phone_add_hint": "Agregá un número con código de seguridad."
  },
  "imprint": {
    "title": "Información legal",
    "intro": "Tago es el marketplace P2P de alquiler de vehículos en El Salvador. Operamos como una plataforma que conecta dueños de vehículos con personas que quieren alquilarlos.",
    "legal_status_title": "Estado legal",
    "legal_status_body": "TAKE AND GO, SOCIEDAD POR ACCIONES SIMPLIFICADA DE CAPITAL VARIABLE (TAGO, S.A.S. DE C.V.), inscrita en el Registro de Comercio del Centro Nacional de Registros bajo el asiento 152 del libro 4942 del Registro de Sociedades, con matrícula de empresa No. 126 del libro 512, vigente desde el 10 de marzo de 2026.",
    "address_title": "Domicilio",
    "address_body": "Avenida Jacarandas 175, Colonia Miramonte, San Salvador, El Salvador",
    "contact_title": "Contacto",
    "contact_email": "team@tago.rent",
    "contact_whatsapp": "+503 7839 2213",
    "app_version": "Versión de la app: {{version}}"
  },
  "legal": {
    "last_updated": "Última actualización: {{date}} · v{{version}}"
  },
  "explore": {
    "greeting_morning": "Buenos días",
    "greeting_afternoon": "Buenas tardes",
    "greeting_evening": "Buenas noches",
    "search_cta": "Buscar carros",
    "search_where": "Dónde",
    "search_placeholder": "Buscá por modelo o marca (p. ej. Vitara)",
    "clear_search": "Limpiá la búsqueda",
    "search_start": "Inicio",
    "search_end": "Fin",
    "search_date_placeholder": "Elegí fechas",
    "searching": "Buscando carros...",
    "no_results": "Sin carros para estos filtros",
    "result_count": "{{count}} carros disponibles",
    "result_count_one": "{{count}} carro disponible",
    "result_count_other": "{{count}} carros disponibles",
    "search_location": "Ubicación",
    "pickup": "Recogida",
    "return": "Devolución",
    "nearby_title": "Cerca de vos",
    "nearby_count": "{{count}} cerca de vos",
    "nearby_count_one": "{{count}} cerca de vos",
    "nearby_count_other": "{{count}} cerca de vos",
    "map_cluster_count": "{{count}} carros",
    "map_cluster_count_one": "{{count}} carro",
    "map_cluster_count_other": "{{count}} carros",
    "map_cluster_zoom_label": "{{count}} carros en esta zona. Tocá para acercar",
    "map_cluster_choose_label": "{{count}} carros. Tocá para ver la lista",
    "map_vehicle_marker_label": "{{vehicle}}, {{price}}",
    "map_cluster_sheet_title": "Carros en esta zona",
    "nearby_fallback_notice": "No hay vehículos cerca de vos — te mostramos todo El Salvador",
    "nearby_empty": "No hay vehículos cerca",
    "all_vehicles_empty": "No hay vehículos disponibles",
    "popular_title": "Populares",
    "view_all": "Ver todos",
    "show_all": "Mostrar todos",
    "trip_count": "{{count}} viajes",
    "trip_count_one": "{{count}} viaje",
    "trip_count_other": "{{count}} viajes",
    "rented_days": "{{count}} días rentado",
    "rented_days_one": "{{count}} día rentado",
    "rented_days_other": "{{count}} días rentado",
    "view_map": "Ver mapa",
    "map_unavailable": "Mapa no disponible",
    "map_unavailable_desc": "No pudimos cargar el mapa. Los vehículos siguen disponibles en la lista.",
    "map_unavailable_action": "Ver la lista",
    "trips_this_week": "{{count}} viajes completados esta semana",
    "per_day": "/día",
    "per_hour": "/hora",
    "instant_book": "Instantáneo",
    "promo_title": "15% de descuento",
    "promo_subtitle": "Tu primer viaje",
    "promo_unlock_subtitle": "Perfil completo",
    "promo_code": "WELCOME",
    "promo_cta": "Reservar ahora",
    "promo_complete_profile_cta": "Completar perfil",
    "promo_copied": "Código WELCOME copiado. Usalo al pagar.",
    "independence_banner_kicker": "Promo 15 de septiembre",
    "independence_banner_title": "15% menos si tu viaje incluye el 15",
    "independence_banner_body": "Aplica automático: Tago descuenta su tarifa de servicio en reservas que incluyan el 15 de septiembre. Sin código.",
    "independence_banner_accessibility": "Promo 15 de septiembre. 15 por ciento menos si tu viaje incluye el 15. Aplica automático sin código.",
    "host_cta_title": "Ganá dinero con tu vehículo",
    "host_cta_subtitle": "Publicá y empezá a generar ingresos",
    "default_location": "Elegí un lugar",
    "coming_soon": "Próximamente",
    "notifications": "Notificaciones",
    "promo_code_label": "Código {{code}} al reservar",
    "promo_locked_label": "Se desbloquea al completar tu perfil al 100%.",
    "available_count": "{{count}} disponibles",
    "available_count_one": "{{count}} disponible",
    "available_count_other": "{{count}} disponibles",
    "filter_title": "Filtros",
    "filter_transmission": "Transmisión",
    "filter_included_services": "Incluye",
    "filter_included_services_hint": "Mostrá solo vehículos que incluyan estos servicios en la tarifa.",
    "filter_price_range": "Rango de precio",
    "filter_min_price": "Precio mínimo",
    "filter_max_price": "Precio máximo",
    "filter_year": "Año mínimo",
    "filter_instant_book": "Solo reserva instantánea",
    "filter_apply": "Aplicar filtros",
    "filter_reset": "Limpiar",
    "filter_active_count": "{{count}} filtro(s)",
    "filters_active_notice": "Mostrando resultados con {{count}} filtro(s) activo(s)",
    "location_search_title": "Buscar ubicación",
    "location_search_placeholder": "Buscá un lugar...",
    "location_no_results": "No se encontraron resultados",
    "location_search_error": "No pudimos buscar direcciones. Revisá tu conexión y probá de nuevo.",
    "location_close": "Cerrar",
    "date_range_title": "Seleccionar fechas",
    "date_confirm": "Confirmar fechas",
    "all_vehicles_title": "Todos los vehículos",
    "map_title": "Mapa",
    "vehicles_on_map": "{{count}} vehículos",
    "map_view_results_one": "Ver {{count}} vehículo",
    "map_view_results_other": "Ver {{count}} vehículos",
    "map_results_title": "Vehículos del mapa",
    "map_fit_results": "Volver a encuadrar los vehículos",
    "zoom_in": "Acercar el mapa",
    "zoom_out": "Alejar el mapa",
    "vehicles_on_map_one": "{{count}} vehículo",
    "vehicles_on_map_other": "{{count}} vehículos",
    "categories": {
      "suv": "SUV",
      "sedan": "Sedán",
      "pickup": "Pickup",
      "microbus": "Microbús",
      "compact": "Compacto",
      "luxury": "Premium",
      "van": "Van",
      "sports": "Eléctrico",
      "heavy_duty": "Trabajo",
      "motorcycle": "Moto",
      "recreational": "Diversión"
    },
    "transmission": {
      "automatic": "Automático",
      "manual": "Manual",
      "cvt": "Automático",
      "dct": "Automático"
    },
    "nearby_carousel_dot": "Ver carro {{index}} de {{total}}",
    "rating_new": "Nuevo",
    "all_title": "Disponibles en El Salvador",
    "all_count": "{{count}} en todo el país"
  },
  "welcome": {
    "headline": "Alquilá tu\npróximo ride.",
    "slogan": "Tu próximo vehículo, a un toque de distancia.",
    "subheadline": "Vehículos verificados de personas reales, con soporte claro y cobertura incluida.",
    "cta_start": "Empezar",
    "cta_login": "Ya tengo cuenta",
    "divider": "o continuá con",
    "divider_short": "o",
    "auth_google": "Google",
    "auth_apple": "Apple",
    "auth_phone": "Teléfono",
    "auth_email": "Email",
    "legal_prefix": "Al continuar, aceptás los ",
    "legal_terms": "Términos",
    "legal_and": " y ",
    "legal_privacy": "Privacidad",
    "trust_insurance": "Cobertura incluida",
    "trust_verified": "Verificados",
    "trust_p2p": "P2P"
  },
  "forgot_password": {
    "headline": "Restablecé tu\ncontraseña.",
    "subtitle": "Te enviaremos un enlace seguro para crear una nueva contraseña."
  },
  "reset_password": {
    "headline": "Creá una nueva\ncontraseña.",
    "subtitle": "Elegí una contraseña segura para proteger tu cuenta."
  },
  "login": {
    "headline": "Iniciá sesión",
    "subtitle": "Accedé a tu cuenta para reservar, publicar o gestionar tus viajes."
  },
  "register": {
    "headline": "Creá tu\ncuenta.",
    "subtitle": "Unite a miles que alquilan y comparten vehículos en El Salvador.",
    "strength_weak": "Débil",
    "strength_fair": "Regular",
    "strength_good": "Buena",
    "strength_strong": "Fuerte",
    "email_divider": "o registrate con email"
  },
  "a11y": {
    "hide_password": "Ocultar contraseña",
    "show_password": "Mostrar contraseña",
    "otp_code": "Código de verificación",
    "otp_digit": "Dígito {{current}} de {{total}}",
    "paste_code": "Mantén presionado para pegar código",
    "welcome_trust_insurance": "Cobertura incluida",
    "welcome_trust_verified": "Vehículos verificados",
    "welcome_trust_p2p": "Alquiler persona a persona",
    "welcome_cta_start": "Comenzar registro",
    "welcome_cta_login": "Ir a inicio de sesión",
    "welcome_google_hint": "Iniciá sesión con Google",
    "welcome_apple_hint": "Iniciá sesión con Apple",
    "welcome_phone_hint": "Iniciá sesión con tu teléfono",
    "welcome_email_hint": "Iniciá sesión con correo electrónico",
    "user_online": "En línea",
    "avatar_overflow": "+{{count}} más",
    "clear_search": "Limpiar búsqueda",
    "remove_chip": "Eliminar",
    "favorite": "Favorito",
    "add_to_favorites": "Agregar a favoritos",
    "remove_from_favorites": "Quitar de favoritos",
    "vehicle_card_label": "{{make}} {{model}}, ${{price}} por día",
    "rating": "Calificación: {{value}} de {{max}} estrellas",
    "datepicker_prev_month": "Mes anterior",
    "datepicker_next_month": "Mes siguiente",
    "datepicker_prev_year": "Año anterior",
    "datepicker_next_year": "Año siguiente",
    "datepicker_select_month": "Seleccionar mes",
    "datepicker_select_year": "Seleccionar año",
    "map_zoom_in": "Acercar",
    "map_zoom_out": "Alejar",
    "map_marker": "Marcador del mapa",
    "map_canvas": "Mapa"
  },
  "error": {
    "boundary_title": "Algo salió mal",
    "boundary_desc": "Ocurrió un error inesperado. Intentá de nuevo.",
    "boundary_retry": "Reintentar"
  },
  "errors": {
    "generic": "Algo salió mal. Intentá de nuevo.",
    "network": "Error de conexión. Revisá tu internet.",
    "offline_title": "Sin conexión",
    "offline_desc": "Revisá tu conexión a internet e intentá de nuevo.",
    "offline_action": "Reintentar",
    "unauthorized": "Tu sesión expiró. Iniciá sesión de nuevo.",
    "forbidden": "No tenés permisos para esta acción.",
    "bad_request": "La solicitud no es válida. Revisá los datos.",
    "not_found": "No encontramos lo que buscás.",
    "validation": "Algunos campos no son válidos. Revisá el formulario.",
    "rate_limited": "Demasiados intentos. Esperá unos segundos y probá de nuevo.",
    "unique_violation": "Ya existe un registro con esos datos. Probá de nuevo o contactá soporte.",
    "fk_violation": "Falta información relacionada. Volvé a intentar.",
    "check_violation": "Algunos datos no son válidos. Revisá el formulario.",
    "not_null_violation": "Faltan campos obligatorios. Completá la información.",
    "permission_denied": "No tenés permisos para esta acción.",
    "too_many_connections": "El servidor está saturado. Probá de nuevo en unos segundos.",
    "timeout": "El servidor está lento. Probá de nuevo en unos segundos.",
    "photo_upload_failed": "No se pudieron subir las fotos. Revisá la conexión e intentá publicar de nuevo.",
    "document_upload_failed": "No se pudo verificar la tarjeta de circulación. Subí fotos más claras e intentá publicar de nuevo.",
    "policy_upload_failed": "No se pudo verificar la póliza de seguro. Subí el documento completo e intentá publicar de nuevo.",
    "document_expired": "Este documento está vencido. Subí uno vigente."
  },
  "validation": {
    "org_name_min": "El nombre debe tener al menos 2 caracteres",
    "org_name_max": "El nombre no puede pasar de 100 caracteres",
    "org_legal_name_min": "La razón social debe tener al menos 3 caracteres",
    "org_legal_name_max": "La razón social no puede pasar de 200 caracteres",
    "org_tax_id_required": "Ingresá el NIT de la empresa",
    "org_tax_id_format": "El NIT debe tener el formato 0614-050707-104-8",
    "org_tax_id_checksum": "Revisá el NIT: el dígito verificador no coincide",
    "org_tax_id_max": "El NIT no puede pasar de 20 caracteres",
    "email_invalid": "Ingresá un correo válido",
    "phone_min": "Ingresá al menos 8 dígitos",
    "phone_max": "El teléfono no puede pasar de 15 dígitos",
    "url_invalid": "Ingresá una URL válida",
    "email_or_phone_required": "Ingresá correo o teléfono",
    "payout_bank_required": "Seleccioná el banco",
    "payout_account_number_min": "Ingresá al menos 6 dígitos",
    "payout_account_number_max": "El número de cuenta no puede pasar de 24 dígitos",
    "payout_account_number_digits": "Usá solo números",
    "payout_holder_name_min": "El titular debe tener al menos 3 caracteres",
    "payout_holder_name_max": "El nombre del titular es demasiado largo",
    "payout_dui_format": "El DUI debe tener 9 dígitos"
  },
  "toast": {
    "dismiss": "Cerrar",
    "action_undo": "Deshacer"
  },
  "empty": {
    "no_vehicles_title": "Sin vehículos aún",
    "no_vehicles_desc": "Agregá tu primer vehículo para comenzar a ser anfitrión",
    "no_vehicles_action": "Agregar vehículo",
    "no_bookings_title": "Sin reservas",
    "no_bookings_desc": "Explorá vehículos disponibles para hacer tu primera reserva",
    "no_bookings_action": "Explorar vehículos",
    "no_messages_title": "Sin mensajes",
    "no_messages_desc": "Tus conversaciones aparecerán aquí",
    "no_results_title": "Sin resultados",
    "no_results_desc": "Sin resultados para \"{{query}}\". Probá con otras palabras.",
    "no_results_desc_generic": "Probá ajustar tu búsqueda o filtros.",
    "offline_title": "No pudimos cargar esto",
    "offline_desc": "Revisá tu conexión y probá de nuevo.",
    "offline_action": "Reintentar"
  },
  "vehicle_detail": {
    "specs": "Especificaciones",
    "features": "Características",
    "included_in_rate": "Incluido en la tarifa",
    "reviews": "Experiencias con este vehículo",
    "availability": "Disponibilidad",
    "host": "Anfitrión",
    "guest": "Huésped",
    "book_now": "Reservar ahora",
    "per_day": "/día",
    "per_hour": "/hora",
    "no_reviews": "Aún sin reseñas",
    "see_all_reviews": "Ver todas las reseñas",
    "contact_host": "Contactar anfitrión",
    "contact_guest": "Contactar huésped",
    "share": "Compartir",
    "similar_vehicles": "Vehículos similares",
    "report": "Reportar",
    "instant_book_badge": "Reserva instantánea",
    "view_image": "Ver imagen",
    "your_vehicle": "Tu vehículo",
    "agency_insurance_coverage": "Cobertura comercial de la agencia {{orgName}}",
    "host_policy_coverage": "Póliza propia del anfitrión",
    "qualitas_asr_coverage": "Cobertura Qualitas verificada por ASR",
    "no_platform_coverage": "Sin cobertura de plataforma",
    "platform_insurance_coming_soon": "Este vehículo opera con la póliza verificada del anfitrión.",
    "booking_coming_soon": "Cobertura incluida",
    "natural_vehicle_booking_block": "Este vehículo está visible mientras se completan sus documentos. La reserva se habilita cuando la póliza quede verificada.",
    "unavailable_title": "Este vehículo ya no está disponible",
    "unavailable_body": "Puede haber sido pausado, eliminado o reservado. Seguí explorando vehículos activos.",
    "browse_available": "Ver vehículos disponibles",
    "inspection_title": "Inspección mecánica y seguridad",
    "inspection_subtitle": "17 puntos técnicos verificados para tu seguridad y tranquilidad",
    "inspection_badge": "Verificación ASR / Qualitas",
    "inspection_view_photo": "Ver foto de inspección",
    "inspection_slot_hood_open": "Área de motor y capó",
    "inspection_slot_engine_closeup": "Motor y componentes",
    "inspection_slot_rim_complete": "Larguero y chasis izq.",
    "inspection_slot_rim_serial": "Larguero y chasis der.",
    "inspection_slot_odometer": "Odómetro verificado",
    "inspection_slot_spare_tire": "Llanta de repuesto",
    "inspection_slot_tools": "Herramientas y mica",
    "inspection_slot_default": "Punto de inspección"
  },
  "photo_lightbox": {
    "close": "Cerrar",
    "next": "Siguiente foto",
    "previous": "Foto anterior",
    "zoom_in": "Acercar",
    "zoom_out": "Alejar",
    "counter": "{{current}} de {{total}}",
    "see_all": "Ver las {{count}} fotos"
  },
  "messages": {
    "locked_title": "El chat se abre al reservar",
    "locked_body": "Cuando la reserva esté pagada van a poder escribirse acá mismo. Así protegemos tu pago y tus datos.",
    "locked_until_paid": "Vas a poder escribirle al anfitrión cuando tu reserva esté pagada. Así protegemos a las dos partes.",
    "title": "Mensajes",
    "search_placeholder": "Buscar chats",
    "no_conversations": "Todavía no hay chats",
    "no_conversations_desc": "El chat con el anfitrión se abre solo cuando tu reserva está pagada. Ahí coordinan la entrega del carro.",
    "no_results": "Sin resultados",
    "no_results_desc": "No encontramos conversaciones con ese nombre o mensaje.",
    "desktop_empty_title": "Conversaciones listas",
    "desktop_empty_desc": "Abrí cualquier chat y seguí desde donde quedaste.",
    "empty_conversation_title": "Listo para conversar",
    "empty_conversation_desc": "Escribí el primer mensaje cuando querás.",
    "type_message": "Escribí un mensaje...",
    "send": "Enviar",
    "sending": "Enviando",
    "sent": "Enviado",
    "read": "Leído",
    "jump_to_latest": "Ir al ultimo mensaje",
    "today": "Hoy",
    "yesterday": "Ayer",
    "you": "Vos",
    "image": "Imagen",
    "open_image": "Abrir la foto",
    "shared_location": "Ubicación compartida",
    "open_location": "Abrir la ubicación en el mapa",
    "attach_title": "Adjuntar",
    "attach_camera": "Tomar foto",
    "attach_gallery": "Elegir de la galería",
    "attach_location": "Compartir mi ubicación",
    "location_permission_denied": "Necesitamos permiso de ubicación para compartirla.",
    "camera_permission_denied": "Necesitamos permiso de cámara para tomar la foto.",
    "location_unavailable": "No pudimos obtener tu ubicación. Probá de nuevo.",
    "quick_replies_label": "Respuestas rápidas",
    "quick_reply_on_my_way": "Voy en camino",
    "quick_reply_arrived": "Ya llegué",
    "quick_reply_on_time": "Estoy ahí a la hora",
    "quick_reply_thanks": "¡Gracias!",
    "call_a11y": "Llamar a {{name}}",
    "call_title": "Llamar a {{name}}",
    "call_body": "Se abrirá tu teléfono para iniciar la llamada.",
    "call_action": "Llamar",
    "call_cancel": "Ahora no",
    "call_unavailable_title": "Todavía no hay teléfono",
    "call_unavailable_body": "{{name}} no tiene un teléfono verificado. Seguí por el chat.",
    "call_failed": "No se pudo iniciar la llamada. Probá de nuevo.",
    "search_in_conversation": "Buscar en este chat",
    "search_messages_placeholder": "Buscar mensajes",
    "search_minimum": "Escribí al menos 2 letras para buscar en este chat.",
    "search_results": "Resultados",
    "search_no_results_title": "No encontramos mensajes",
    "search_no_results_desc": "Probá con otra palabra o frase.",
    "search_result_a11y": "Resultado de búsqueda",
    "close_search": "Cerrar búsqueda",
    "reply_action": "Responder",
    "replying_to": "Respondiendo a {{name}}",
    "reply_message": "un mensaje",
    "reply_deleted": "Mensaje eliminado",
    "reply_open_original": "Ver mensaje original",
    "reply_cancel": "Cancelar respuesta",
    "trip_context_title": "Viaje",
    "trip_context_open": "Ver viaje",
    "trip_context_pickup": "Recogida",
    "trip_context_dropoff": "Devolución",
    "system": "Sistema",
    "new_conversation": "Nueva conversación",
    "attach_image": "Adjuntar imagen",
    "sending_image": "Enviando imagen...",
    "image_too_large": "Imagen muy grande",
    "image_send_failed": "No se pudo enviar la imagen",
    "send_failed": "No se pudo enviar el mensaje",
    "send_failed_tap": "No se envió · Toca para reintentar",
    "retry_send": "Reintentar el envío",
    "content_filtered": "Coordiná acá para no perder cobertura, pagos ni soporte de Tago si algo sale mal.",
    "typing": "{{name}} está escribiendo...",
    "preview_image": "📷 Imagen",
    "preview_location": "📍 Ubicación"
  },
  "trips": {
    "title": "Viajes",
    "upcoming": "Próximos",
    "past": "Anteriores",
    "all": "Todos",
    "no_trips": "Sin viajes",
    "no_trips_desc": "Cuando reservés un vehículo, tu viaje aparecerá aquí",
    "no_past_trips": "Sin viajes anteriores",
    "no_past_trips_desc": "Acá vas a ver los viajes que ya terminaron.",
    "cancel_trip": "Cancelar viaje",
    "view_details": "Ver detalles"
  },
  "cancellation": {
    "title": "Cancelación",
    "confirm_title": "Confirmar cancelación",
    "confirm_desc": "Esta acción no se puede deshacer",
    "reason_label": "Motivo de cancelación",
    "reason_placeholder": "Contanos por qué cancelás",
    "reason_plans_changed": "Cambio de planes",
    "reason_found_alternative": "Encontré otra opción",
    "reason_vehicle_issue": "Problema con el vehículo",
    "reason_personal": "Motivo personal",
    "reason_other": "Otro",
    "policy_title": "Política de cancelación",
    "policy_full": "Reembolso completo",
    "policy_full_desc": "100% del alquiler si cancelás más de 48h antes de la recogida",
    "policy_partial": "Reembolso parcial",
    "policy_partial_desc": "50% de reembolso entre 24h y 48h antes",
    "policy_none": "Sin reembolso",
    "policy_none_desc": "Sin reembolso dentro de las 24h antes",
    "refund_summary_title": "Resumen del reembolso",
    "refund_line": "Reembolso estimado",
    "refund_total": "Total a devolver",
    "refund_amount": "Monto del reembolso",
    "no_refund": "Sin reembolso",
    "cancellation_fee": "Tarifa de cancelación",
    "confirm_button": "Confirmar cancelación",
    "cancel_button": "Volver",
    "success_title": "Cancelación confirmada",
    "success_desc": "Tu reserva fue cancelada exitosamente",
    "refund_status_refunded": "Reserva cancelada. El reembolso fue procesado.",
    "refund_status_manual_required": "Reserva cancelada. El reembolso queda en revisión manual.",
    "refund_status_not_applicable": "Reserva cancelada. No aplica reembolso según la política.",
    "refund_status_processing": "Reserva cancelada. El reembolso ya se está procesando.",
    "refund_status_pending_reconciliation": "Reserva cancelada. Vamos a reconciliar el reembolso.",
    "error_not_cancellable": "Esta reserva no se puede cancelar",
    "error_failed": "No se pudo cancelar la reserva",
    "hours_before": "{{hours}}h antes de la recogida",
    "unavailable_title": "Esta reserva ya no está disponible",
    "unavailable_body": "Puede haber sido cancelada, expirada o movida. Revisá tus viajes activos.",
    "back_to_trips": "Volver a viajes"
  },
  "checkin": {
    "add_damage": "Reportar daño",
    "add_photo": "Agregar foto",
    "camera_permission_cta": "Activar cámara",
    "camera_permission_title": "Necesitamos cámara para capturar la inspección",
    "capture_failed": "No se pudo tomar la foto. Intentá de nuevo.",
    "capture_live_photo": "Capturar foto en vivo",
    "condition_excellent": "Excelente",
    "condition_fair": "Regular",
    "condition_good": "Buena",
    "condition_poor": "Mala",
    "confirm_checkin": "Confirmar check-in",
    "damage_area": "Área del daño",
    "damage_description": "Descripción del daño",
    "damages_title": "Daños existentes",
    "error_failed": "No se pudo completar el check-in",
    "error_incomplete_body": "Revisá los pasos marcados en la lista.",
    "error_incomplete_title": "Falta algo para poder enviar",
    "exterior_condition": "Condición exterior",
    "fuel_confirm_hint": "Movelo hasta donde marca la aguja del tablero.",
    "fuel_decrease": "Bajar el nivel de combustible",
    "fuel_increase": "Subir el nivel de combustible",
    "fuel_level": "Nivel de combustible",
    "interior_condition": "Condición interior",
    "license_checking_body": "Estamos confirmando que tu licencia esté aprobada antes de entregar el vehículo.",
    "license_checking_title": "Validando licencia",
    "license_refresh_cta": "Ya verifiqué mi licencia",
    "license_required_body": "Guardamos el check-in. Si tu licencia aún no está aprobada, queda en revisión antes de cerrar la entrega.",
    "license_required_cta": "Verificar licencia",
    "license_required_title": "Licencia pendiente",
    "license_subtitle": "Tomale una foto a la licencia ahora, junto al carro. No la verificamos de nuevo: queda como constancia de que la andaba encima antes de arrancar.",
    "license_required_for_checkin": "Obligatoria para confirmar la entrega.",
    "license_title": "Licencia del huésped",
    "min_photos_required": "Mínimo {{count}} fotos requeridas",
    "missing_required_photos": "Te faltan: {{areas}}",
    "notes": "Notas adicionales",
    "notes_placeholder": "Observaciones sobre el estado del vehículo",
    "odometer": "Kilometraje",
    "odometer_placeholder": "Km actuales del vehículo",
    "photo_back": "Atrás",
    "photo_damage": "Daño",
    "photo_dashboard": "Tablero",
    "photo_front": "Frente",
    "photo_front_left": "Frente izquierdo",
    "photo_front_right": "Frente derecho",
    "photo_front_seats": "Asientos delanteros",
    "photo_left": "Izquierda",
    "photo_license": "Licencia",
    "photo_odometer": "Odómetro",
    "photo_optional": "Opcional",
    "photo_rear_left": "Atrás izquierdo",
    "photo_rear_right": "Atrás derecho",
    "photo_rear_seats": "Asientos traseros",
    "photo_right": "Derecha",
    "photo_tires": "Llantas",
    "photo_trunk": "Baúl",
    "photo_windshield": "Parabrisas",
    "photos_failed_body": "No se subieron: {{areas}}. Volvé a tocar el botón — las que ya subieron no se repiten.",
    "photos_progress": "{{count}}/{{total}} fotos en vivo",
    "photos_subtitle": "Seis fotos en vivo: cuatro ángulos, interior y odómetro. El odómetro es obligatorio.",
    "photos_title": "Fotos del vehículo",
    "readiness_title": "Estado de inspección",
    "ready_title": "Inspección lista",
    "retake_photo": "Retomar",
    "subtitle": "Inspección del vehículo al recoger",
    "success_desc": "El viaje ha comenzado. ¡Buen camino!",
    "success_title": "Check-in completado",
    "title": "Check-in",
    "uploading_photos": "Subiendo fotos"
  },
  "inspection_assurance": {
    "title": "Revisión de aseguradora",
    "status_pending_submission": "Pendiente de envío a aseguradora",
    "status_submitted": "Recibida por aseguradora",
    "status_under_review": "En revisión",
    "status_accepted": "Aceptada",
    "status_rejected": "Rechazada",
    "status_needs_action": "Requiere acción",
    "status_expired": "SLA vencido",
    "status_failed": "Error de envío",
    "review_overdue": "Vencido",
    "due_in_hours": "En {{count}} h"
  },
  "trip_checkout": {
    "title": "Check-out",
    "subtitle": "Inspección de devolución del vehículo",
    "comparison_title": "Comparación con check-in",
    "checkin_loading_title": "Cargando check-in base",
    "checkin_loading_body": "Estamos trayendo la inspección de entrega para comparar la devolución.",
    "checkin_missing_title": "Falta el check-in base",
    "checkin_missing_body": "No encontramos la inspección de entrega. Revisá conexión o abrí el viaje antes de completar el check-out.",
    "checkin_value": "Al recoger",
    "checkout_value": "Al devolver",
    "fuel_difference": "Diferencia de combustible",
    "km_driven": "Kilómetros recorridos",
    "new_damage_found": "Nuevo daño encontrado",
    "no_new_damage": "Sin daños nuevos",
    "confirm_checkout": "Confirmar check-out",
    "success_title": "Check-out completado",
    "success_desc": "El viaje fue completado exitosamente",
    "error_failed": "No se pudo completar el check-out",
    "ready_title": "Check-out listo",
    "odometer_below_checkin": "El kilometraje debe ser igual o mayor a {{km}} km.",
    "km_allowance": "Incluye {{km}} km para este viaje.",
    "extra_km_charge": "Cargo por km extra",
    "fuel_charge": "Cargo por combustible",
    "late_return": "Devolución tardía",
    "late_fee": "Cargo por devolución tardía",
    "late_notice_title": "Devolución con retraso",
    "late_notice_body": "Se agregan {{amount}} al viaje por devolver {{late}} tarde.",
    "late_grace_title": "Vas dentro del tiempo de cortesía",
    "late_grace_body": "Hasta las {{time}} no hay recargo. Después se agregan {{amount}}.",
    "late_due_title": "El viaje vence a las {{time}}",
    "late_due_body": "Devolver con más de {{grace}} de retraso agrega {{amount}}."
  },
  "reviews": {
    "title": "Calificá tu viaje",
    "review_trip_cta": "Calificar viaje",
    "trip_prompt": "¿Cómo estuvo el viaje?",
    "trip_context_guest": "{{vehicle}} · con {{name}}",
    "trip_context_host": "{{name}} · viajó en {{vehicle}}",
    "subtitle": "Una sola calificación para toda la experiencia",
    "overall_rating": "Tu experiencia",
    "tap_to_rate": "Tocá para calificar",
    "add_comment": "Agregar un comentario",
    "hide_comment": "Ocultar comentario",
    "comment_label": "Comentario (opcional)",
    "comment_placeholder": "¿Hay algo más que querás contar?",
    "char_count": "{{count}}/{{max}}",
    "submit": "Enviar",
    "submitting": "Enviando...",
    "success_title": "¡Reseña enviada!",
    "success_desc": "Gracias por compartir tu experiencia",
    "error_failed": "No se pudo enviar la reseña",
    "error_not_eligible": "Este viaje ya no está disponible para reseña",
    "error_already_reviewed": "Ya dejaste una reseña para este viaje",
    "error_window_closed": "El período para dejar reseñas ha expirado",
    "error_wrong_role": "Solo quienes hicieron este viaje pueden calificarlo.",
    "rating_1": "Muy mala",
    "rating_2": "Mala",
    "rating_3": "Regular",
    "rating_4": "Buena",
    "rating_5": "Excelente",
    "no_reviews": "Aún sin reseñas",
    "no_reviews_desc": "Las reseñas aparecerán aquí después de completar viajes",
    "review_count": "{{count}} reseña(s)",
    "avg_rating": "Calificación promedio",
    "rating_only": "Solo dejó una calificación.",
    "reviewer_fallback": "Miembro de Tago",
    "unavailable_title": "Esta reseña ya no está disponible",
    "unavailable_body": "El viaje puede haber cambiado de estado o ya no estar disponible para reseña.",
    "back_to_trips": "Volver a viajes"
  },
  "verification": {
    "almost_there_one": "Te falta 1 paso para reservar",
    "almost_there_other": "Te faltan {{count}} pasos para reservar",
    "one_time_only": "Se hace una sola vez. Después reservás en dos toques.",
    "blocker_identity_review_pending_title": "Estamos revisando tus documentos",
    "blocker_identity_review_pending_desc": "Ya subiste todo. Te avisamos apenas quede listo, normalmente en minutos.",
    "blocker_account_deletion_requested_title": "Tu cuenta está en proceso de borrado",
    "blocker_account_deletion_requested_desc": "Mientras tanto no se pueden hacer reservas nuevas. Escribinos a team@tago.rent si querés cancelarlo.",
    "cta_verify_to_book": "Verificarme para reservar",
    "title": "Verificación de identidad",
    "subtitle": "Verificá tu identidad para mayor seguridad",
    "steps_title": "Pasos de verificación",
    "status_pending": "Pendiente",
    "status_submitted": "En revisión",
    "status_retry": "En revisión",
    "status_approved": "Aprobado",
    "status_rejected": "Rechazado",
    "status_expired": "Expirado",
    "celebration_title": "¡Estás verificado!",
    "celebration_subtitle": "Tu identidad quedó confirmada. Para reservar o publicar completá el cumplimiento.",
    "identity_title": "Documento de identidad",
    "identity_subtitle": "Validá tu documento de identidad o pasaporte",
    "identity_manual_title": "Ingresá los datos a mano",
    "identity_manual_subtitle": "Completá los campos vos mismo si la lectura automática no detecta bien tu documento",
    "document_type": "Tipo de documento",
    "document_type_dui": "DUI",
    "document_type_passport": "Pasaporte",
    "issuing_country": "País del documento",
    "issuing_region": "Provincia o estado",
    "issuing_region_placeholder": "Ontario, California…",
    "document_type_national_id": "Documento de identidad",
    "document_type_curp": "CURP",
    "document_type_cedula": "Cédula",
    "document_type_driver_license": "Licencia de conducir",
    "document_number": "Número de documento",
    "document_number_placeholder": "Ej: 12345678-9",
    "first_name": "Nombres",
    "last_name": "Apellidos",
    "date_of_birth": "Fecha de nacimiento",
    "issue_date": "Fecha de emisión",
    "expiry_date": "Fecha de vencimiento",
    "front_photo": "Foto frontal",
    "back_photo": "Foto trasera",
    "take_photo": "Tomar foto",
    "scan_document": "Escanear documento",
    "retake_photo": "Volver a tomar",
    "photo_guidelines": "Guía para la foto",
    "photo_guideline_1": "Colocá el documento sobre una superficie plana",
    "photo_guideline_2": "Asegurate de que todo el texto sea legible",
    "photo_guideline_3": "Evitá reflejos o sombras",
    "license_title": "Licencia de conducir",
    "license_subtitle": "Subí fotos de tu licencia personal vigente — no la tarjeta de circulación del carro.",
    "license_not_tarjeta_hint": "No subas la tarjeta de circulación ni el DUI. Es la licencia plástica con tu foto y clase (liviana, pesada, etc.).",
    "license_retry_subtitle": "Recibimos tu licencia y queda en revisión.",
    "license_approved_title": "Licencia verificada",
    "license_approved_body": "Tu licencia de conducir ya está aprobada. No necesitás volver a subir fotos.",
    "license_approved_cta": "Volver a verificación",
    "license_manual_title": "Ingresá los datos a mano",
    "license_manual_subtitle": "Completá los campos vos mismo si la lectura automática no detecta bien tu licencia",
    "locked_by_identity": "Verificá primero tu identidad",
    "selfie_locked_helper": "Aprobá tu documento de identidad o pasaporte para habilitar este paso.",
    "license_locked_helper": "Aprobá tu documento de identidad o pasaporte para habilitar este paso.",
    "gate_required_toast": "Un paso más para continuar",
    "gate_required_checklist": "Completá lo que falte: contacto, identidad, licencia y selfie. Solo una vez — no te pedimos lo que ya tenés.",
    "license_number": "Número de licencia",
    "license_class": "Clase de licencia",
    "confirm_license_class": "Confirmá la clase de tu licencia",
    "license_class_liviana": "Liviana",
    "license_class_pesada": "Pesada",
    "license_class_motocicleta": "Motocicleta",
    "license_class_especial": "Especial",
    "sertracen_title": "Consulta oficial en Sertracen",
    "sertracen_desc": "Usamos tu DUI verificado y el prefijo + número de control de tu licencia. TAGO consulta Sertracen de forma segura y solo aprueba licencias válidas y vigentes.",
    "sertracen_prefix": "Prefijo",
    "sertracen_control": "Número de control",
    "sertracen_control_number": "Dígitos de control",
    "sertracen_control_number_placeholder": "Ej: 003354569",
    "sertracen_open": "Abrir Sertracen",
    "sertracen_missing_fields": "Ingresá el prefijo y número de control de tu licencia.",
    "sertracen_license_pending": "Confirmá primero el número leído por OCR",
    "sertracen_identity_pending": "Primero confirmá tu documento de identidad para validar la licencia.",
    "sertracen_unavailable": "Recibimos tu licencia. Si no podemos confirmarla al instante, queda en revisión.",
    "front_image": "Imagen frontal",
    "back_image": "Imagen trasera",
    "selfie_title": "Selfie de verificación",
    "selfie_subtitle": "Tomá una selfie para verificar tu identidad",
    "selfie_blocked_title": "Verificá primero tu identidad",
    "selfie_blocked_body": "Necesitamos aprobar tu documento de identidad o pasaporte antes del paso del selfie. Se hace en menos de 2 minutos.",
    "go_to_identity": "Ir a verificar identidad",
    "selfie_instructions": "Sostené el teléfono a la altura de los ojos",
    "selfie_take": "Tomar selfie",
    "submit": "Enviar verificación",
    "submitting": "Enviando...",
    "success_title": "¡Verificación enviada!",
    "success_desc": "Revisaremos tu información en 24-48 horas",
    "error_failed": "No se pudo enviar la verificación",
    "verifik_unavailable": "La validación no respondió. Intentá de nuevo con buena conexión.",
    "verifik_read_failed": "No pudimos leer el documento. Volvé a tomar la foto con buena luz, sin reflejos y con todo el documento dentro del marco.",
    "verifik_not_found": "No encontramos ese {{document}} con esa fecha de nacimiento. Revisá los datos y volvé a intentar.",
    "verifik_name_mismatch": "Los nombres no coinciden con los datos del documento. Revisá los datos y volvé a intentar.",
    "verifik_timeout_lookup": "La validación tardó más de lo esperado. Volvé a intentar en unos segundos.",
    "verifik_timeout_reading": "Verifik tardó demasiado en leer el documento. Volvé a intentar con una foto clara.",
    "verifik_retry_required": "La validación no terminó. Volvé a intentar.",
    "identity_processing_notice": "La consulta sigue procesándose. Volvé a intentar en unos minutos.",
    "identity_in_review_notice": "Recibimos el documento. Queda en revisión.",
    "timeout_saved_notice": "La validación tardó más de lo esperado y no pudimos terminarla. Tus fotos quedaron guardadas — no hace falta tomarlas de nuevo.",
    "resume_title": "Tu verificación quedó a medias",
    "resume_desc": "Tus fotos quedaron guardadas. Podés continuar con ellas o volver a tomarlas.",
    "resume_continue": "Continuar con mis fotos",
    "resume_recapture": "Tomar fotos nuevas",
    "license_in_review_notice": "Recibimos la licencia. Queda en revisión.",
    "selfie_in_review_notice": "Recibimos la verificación. Queda en revisión.",
    "error_scan_empty": "No pudimos leer el documento. Volvé a tomar la foto con buena luz, sin reflejos y con todo el documento dentro del marco.",
    "rejection_reason": "Motivo de rechazo",
    "web_liveness": {
      "requesting": "Pidiendo permiso de cámara…",
      "helper": "Mirá a la cámara, posicioná tu cara dentro del óvalo y tocá Capturar. La foto se toma en vivo — no podés subir un archivo.",
      "capture": "Capturar",
      "restart": "Reiniciar",
      "retry": "Reintentar",
      "permission_denied_title": "Permiso de cámara denegado",
      "permission_denied_body": "Para verificar tu identidad necesitamos acceso a la cámara. Habilitá el permiso en la configuración del navegador o continuá desde el celular.",
      "no_camera_title": "No detectamos cámara",
      "no_camera_body": "Tu navegador o dispositivo no expone una cámara compatible. Probá desde el celular para completar la verificación.",
      "error_title": "No pudimos abrir la cámara",
      "error_body": "Ocurrió un problema iniciando la cámara. Intentá de nuevo."
    },
    "camera_permission_blocked": "El permiso de cámara está bloqueado para Tago. Habilitalo en los ajustes del teléfono y volvé a intentar.",
    "open_settings": "Abrir Ajustes",
    "photo_first_intro": "Tomá fotos de tu documento y nosotros extraemos los datos.",
    "photo_first_intro_web": "Subí fotos de tu documento y nosotros extraemos los datos.",
    "dui_lookup_intro": "Tomá fotos del frente y reverso de tu {{document}}. Luego confirmamos los datos oficialmente.",
    "dui_lookup_intro_web": "Agregá fotos del frente y reverso de tu {{document}}. Luego confirmamos los datos oficialmente.",
    "tap_to_start": "Tomar foto del frente",
    "tap_to_capture_back": "Tomar foto del reverso",
    "upload_front": "Subir foto del frente",
    "upload_back": "Subir foto del reverso",
    "upload_instruction_front": "Subí una foto clara del frente de tu documento",
    "upload_instruction_back": "Ahora subí el reverso",
    "license_upload_intro": "Subí fotos de tu licencia y nosotros extraemos los datos.",
    "license_upload_instruction_front": "Subí una foto clara del frente de tu licencia",
    "license_upload_instruction_back": "Ahora subí el reverso",
    "front_captured": "Frente listo",
    "back_captured": "Reverso listo",
    "uploading": "Subiendo fotos...",
    "verifying": "Validando tu {{document}}...",
    "verifying_didit": "Verificando tu documento...",
    "verifying_generic": "Verificando...",
    "dui_lookup_title": "Validá tu {{document}}",
    "dui_lookup_subtitle": "Frente, reverso y validación oficial en un solo paso seguro.",
    "dui_lookup_evidence_title": "Fotos del {{document}}",
    "dui_lookup_evidence_subtitle": "Guardamos frente y reverso como respaldo para verificación, cobertura y reclamos cuando aplique.",
    "dui_lookup_front_title": "Frente del {{document}}",
    "dui_lookup_back_title": "Reverso del {{document}}",
    "dui_lookup_front_helper": "Datos y foto completos, sin recortes.",
    "dui_lookup_back_helper": "Reverso completo y legible.",
    "dui_lookup_take_front": "Tomar frente",
    "dui_lookup_take_back": "Tomar reverso",
    "dui_lookup_upload_front": "Agregar frente",
    "dui_lookup_upload_back": "Agregar reverso",
    "dui_lookup_retake_front": "Cambiar frente",
    "dui_lookup_retake_back": "Cambiar reverso",
    "dui_lookup_photos_required": "Tomá foto del frente y reverso de tu {{document}} para continuar.",
    "dui_lookup_missing_title": "Falta para continuar",
    "dui_lookup_missing_front": "La foto del frente del {{document}}",
    "dui_lookup_missing_back": "La foto del reverso del {{document}}",
    "dui_lookup_missing_number": "El número de {{document}} completo",
    "dui_lookup_missing_dob": "Tu fecha de nacimiento",
    "dui_number_label": "Número de {{document}}",
    "dui_lookup_dui_placeholder": "00000000-0",
    "dui_lookup_dob_placeholder": "AAAA-MM-DD",
    "dui_lookup_dob_error": "Usá formato AAAA-MM-DD y una edad entre 18 y 100 años.",
    "dui_lookup_cta": "Validar {{document}}",
    "dui_lookup_verifying": "Validando {{document}}...",
    "dui_lookup_checking": "Validando datos...",
    "dui_lookup_confirming": "Confirmando identidad...",
    "dui_lookup_secure_note": "Esto suele tardar unos segundos. Tus datos viajan cifrados.",
    "dui_lookup_approved_title": "{{document}} validado",
    "dui_lookup_approved_desc": "Tu {{document}} fue validado correctamente.",
    "uploading_securely": "Subiendo fotos de forma segura...",
    "verifik_reading_dui": "Leyendo ambos lados del documento...",
    "verifik_checking_government": "Confirmando identidad...",
    "verifik_almost_done": "Seguimos validando. Ya casi terminamos...",
    "verifik_longer_than_usual": "Está tardando más de lo normal, pero seguimos esperando la respuesta segura.",
    "review_fields": "Revisá los datos y confirmá",
    "review_required_fields": "Completá nombres, apellidos, fecha de nacimiento y número de documento antes de confirmar.",
    "confirm_looks_good": "Se ve bien",
    "retake_front": "Retomar frente",
    "retake_back": "Retomar reverso",
    "retake_both": "Retomar todo",
    "result_approved_title": "¡Listo! Ya estás verificado",
    "result_approved_desc": "Tu identidad fue confirmada exitosamente",
    "result_review_title": "Revisá los datos",
    "result_review_desc": "Confirmá o corregí los campos que extrajimos",
    "result_declined_title": "No pudimos verificar este documento",
    "result_declined_desc": "Revisá el número o intentá con otro documento",
    "license_manual_review_title": "Licencia recibida",
    "license_manual_review_body": "Queda en revisión y te avisamos cuando esté aprobada.",
    "license_save_failed": "No pudimos guardar tu licencia. Revisá tu conexión e intentá de nuevo.",
    "try_again": "Intentar de nuevo",
    "use_manual_entry": "Prefiero escribir los datos",
    "extracted_fields_title": "Datos extraídos",
    "field_firstName": "Nombres",
    "field_lastName": "Apellidos",
    "field_dateOfBirth": "Fecha de nacimiento",
    "field_documentNumber": "Número de documento",
    "field_issueDate": "Fecha de emisión",
    "field_expiryDate": "Fecha de vencimiento",
    "field_firstName_placeholder": "Tus nombres",
    "field_lastName_placeholder": "Tus apellidos",
    "field_dateOfBirth_placeholder": "YYYY-MM-DD",
    "field_documentNumber_placeholder": "12345678-9",
    "field_issueDate_placeholder": "YYYY-MM-DD",
    "field_expiryDate_placeholder": "YYYY-MM-DD",
    "instruction_front": "Colocá el frente de tu documento en el recuadro",
    "instruction_back": "Ahora el reverso",
    "license_photo_first_intro": "Tomá fotos de tu licencia de conducir (con tu foto). No uses la tarjeta de circulación del vehículo.",
    "license_instruction_front": "Colocá el frente de tu licencia personal en el recuadro",
    "license_instruction_back": "Ahora el reverso de la misma licencia",
    "selfie_photo_first_intro": "Tomate una selfie para confirmar que sos vos.",
    "selfie_instruction": "Mirá la cámara con buena luz",
    "selfie_native_hint": "Usá buena luz, quitá lentes oscuros y mantené el rostro dentro del encuadre.",
    "selfie_preparing": "Preparando verificación...",
    "selfie_tap_to_start": "Tomar selfie",
    "selfie_verifying": "Verificando que sos vos...",
    "selfie_verifying_helper": "Mantené la app abierta. Esto suele tomar unos segundos.",
    "selfie_progress_uploading": "Subiendo selfie segura...",
    "selfie_progress_liveness": "Validando prueba de vida...",
    "selfie_progress_face_match": "Comparando con tu documento...",
    "selfie_progress_finishing": "Guardando resultado...",
    "selfie_live_title": "Verificación biométrica en vivo",
    "selfie_live_body": "Validá tu rostro con una prueba de vida segura dentro de Tago.",
    "selfie_live_secure_title": "Sesión protegida",
    "selfie_live_secure_body": "Tu verificación se procesa en una sesión protegida, sin salir de Tago.",
    "selfie_live_start": "Iniciar verificación",
    "selfie_web_title": "Continuá en el proveedor seguro",
    "selfie_web_body": "En computadora, la verificación biométrica se abre en una ventana segura del proveedor para evitar bloqueos de cámara. Cuando terminés, regresá a Tago y revisá el resultado.",
    "selfie_web_open": "Abrir verificación",
    "selfie_web_check": "Revisar resultado",
    "selfie_live_progress_starting": "Creando sesión segura...",
    "selfie_live_progress_provider": "Abriendo verificación en vivo...",
    "selfie_live_progress_security": "Validando prueba de vida...",
    "selfie_live_progress_saving": "Confirmando resultado...",
    "selfie_live_approved_body": "Tu prueba de vida fue aprobada y guardada de forma segura.",
    "selfie_session_failed": "No pudimos completar la verificación biométrica. Volvé a intentar.",
    "selfie_still_processing": "La verificación sigue procesándose. Volvé a intentar en unos segundos.",
    "selfie_capture_failed": "No se pudo abrir la cámara. Volvé a intentar.",
    "selfie_camera_permission_denied": "Necesitamos permiso de cámara para verificar tu selfie.",
    "selfie_upload_failed": "No se pudo subir la selfie. Revisá tu conexión y volvé a intentar.",
    "selfie_liveness_failed": "No pudimos confirmar que sos una persona real",
    "selfie_match_failed": "La cara no coincide con tu documento",
    "selfie_result_approved": "¡Listo! Tu selfie fue verificada",
    "identity_required_for_selfie": "Guardamos la selfie; queda en revisión junto con tu identidad.",
    "liveness_label": "Prueba de vida",
    "face_match_label": "Coincidencia facial",
    "gate_redirecting": "Te estamos llevando al paso que falta…",
    "email_subtitle": "Para recibos y para recuperar tu acceso.",
    "phone_subtitle": "Hace falta para reservar: es cómo te ubica el anfitrión.",
    "scanner_unavailable": "No pudimos abrir el escáner de documentos en este teléfono. Probá de nuevo; si vuelve a fallar, escribinos y lo resolvemos con vos.",
    "selfie_rate_limited": "Hiciste varios intentos seguidos. Esperá unos 10 minutos y volvé a intentar — tu progreso no se pierde.",
    "rate_limited": "Hiciste demasiadas verificaciones en poco tiempo. Esperá un momento y volvé a intentar.",
    "document_type_dni": "DNI",
    "document_type_dpi": "DPI",
    "verifik_not_found_generic": "No encontramos ese documento con esa fecha de nacimiento. Revisá los datos y volvé a intentar.",
    "dui_lookup_photos_required_generic": "Tomá foto del frente y reverso de tu documento para continuar.",
    "blocked_toast_phone": "Confirmá tu teléfono para reservar. Toma menos de un minuto.",
    "blocked_toast_steps": "Te faltan unos pasos para poder reservar. Te llevamos.",
    "go_do_step": "Hacer ahora: {{step}}"
  },
  "payouts": {
    "onboarding_title": "Cuenta para pagos",
    "onboarding_subtitle": "Guardala una vez y usala para recibir tus ganancias.",
    "onboarding_intro": "Necesitamos tu cuenta bancaria para enviarte las ganancias. Nunca guardamos el número completo — solo los últimos 4 dígitos.",
    "secure_title": "Datos protegidos",
    "bank": "Banco",
    "bank_placeholder": "Seleccioná tu banco",
    "account_type": "Tipo de cuenta",
    "account_savings": "Ahorro",
    "account_checking": "Corriente",
    "account_number": "Número de cuenta",
    "account_number_placeholder": "Ej: 12345678901",
    "holder_name": "Nombre del titular",
    "holder_name_placeholder": "Como aparece en el banco",
    "holder_name_org_placeholder": "Razón social exacta",
    "document_number": "DUI o NIT",
    "document_number_placeholder": "12345678-9",
    "document_helper_dui": "Usá el DUI de la persona titular de la cuenta.",
    "document_helper_org": "La cuenta corporativa debe estar a nombre de la razón social.",
    "review_hint": "Revisá que banco, titular y número coincidan antes de guardar.",
    "review_hint_selected": "Vamos a registrar esta cuenta en {{bank}} y guardar solo el número enmascarado.",
    "onboarding_submit": "Guardar cuenta",
    "onboarding_success": "Cuenta guardada. Te avisaremos cuando esté verificada.",
    "onboarding_failed": "No se pudo guardar la cuenta",
    "title": "Pagos",
    "manage_accounts": "Gestionar cuentas de pago",
    "manage_accounts_desc": "Añadí, editá o cambiá tu cuenta bancaria",
    "accounts_section": "Tus cuentas",
    "history_section": "Historial",
    "no_accounts": "No tenés cuentas aún",
    "no_accounts_desc": "Añadí una cuenta bancaria para recibir tus ganancias",
    "no_history": "Todavía no hay pagos",
    "setup_title": "Configurá cómo cobrás",
    "how_it_works": "Cómo funciona",
    "step_account": "Añadís tu cuenta bancaria",
    "step_account_desc": "Guardamos solo los últimos 4 dígitos.",
    "step_trip": "Completás un viaje",
    "step_trip_desc": "Ahí empezás a generar ganancias.",
    "step_deposit": "Te depositamos las ganancias",
    "step_deposit_desc": "Te las enviamos dentro de las 48 horas después del viaje. Cada pago queda en este historial.",
    "add_account": "Añadir cuenta",
    "set_default": "Usar por defecto",
    "default_label": "Predeterminada",
    "default_set": "Cuenta predeterminada actualizada",
    "unknown_bank": "Banco",
    "status_pending": "Pendiente",
    "status_processing": "Procesando",
    "status_completed": "Completado",
    "status_failed": "Fallido",
    "status_reversed": "Revertido",
    "identity_required_title": "Primero verificá tu identidad",
    "identity_required_body": "Antes de decirnos a dónde enviarte tu dinero necesitamos saber quién sos. Es una sola vez y toma un par de minutos.",
    "identity_required_action": "Verificar identidad",
    "identity_source": "De tu DUI verificado"
  },
  "org_payouts": {
    "title": "Pagos de la empresa",
    "subtitle": "Ganancias y cuentas bancarias de {{name}}.",
    "onboarding_title": "Cuenta bancaria",
    "onboarding_subtitle": "Conectá la cuenta de la empresa para recibir pagos sin fricción.",
    "onboarding_intro": "La cuenta debe estar a nombre de la razón social. Guardamos solo los últimos 4 dígitos.",
    "mtd": "Mes actual",
    "ytd": "Año actual",
    "lifetime": "Total histórico",
    "rentals": "alquileres",
    "pending": "Pendiente",
    "primary_account": "Cuenta corporativa",
    "configure_cta": "Configurar cuenta bancaria",
    "configure_hint": "Agregá una cuenta a nombre de la empresa para liberar pagos automáticos.",
    "other_accounts": "Otras cuentas",
    "set_default": "Usar como principal",
    "add_account": "Añadir otra cuenta",
    "history": "Historial de pagos",
    "history_empty": "Los pagos de la empresa aparecerán aquí.",
    "col_date": "Fecha",
    "col_amount": "Monto",
    "col_status": "Estado",
    "footnote": "Los pagos se envían a la cuenta principal verificada de {{name}}.",
    "edit_account": "Editar datos bancarios",
    "status_completed": "Completado",
    "status_processing": "Procesando",
    "status_failed": "Fallido",
    "status_reversed": "Revertido",
    "status_pending": "Pendiente",
    "cta_subtitle": "Revisá cuentas, historial y pagos pendientes."
  },
  "compliance": {
    "delete_title": "Eliminar cuenta",
    "delete_warning_title": "Esta acción es permanente",
    "delete_warning_desc": "Vamos a eliminar tu cuenta después de 30 días. Ese período de gracia es una decisión nuestra para que podás arrepentirte, no el plazo legal para responder solicitudes de datos. Tus datos personales se borran o se anonimizan; los registros que la ley nos obliga a resguardar (facturación y registros de la relación comercial, 10 años) quedan bloqueados para autoridades en lugar de eliminarse.",
    "delete_reason_label": "Motivo (opcional)",
    "delete_reason_placeholder": "Contanos por qué te vas",
    "delete_request": "Solicitar eliminación",
    "delete_confirm_title": "¿Seguro?",
    "delete_confirm_desc": "Empezamos el período de gracia de 30 días. Podés cancelar cuando querás durante ese tiempo.",
    "delete_confirm_yes": "Sí, eliminar",
    "delete_success": "Solicitud enviada",
    "delete_failed": "No se pudo enviar la solicitud",
    "delete_pending_title": "Eliminación programada",
    "delete_pending_desc": "Tu cuenta se eliminará el {{date}}. Podés cancelar hasta entonces.",
    "delete_cancel": "Cancelar eliminación",
    "cancel_success": "Eliminación cancelada",
    "cancel_failed": "No se pudo cancelar",
    "delete_status_error": "No pudimos leer el estado de tu cuenta, así que no sabemos si ya hay una solicitud en curso. Probá de nuevo antes de enviar una."
  },
  "notifications": {
    "title": "Notificaciones",
    "empty_title": "No tenés notificaciones",
    "empty_desc": "Acá aparecen las novedades de tus reservas, mensajes y más.",
    "mark_all_read": "Marcar todo como leído",
    "mark_all_short": "Marcar todo"
  },
  "notification_prefs": {
    "title": "Notificaciones",
    "section_general": "General",
    "push_enabled": "Notificaciones push",
    "section_trips": "Viajes",
    "booking_updates": "Actualizaciones de reserva",
    "trip_reminders": "Recordatorios de viaje",
    "section_messages": "Mensajes",
    "new_messages": "Nuevos mensajes",
    "section_hosting": "Anfitrión",
    "host_bookings": "Nuevas reservas",
    "host_cancellations": "Cancelaciones",
    "host_payouts": "Pagos",
    "section_promotions": "Promociones",
    "promotions": "Ofertas y descuentos",
    "section_delivery": "Método de entrega",
    "email_enabled": "Correo electrónico",
    "sms_enabled": "SMS",
    "push_off_notice": "Con las notificaciones push apagadas, el resto de los avisos push queda en pausa. Encendelas para elegir cuáles querés recibir.",
    "update_failed": "No se pudo actualizar la preferencia"
  },
  "disputes": {
    "file_title": "Reportar problema",
    "file_intro": "Contanos qué pasó. Tu anfitrión tiene 72 horas para responder con su versión y evidencia. Si no se ponen de acuerdo, Tago revisa el caso.",
    "detail_title": "Detalle de la disputa",
    "respond_title": "Responder a la disputa",
    "respond_claim_summary": "Reclamo del huésped",
    "claim_section": "Reclamo",
    "response_section": "Respuesta",
    "resolution_section": "Resolución",
    "category_label": "Categoría",
    "category_vehicle_damage": "Daño al vehículo",
    "category_excessive_mileage": "Exceso de kilómetros",
    "category_fuel_level": "Nivel de combustible",
    "category_cleanliness": "Limpieza",
    "category_late_return": "Devolución tardía",
    "category_missing_items": "Artículos faltantes",
    "category_billing": "Cobro",
    "category_other": "Otro",
    "description_label": "Descripción",
    "description_placeholder": "Explicá lo que pasó con suficiente detalle para que la otra parte y, si fuera necesario, Tago, puedan entender.",
    "amount_label": "Monto reclamado (USD)",
    "amount_placeholder": "0.00",
    "amount_claimed": "Monto reclamado:",
    "amount_resolved": "Monto resuelto:",
    "evidence_label": "Evidencia (fotos)",
    "evidence_hint": "{{count}} de {{max}} fotos.",
    "evidence_source_camera_short": "CÁM",
    "evidence_source_library_short": "GAL",
    "add_photo_camera": "Tomar foto",
    "add_photo_library": "Elegir de la galería",
    "remove_photo": "Quitar foto",
    "submit": "Enviar disputa",
    "ready_to_submit": "Listo para enviar.",
    "filed_success": "Disputa enviada. Te avisamos cuando la otra parte responda.",
    "file_failed": "No se pudo enviar la disputa. Intentá de nuevo.",
    "no_response_yet": "Aún sin respuesta de la otra parte.",
    "respond_cta": "Responder",
    "response_label": "Tu respuesta",
    "response_placeholder": "Contanos tu versión de los hechos. Mínimo 10 caracteres.",
    "response_evidence_label": "Evidencia (fotos)",
    "respond_submit": "Enviar respuesta",
    "responded_success": "Respuesta enviada. Tago revisará el caso.",
    "respond_failed": "No se pudo enviar la respuesta. Intentá de nuevo.",
    "deadline_remaining": "Quedan",
    "deadline_expired": "Plazo vencido",
    "deadline_expired_explainer": "El plazo de 72 horas para responder ya pasó. Tago revisará la disputa con la evidencia disponible.",
    "report_damage_cta": "Reportar problema con este viaje",
    "report_damage_subtitle": "Daños, limpieza, kilometraje, combustible u otro.",
    "view_existing_cta": "Ver disputa abierta",
    "status_open": "Abierta",
    "status_awaiting_response": "Esperando respuesta",
    "status_under_review": "En revisión",
    "status_resolved_claimant": "Resuelta a tu favor",
    "status_resolved_respondent": "Resuelta a favor del otro",
    "status_resolved_split": "Resuelta dividida",
    "status_withdrawn": "Retirada"
  },
  "error_boundary": {
    "title": "Algo salió mal",
    "description": "Ocurrió un error inesperado. Intentá de nuevo.",
    "action": "Reintentar"
  },
  "ui": {
    "search_placeholder": "Buscar...",
    "search_cancel": "Cancelar",
    "select_placeholder": "Seleccionar...",
    "select_search": "Buscar...",
    "select_no_results": "Sin resultados",
    "select_date": "Elegí fecha",
    "select_month": "Elegí mes",
    "select_time": "Elegí hora",
    "time_period_am": "a. m.",
    "time_period_pm": "p. m.",
    "rate_star": "Calificar {{count}} estrellas"
  },
  "settings": {
    "biometric_title": "Desbloqueo biométrico",
    "biometric_desc": "Usá huella o Face ID para entrar a la app",
    "biometric_toggle_failed": "No se pudo cambiar el desbloqueo biométrico",
    "appearance": {
      "title": "Apariencia",
      "light": "Claro",
      "dark": "Oscuro",
      "subtitle": "Tago inicia en modo claro. Si cambiás la apariencia, tu elección se guarda automáticamente en este dispositivo.",
      "light_desc": "Interfaz clara para uso de día.",
      "dark_desc": "Menos brillo para la noche.",
      "selected": "Seleccionado",
      "preview_card_heading": "Vista previa",
      "preview_title": "Toyota Corolla 2022",
      "preview_meta": "San Salvador · Disponible hoy",
      "preview_price": "$35/día"
    },
    "safety_section": "Privacidad",
    "blocked_users": "Usuarios bloqueados"
  },
  "block": {
    "action": "Bloquear",
    "unblock_action": "Desbloquear",
    "confirm_title": "¿Bloquear a {{name}}?",
    "confirm_body": "Ya no vas a ver sus vehículos ni recibir mensajes de esta persona. Podés desbloquearlo en Configuración → Usuarios bloqueados.",
    "unblock_confirm_title": "¿Desbloquear a {{name}}?",
    "unblock_confirm_body": "Vas a volver a ver sus vehículos y esta persona va a poder escribirte. Podés bloquearla de nuevo cuando querás.",
    "reason_label": "¿Por qué? (opcional)",
    "success_toast": "Usuario bloqueado",
    "unblock_success_toast": "Usuario desbloqueado",
    "empty_state": "No tenés a nadie bloqueado.",
    "list_intro": "Estos usuarios no pueden contactarte ni aparecen en tu búsqueda.",
    "error_generic": "No se pudo completar la acción",
    "error_booking": "No podés reservar este vehículo."
  },
  "hosting": {
    "title": "Anfitrión",
    "my_listings": "Mis vehículos",
    "edit_vehicle": "Editar vehículo",
    "edit_overview": "Elegí qué querés cambiar",
    "edit_hint": "Tocá Guardar para aplicar tus cambios.",
    "review_changes": "Revisar cambios",
    "edit_exit_title": "¿Continuar después?",
    "edit_exit_body": "Conservamos tu borrador en este dispositivo. Los cambios todavía no se aplicaron al anuncio.",
    "edit_exit_later": "Continuar después",
    "add_vehicle": "Agregar vehículo",
    "no_listings": "Aún no tenés vehículos publicados",
    "no_listings_desc": "Publica tu primer vehículo y comienza a ganar",
    "empty_launch_title": "Publicá tu primer vehículo",
    "empty_launch_desc": "Fotos, documentos y precio en un flujo simple.",
    "empty_step_photos": "Fotos reales",
    "empty_step_docs": "Tarjeta",
    "empty_step_price": "Precio",
    "delete_vehicle_title": "¿Eliminar vehículo?",
    "vehicle_deleted": "Vehículo eliminado",
    "earnings": "Ganancias",
    "calendar": "Calendario",
    "status_draft": "Borrador",
    "status_pending": "En revisión",
    "status_pending_review": "Pendiente de publicar",
    "status_active": "Activo",
    "status_paused": "Pausado",
    "publish_vehicle": "Publicar",
    "pause_vehicle": "Pausar",
    "continue_listing": "Continuar",
    "publish_blocked_draft": "Completá el anuncio y enviá a revisión para publicarlo.",
    "publish_blocked_pending_review": "Este anuncio no se publica hasta que completés lo que falta.",
    "listing_needs_title": "Para que se vea y se pueda reservar, falta:",
    "blocker_identity": "tu DUI y tu selfie en vivo",
    "blocker_tarjeta_front": "el frente vigente de la tarjeta",
    "blocker_tarjeta_back": "el reverso de la tarjeta",
    "blocker_insurance_platform": "que Qualitas acepte la cobertura",
    "blocker_insurance_own": "una póliza propia vigente y aprobada",
    "blocker_photos": "las 17 fotos ASR en vivo",
    "blocker_city": "la ciudad del vehículo",
    "blocker_location": "la ubicación del vehículo",
    "blocker_price": "un precio diario válido",
    "blocker_catalog": "una marca y modelo válidos",
    "blocker_organization": "que tu agencia esté activa y verificada",
    "blocker_host_restricted": "contactar a soporte: tu cuenta está restringida",
    "blocker_insurance_model": "la cobertura del vehículo (póliza propia o de plataforma)",
    "blocker_generic": "un requisito pendiente",
    "listing_needs_personal_cta": "Completá tu verificación",
    "listing_needs_docs_cta": "Completá los documentos del carro",
    "expired_doc_title": "Reservas pausadas",
    "expired_doc_desc": "{{document}} venció el {{date}}. Actualizalo aquí. Las reservas se habilitarán cuando aprobemos el documento y los demás requisitos estén completos.",
    "expired_doc_cta": "Actualizar",
    "expired_doc_short": "tarjeta o póliza vencida el {{date}}",
    "expired_doc_must_replace": "{{document}} sigue vencida. Subí la nueva para poder continuar.",
    "document_tarjeta_circulacion_front": "La tarjeta de circulación",
    "document_tarjeta_circulacion_back": "El reverso de la tarjeta",
    "document_insurance_policy": "La póliza de seguro",
    "document_insurance_certificate": "El certificado de seguro",
    "document_generic": "Un documento del vehículo",
    "vehicle_published": "Vehículo publicado",
    "vehicle_pending_review": "Recibimos el anuncio. No aparece en la app hasta que completés lo que falta.",
    "vehicle_draft_saved": "Borrador guardado",
    "vehicle_paused": "Vehículo pausado",
    "vehicle_count": "{{count}} vehículo(s)",
    "delete_confirm": "¿Eliminar este vehículo?",
    "delete_confirm_desc": "Esta acción no se puede deshacer",
    "welcome": "Bienvenido, anfitrión",
    "stats_title": "Tu resumen",
    "total_earnings": "Ganancias totales",
    "active_listings": "Vehículos activos",
    "pending_bookings": "Reservas pendientes",
    "active_trips": "Viajes activos",
    "avg_rating": "Calificación promedio",
    "total_trips": "Viajes completados",
    "rented_days": "Días rentados",
    "quick_actions": "Acciones rápidas",
    "new_listing": "Nuevo vehículo",
    "view_calendar": "Ver calendario",
    "see_earnings": "Ver ganancias",
    "recent_bookings": "Reservas recientes",
    "recent_rentals": "Rentas recientes",
    "recent_rentals_subtitle": "Estado y próximo paso",
    "recent_rentals_empty": "Aún no hay rentas recientes.",
    "no_bookings": "Aún no tenés reservas",
    "no_bookings_desc": "Cuando alguien reserve tu vehículo, aparecerá aquí",
    "booking_status_pending_payment": "Pago pendiente",
    "booking_status_awaiting_host": "Esperando al anfitrión",
    "booking_status_confirmed": "Confirmada",
    "booking_status_pending_pickup": "Pendiente de recogida",
    "booking_status_active": "En curso",
    "booking_status_pending_return": "Pendiente de devolución",
    "booking_status_completed": "Completada",
    "booking_status_cancelled": "Cancelada",
    "booking_status_disputed": "En disputa",
    "pending_payouts": "Pagos pendientes",
    "no_rating": "Sin calificación",
    "coming_soon_title": "Cobertura",
    "coming_soon_body": "Las personas naturales ya pueden publicar con póliza propia verificada. La cobertura de plataforma está activa y se integra a cada viaje.",
    "coming_soon_explore": "Explorar vehículos",
    "coming_soon_agency": "Crear perfil de agencia",
    "coming_soon_agency_label": "Crear perfil de agencia",
    "host_onboarding_badge": "Acceso temprano",
    "host_onboarding_title": "Publicá vehículos en Tago",
    "host_onboarding_subtitle": "Elegí cómo vas a operar. Agencias y personas naturales pueden publicar con póliza propia verificada.",
    "host_choice_agency_title": "Soy agencia o empresa",
    "host_choice_agency_body": "Creá tu perfil legal con razón social, NIT y representante para publicar tu flota.",
    "host_choice_agency_badge": "Disponible ahora",
    "host_choice_agency_label": "Crear perfil legal de agencia o empresa",
    "host_choice_natural_title": "Soy persona natural",
    "host_choice_natural_body": "Subí frente y reverso de la tarjeta de circulación, más una póliza o certificado vigente. Verificamos que todo coincida con el vehículo antes de publicar.",
    "host_choice_natural_badge": "Disponible con póliza",
    "host_choice_natural_label": "Publicar como persona natural con póliza verificada",
    "org_loading": "Verificando tu agencia...",
    "org_required_error": "Necesitás una póliza propia verificada para publicar.",
    "exit_draft_title": "¿Salir de la publicación?",
    "exit_draft_body": "Guardamos tu avance: podés salir y seguir después desde donde ibas.",
    "exit_draft_save": "Guardar y salir",
    "exit_draft_stay": "Seguí acá",
    "draft_autosaved_hint": "Guardamos tu avance automáticamente.",
    "resume_draft_title": "¿Continuar tu publicación?",
    "resume_draft_body": "Tus fotos y datos están guardados. Podés continuar donde quedaste o descartar este borrador.",
    "resume_draft_continue": "Continuar publicación",
    "resume_draft_start_over": "Descartar borrador",
    "edit_discards_draft_body": "Si editás otro vehículo perdés las fotos y los datos del borrador que empezaste.",
    "edit_discard_and_edit": "Descartar y editar",
    "retention_kicker": "Por qué quedarse en Tago",
    "retention_title": "El huésped que vuelve paga menos. Vos cobrás el precio entero.",
    "retention_body": "La tarifa de Tago baja a 8% en la segunda reserva del mismo par y a 5% desde la tercera. Tu payout sigue siendo el subtotal del anuncio. Cobertura, reputación y liquidación en 48 h no se llevan a WhatsApp.",
    "retention_point_coverage": "Fuera de Tago, el riesgo de colisión o disputa queda en tu balance.",
    "retention_point_payout": "Liquidamos a tu cuenta en 48 horas. El dinero no se queda en el chat.",
    "retention_point_repeat": "Cuando el mismo huésped vuelve, Tago baja su comisión. Vos no subsidiás el descuento."
  },
  "calendar": {
    "title": "Calendario",
    "available": "Disponible",
    "blocked": "Bloqueado",
    "booked": "Reservado",
    "reserved": "Reservado",
    "legend": "Leyenda",
    "block_dates": "Bloquear fechas",
    "unblock_dates": "Desbloquear fechas",
    "block_summary": "Bloquear {{range}}",
    "unblock_summary": "Desbloquear {{range}}",
    "select_dates": "Seleccioná las fechas",
    "instructions": "Tocá el primer día y luego el último. Para un solo día, tocá esa fecha. Podés cambiar de mes sin perder la selección.",
    "whole_days_one": "1 día completo · horario de El Salvador",
    "whole_days_other": "{{count}} días completos · incluye el primer y último día",
    "clear_selection": "Limpiar selección",
    "crosses_reservation": "Estas fechas incluyen una reserva. Elegí un rango que no cruce días reservados; no cambiamos tu selección ni la reserva.",
    "load_failed": "No pudimos cargar el calendario",
    "load_failed_body": "Necesitamos verificar las reservas antes de cambiar la disponibilidad. Intentá de nuevo.",
    "saved_block": "Guardado: {{range}} ya no se puede reservar.",
    "saved_unblock": "Guardado: quitamos el bloqueo manual de {{range}}.",
    "block_reason": "Motivo (opcional)",
    "reason_maintenance": "Mantenimiento",
    "reason_personal": "Uso personal",
    "reason_other": "Otro",
    "confirm_block": "Confirmar bloqueo",
    "confirm_unblock": "Confirmar desbloqueo",
    "dates_blocked": "Fechas bloqueadas",
    "dates_unblocked": "Fechas desbloqueadas",
    "no_vehicle_selected": "Seleccioná un vehículo",
    "block_failed": "No se pudieron bloquear las fechas",
    "unblock_failed": "No se pudieron desbloquear las fechas",
    "months": "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    "days_short": "L,M,M,J,V,S,D",
    "previous_month": "Mes anterior",
    "next_month": "Mes siguiente"
  },
  "earnings": {
    "title": "Ganancias",
    "this_month": "Este mes",
    "this_week": "Esta semana",
    "all_time": "Histórico",
    "monthly_breakdown": "Desglose mensual",
    "per_vehicle": "Por vehículo",
    "pending_payouts": "Pagos pendientes",
    "transaction_history": "Historial de transacciones",
    "no_earnings": "Aún no tenés ganancias",
    "no_earnings_desc": "Cuando completés tu primer viaje, tus ganancias aparecerán aquí",
    "total_rentals": "{{count}} viaje(s)",
    "payout_pending": "Pago en proceso",
    "payout_completed": "Pagado"
  },
  "booking": {
    "title": "Reservar",
    "select_dates": "Seleccioná tus fechas",
    "price_breakdown": "Desglose del precio",
    "days": "{{count}} día(s)",
    "daily_rate": "Tarifa diaria",
    "subtotal": "Subtotal",
    "discount": "Descuento",
    "cleaning_fee": "Tarifa de limpieza",
    "tago_fee": "Tarifa de servicio Tago",
    "payment_processing": "Procesamiento de pago (3.5%)",
    "insurance": "Seguro",
    "protection_included": "Protección incluida en cada viaje",
    "protection_coming_soon": "Cobertura incluida",
    "total": "Total",
    "iva": "IVA",
    "iva_included": "IVA no aplicado por ahora",
    "security_deposit": "Depósito reembolsable",
    "security_deposit_note": "No es un cobro: queda retenido durante el viaje. Si no hay daños, Tago lo libera al cerrar la renta.",
    "deposit_held": "Depósito retenido",
    "deposit_held_note": "No es un cobro. Se te devuelve al cerrar la renta si no hay daños.",
    "deposit_returning": "Depósito en devolución",
    "deposit_returning_note": "Ya lo estamos gestionando. Te avisamos apenas salga.",
    "deposit_returned": "Depósito devuelto",
    "deposit_returned_note": "Tu banco puede tardar de 5 a 10 días hábiles en reflejarlo.",
    "deposit_held_host": "Depósito del huésped",
    "deposit_held_host_note": "No es parte de tu pago. Se le devuelve al cerrar la renta si no hay daños.",
    "deposit_returning_host": "Depósito en devolución",
    "deposit_returning_host_note": "La renta ya cerró. Se le está devolviendo al huésped.",
    "deposit_returned_host": "Depósito devuelto",
    "deposit_returned_host_note": "Ya se le devolvió al huésped.",
    "deposit_claimed": "Retenido por daños",
    "deposit_claimed_note": "Una disputa resuelta asignó esta parte del depósito al anfitrión.",
    "deposit_claimed_host": "Asignado a vos por daños",
    "deposit_claimed_host_note": "Una disputa resuelta te asignó esta parte del depósito.",
    "host_earnings": "Ganancias del anfitrión",
    "pickup_location": "Lugar de recogida",
    "dropoff_location": "Lugar de devolución",
    "pickup_date": "Recogida",
    "pickup_time": "Hora de recogida",
    "dropoff_date": "Devolución",
    "dropoff_time": "Hora de devolución",
    "select_time": "Elegí hora",
    "pick_times_to_continue": "Elegí la hora de recogida y de devolución para continuar.",
    "pickup_window_hint": "Este día, desde las {{time}}.",
    "dropoff_window_hint": "Este día, hasta las {{time}}.",
    "time_slot_unavailable": "{{time}}, no disponible este día",
    "time_window_empty": "Este día no tiene una hora libre. Elegí otro.",
    "start_in_the_past": "Esa hora de recogida ya pasó. Elegí la primera hora libre.",
    "minimum_duration_notice": "Este carro se reserva por mínimo {{count}} días.",
    "minimum_duration_error": "Ajustá la fecha u hora de devolución: este carro requiere mínimo {{count}} días.",
    "same_location": "Mismo lugar de devolución",
    "different_location": "Diferente lugar de devolución",
    "select_insurance": "Cobertura de la reserva",
    "promo_code": "Código promocional",
    "apply_promo": "Aplicar",
    "promo_applied": "Código aplicado",
    "promo_invalid": "Código no válido",
    "promo_code_not_found": "Código no encontrado",
    "promo_expired": "Este código ha expirado",
    "promo_max_uses_reached": "Este código alcanzó su límite de uso",
    "promo_user_limit_reached": "Ya usaste este código",
    "promo_not_first_rental": "Este código es solo para tu primer viaje",
    "promo_user_not_eligible": "Este código no está disponible para tu perfil.",
    "promo_below_minimum": "El monto del alquiler es menor al mínimo para este código",
    "promo_not_yet_valid": "Este código aún no está activo",
    "promo_country_not_eligible": "Este código no aplica para tu país.",
    "promo_profile_incomplete": "Completá tu perfil al 100% para usar este código.",
    "independence_promo_applied": "Tu reserva incluye el 15 de septiembre: Tago descuenta automáticamente su tarifa de servicio (15%).",
    "independence_discount": "Promo 15 de septiembre",
    "confirm_booking": "Confirmar reserva",
    "agency_only_error": "Por ahora, solo podés reservar vehículos con póliza propia verificada.",
    "errors": {
      "unavailable": "Este vehículo no está disponible para las fechas seleccionadas",
      "min_days": "La duración mínima es de {{hours}} horas",
      "max_days": "La duración máxima es de {{days}} días",
      "own_vehicle": "No podés reservar tu propio vehículo",
      "dates_blocked": "El vehículo está bloqueado para estas fechas",
      "create_failed": "No se pudo crear la reserva",
      "cancel_failed": "No se pudo cancelar la reserva"
    },
    "availability_loading": "Viendo qué días están libres...",
    "availability_error_title": "No pudimos ver la disponibilidad",
    "availability_error_body": "Sin esto no podemos saber qué días están libres. Revisá tu conexión y volvé a intentar.",
    "return_crosses_unavailable": "Ese rango incluye días en que el vehículo ya está reservado. Elegí una devolución más temprana.",
    "return_unavailable_title": "No hay devolución disponible",
    "return_unavailable_body": "El vehículo ya está reservado en los días que siguen a esa fecha de retiro, así que no queda un rango válido. Elegí otra fecha de retiro.",
    "dates_cleared_unavailable": "Esas fechas ya no están disponibles. Seleccioná el rango de nuevo.",
    "charged_today": "Hoy se te cobra",
    "trip_total": "Total del viaje"
  },
  "insurance": {
    "title": "Cobertura del viaje",
    "provider_name": "Aliado asegurador",
    "provider_short": "Aliado asegurador",
    "provider_short_coming_soon": "Cobertura incluida",
    "provider_short_included_soon": "Cobertura incluida",
    "provider_tagline": "Cobertura para viajes",
    "provider_view_coverage_soon": "Detalles de cobertura",
    "provider_logo_alt": "Ícono de cobertura",
    "launching_soon": "Incluida en cada viaje",
    "provider_launching_soon_a11y": "Cobertura para viajes incluida",
    "provider_partner_context": "Con el respaldo de",
    "provider_partner_review_a11y": "Con el respaldo de Quálitas.",
    "coming_soon_badge": "Incluida",
    "available_soon": "Incluida en tu reserva",
    "early_access_desc": "Una sola cobertura incluida. Sin escoger planes.",
    "included_title": "Cobertura para viajes",
    "included_soon_badge": "Incluida",
    "included_desc": "Se integra como una única cobertura incluida en la reserva: una prima por día, sin planes ni cargos sorpresa.",
    "included_point_auto": "Se aplica automáticamente a cada viaje.",
    "included_point_no_plans": "Sin escoger planes ni configurar extras.",
    "included_point_assistance": "Asistencia 24/7 incluida en El Salvador.",
    "included_point_benefits": "Póliza emitida para tu viaje antes de confirmar.",
    "assistance_card_title": "Cabina de asistencia",
    "assistance_card_desc": "Disponible para viajes con cobertura activa. Usá estos teléfonos si necesitás ayuda durante el viaje.",
    "assistance_card_a11y": "Cabina de asistencia de cobertura",
    "assistance_generic_title": "Asistencia",
    "assistance_generic_desc": "Abrí el marcador con el número de la cabina de asistencia para viajes con cobertura activa.",
    "assistance_generic_badge": "Contacto",
    "assistance_call": "Llamar al {{phone}}",
    "assistance_call_now": "Llamar ahora",
    "assistance_call_primary": "Llamar a asistencia al {{phone}}",
    "assistance_call_secondary": "Llamar al número alternativo {{phone}}",
    "assistance_secondary_short": "Otro número: {{phone}}",
    "assistance_phone_ready": "Se abrirá el marcador con {{phone}} listo para llamar.",
    "assistance_call_failed": "No pudimos abrir el marcador. Llamá manualmente al número mostrado.",
    "current_policy_note": "Los vehículos de agencias y los que no tienen cobertura de plataforma aplican la póliza verificada del anfitrión.",
    "provider_partner_live_title": "Cada viaje respaldado",
    "provider_partner_live_a11y": "Cada viaje respaldado por Quálitas, con póliza."
  },
  "checkout": {
    "title": "Pagar",
    "your_trip": "Tu viaje",
    "summary": "Resumen de la reserva",
    "payment_method": "Método de pago",
    "select_payment": "Seleccioná un método de pago",
    "confirm": "Confirmar y pagar",
    "or": "o",
    "pay_now": "Pagar ahora",
    "pay_securely": "Pagar {{amount}} de forma segura",
    "pay_securely_a11y": "Pagar de forma segura",
    "pay_with_new_card": "Usar otra tarjeta",
    "paypal": "PayPal",
    "paypal_title": "Pagá con PayPal",
    "paypal_desc": "Usá tu cuenta PayPal sin compartir los datos de tu tarjeta con Tago.",
    "paypal_secure_title": "Pago seguro con PayPal",
    "paypal_secure_desc": "PayPal protege tus datos de pago. Tago recibe únicamente la confirmación de la orden.",
    "paypal_secure_note": "Se abrirá PayPal de forma segura. Al terminar, volverás automáticamente a Tago.",
    "paypal_pending": "Tu orden de PayPal está lista. Completá la autorización para confirmar la reserva.",
    "paypal_continue": "Continuar en PayPal",
    "pay_with_paypal": "Pagar {{amount}} con PayPal",
    "paypal_fee_line": "Comisión de PayPal",
    "processor_fee_hint": "La comisión de PayPal se suma a tu total. Tago no la absorbe.",
    "secure_payment_title": "Pago seguro",
    "secure_payment_desc": "Los datos de pago se quedan con la pasarela. Tago solo guarda una referencia segura para que reconozcás tus tarjetas.",
    "saved_cards_title": "Tus tarjetas",
    "saved_cards_desc": "Elegí una guardada o usá otra tarjeta.",
    "saved_card_cvv_desc": "La pasarela puede pedir el CVV para confirmar este pago. No se guarda después de enviarlo.",
    "saved_card_cvv_label": "CVV de la tarjeta guardada",
    "card": "Tarjeta",
    "card_expiry": "Vence {{expiry}}",
    "other_methods": "Otros métodos de pago",
    "other_methods_desc": "Puntos Agrícola, Bitcoin, Cuotas",
    "cancellation_policy": "Política de cancelación",
    "cancellation_full": "Reembolso del 100% del alquiler hasta 48h antes",
    "cancellation_partial": "50% de reembolso entre 24h y 48h antes",
    "cancellation_none": "Sin reembolso dentro de las 24h antes",
    "cancellation_fee_note": "La tarifa de servicio de Tago no se reembolsa si cancelás vos.",
    "terms": "Al confirmar, aceptás los términos de alquiler y la política de cancelación",
    "accept_terms_error": "Aceptá los términos para continuar.",
    "missing_booking_data": "Revisá las fechas y el vehículo antes de reservar.",
    "start_in_the_past": "Esa hora de recogida ya pasó. Volvé y elegí la primera hora libre.",
    "dates_unavailable": "Ese vehículo ya está reservado en esas fechas. Elegí otras fechas.",
    "vehicle_no_longer_available": "Este vehículo ya no está disponible. Volvé a explorar para elegir uno activo.",
    "vehicle_document_expired": "Este vehículo tiene un documento vencido y no se puede reservar. Elegí otro mientras el anfitrión renueva los papeles.",
    "dates_blocked": "El anfitrión bloqueó esas fechas. Elegí otras fechas.",
    "min_rental_duration": "Este carro tiene una duración mínima. Ajustá tus fechas para continuar.",
    "processing": "Procesando pago...",
    "platform_insurance_coming_soon": "Este vehículo opera con la póliza verificada del anfitrión.",
    "delivery_return_title": "Entrega y devolución",
    "pickup_at": "Entrega",
    "dropoff_at": "Devolución",
    "delivery_radius_notice": "Disponible hasta {{radius}} km del punto del anfitrión.",
    "vehicle_location_missing_title": "Falta el punto de entrega",
    "vehicle_location_missing": "Este vehículo todavía no tiene un punto de entrega configurado. Elegí otro vehículo mientras el anfitrión lo corrige.",
    "location_out_of_radius": "La entrega o devolución está fuera del radio permitido por el anfitrión.",
    "pickup_location_title": "Punto de entrega",
    "dropoff_location_title": "Punto de devolución",
    "search_or_drag_pin": "Buscá una dirección o mové el pin del mapa.",
    "location_search_placeholder": "Buscar dirección",
    "location_no_results": "No encontramos direcciones con esa búsqueda.",
    "selected_location": "Ubicación seleccionada",
    "location_within_radius": "{{distance}} km del punto del anfitrión. Radio máximo: {{radius}} km.",
    "location_out_of_radius_detail": "{{distance}} km del punto del anfitrión. Máximo permitido: {{radius}} km.",
    "save_location": "Guardar ubicación",
    "same_return_location": "Devolver en el mismo punto de entrega",
    "resume_loading_title": "Recuperando pago pendiente",
    "resume_loading": "Estamos cargando la reserva pendiente para continuar el pago.",
    "resume_error_title": "No se pudo recuperar el pago",
    "resume_error": "No pudimos cargar esa reserva pendiente. Volvé a abrirla desde tus viajes.",
    "resume_already_handled_title": "Reserva ya actualizada",
    "resume_already_handled": "Esta reserva ya no está pendiente de pago. Revisá tus viajes para ver el estado actual.",
    "resume_saved_locations": "Puntos guardados en esta reserva.",
    "pair_fee_loading": "Estamos calculando tu tarifa de servicio para este anfitrión."
  },
  "payment": {
    "title": "Pago",
    "processing": "Procesando pago...",
    "redirecting": "Preparando la confirmación del pago...",
    "redirecting_paypal": "Volviendo de PayPal...",
    "success": "¡Pago exitoso!",
    "success_desc": "Tu reserva ha sido confirmada. Te enviaremos un correo con los detalles.",
    "failed": "Pago rechazado",
    "failed_desc": "El pago no fue procesado. Intentá de nuevo o usá otro método de pago.",
    "wompi_generic_validation": "El cobro no pasó la validación del procesador. No se cobró. Intentá de nuevo o usá otra tarjeta.",
    "declined_title": "La tarjeta no pasó",
    "declined_desc": "El banco rechazó este cobro. No se te cobró. Probá de nuevo o usá otra tarjeta.",
    "validation_title": "No se pudo validar el cobro",
    "validation": "El cobro no pasó la validación del procesador. No se cobró. Intentá de nuevo o usá otra tarjeta.",
    "app_not_live_title": "El comercio aún no está en vivo",
    "app_not_live": "El procesador de pagos todavía no tiene este comercio en vivo. No es tu tarjeta.",
    "challenge_abandoned_title": "Cancelaste la verificación",
    "challenge_abandoned": "Cancelaste la verificación del banco. No se cobró. Podés intentar de nuevo.",
    "start_in_past_title": "Esa hora ya pasó",
    "booking_too_soon_title": "Elegí un horario más tarde",
    "booking_too_soon": "Elegí un inicio al menos tres horas después de ahora.",
    "create_failed_title": "No pudimos iniciar el cobro",
    "total_mismatch_title": "El precio cambió",
    "saved_card_title": "Tarjeta guardada no disponible",
    "hosted_checkout_title": "No se abrió el pago hospedado",
    "hosted_checkout_could_not_start": "No pudimos abrir el pago hospedado. No se te cobró nada. Volvé a intentar en un momento.",
    "unconfirmed_title": "No pudimos confirmar tu pago",
    "unconfirmed_desc": "El banco todavía no nos respondió, así que no sabemos si el cobro se aprobó. No lo intentés de nuevo: si se aprobó, la reserva va a aparecer en Mis viajes en unos minutos y te avisamos apenas se confirme.",
    "unconfirmed_action": "Ver mis viajes",
    "processing_delayed": "Tu pago está siendo procesado. Te notificaremos cuando se confirme.",
    "timeout": "El tiempo para pagar expiró",
    "retry": "Reintentar pago",
    "bank_verification": "Verificación bancaria",
    "loading_verification": "Cargando verificación...",
    "cancel_verification_title": "¿Cancelar verificación?",
    "cancel_verification_desc": "Si cancelás, el pago podría haberse procesado de todos modos. Verificá tu estado de cuenta.",
    "complete_payment": "Completar pago",
    "rental_no_longer_active": "La reserva ya no estaba activa cuando se aprobó el cobro. Te devolvimos el dinero; revisá tus viajes antes de reservar de nuevo.",
    "total_mismatch": "El precio de esta reserva cambió. Volvé a la reserva para ver el monto actualizado.",
    "refunded_title": "Te devolvimos el dinero",
    "refunded_desc": "El cobro se aprobó cuando la reserva ya estaba cancelada, así que lo revertimos. No se hizo ningún viaje ni se te cobró.",
    "refund_pending_desc": "El cobro se aprobó cuando la reserva ya estaba cancelada. Estamos procesando la devolución y te avisamos en cuanto esté lista.",
    "cancelled_title": "Pago cancelado",
    "cancelled_desc": "No se realizó ningún cobro. Podés volver a PayPal cuando estés listo para confirmar la reserva.",
    "booking_blocked_title": "Falta un paso antes de pagar",
    "booking_blocked_unknown": "No pudimos determinar qué falta. Abrí Verificación en tu perfil.",
    "booking_blocked_cta": "Completar ahora",
    "blocker_identity_review_pending": "Tus documentos están aprobados; estamos terminando de habilitarte",
    "blocker_account_deletion_requested": "Pediste borrar tu cuenta. Escribinos para reactivarla.",
    "blocker_unknown_profile": "No encontramos tu perfil. Volvé a iniciar sesión.",
    "saved_card_unavailable": "Por ahora no podemos cobrar con tarjetas guardadas. Usá el formulario de tarjeta acá abajo.",
    "bank_verification_unavailable": "No pudimos iniciar la verificación con el banco. No es tu tarjeta: volvé a intentar en un rato.",
    "wompi_app_not_live": "Wompi todavía no tiene este aplicativo en vivo. No es tu tarjeta: en el panel activá En Vivo en el aplicativo de prueba.",
    "could_not_start": "No pudimos iniciar el cobro y no se te cobró nada. Volvé a intentar en un rato.",
    "paypal_could_not_start": "No pudimos abrir PayPal",
    "paypal_could_not_start_desc": "No se te cobró nada. Volvé a intentar en un momento."
  },
  "card_form": {
    "card_number": "Número de tarjeta",
    "expiry": "Vencimiento",
    "cvv": "CVV",
    "cardholder_name": "Nombre del titular",
    "cardholder_name_placeholder": "Ej: Carlos Ávila",
    "pay_amount": "Pagar {{amount}}",
    "card_required": "Ingresá el número de tarjeta",
    "invalid_card": "Número de tarjeta inválido",
    "expiry_required": "Ingresá el vencimiento",
    "invalid_expiry": "Vencimiento inválido",
    "card_expired": "La tarjeta está vencida",
    "cvv_required": "Ingresá el CVV",
    "invalid_cvv": "CVV inválido"
  },
  "confirmation": {
    "title": "¡Reserva confirmada!",
    "subtitle": "Tu reserva fue creada exitosamente",
    "reference": "Código de reserva",
    "vehicle": "Vehículo",
    "dates": "Fechas",
    "host": "Anfitrión",
    "total_paid": "Total pagado",
    "view_trips": "Ver mis viajes",
    "contact_host": "Contactar anfitrión",
    "what_next": "¿Qué sigue?",
    "next_step_1": "Ya le avisamos al anfitrión",
    "next_step_2": "Escribile por Mensajes para coordinar la entrega",
    "next_step_3": "Presentá tu DUI al recoger el vehículo"
  },
  "rental_terms_flow": {
    "title": "Condiciones de alquiler · v{{version}}",
    "loading_title": "Condiciones de la reserva",
    "loading": "Cargando la versión vigente…",
    "unavailable": "No pudimos verificar la versión vigente. No cobraremos hasta que podás revisarla.",
    "retry": "Volver a intentar",
    "read_terms": "Leer términos completos",
    "read_cancellation": "Ver cancelaciones y reembolsos",
    "profile_current_version": "La versión vigente es la {{version}}. Abriremos el documento completo y permanente de esa versión; tus reservas anteriores conservan sus condiciones originales.",
    "open_current_document": "Abrir documento vigente",
    "open_error": "No pudimos abrir el documento. Probá de nuevo.",
    "payment_disclosure": "Pagás ahora. El anfitrión tiene 2 horas para aceptar o rechazar; mientras tanto, tu reserva aún no está confirmada. Si rechaza o vence el plazo, gestionamos el reembolso completo.",
    "minimum_lead_title": "Elegí una salida más tarde",
    "minimum_lead": "Para que el anfitrión tenga sus 2 horas completas para responder, elegí una salida al menos 3 horas después de ahora. No se intentó ningún cobro.",
    "accept_label": "Leí los documentos de la versión {{version}} y acepto sus condiciones para esta reserva.",
    "changed": "Las condiciones cambiaron. Revisá la nueva versión antes de pagar.",
    "stale_hold_title": "Empezá con las condiciones vigentes",
    "stale_hold_body": "Esta solicitud sin pagar se creó con una versión anterior. No iniciaremos otro cobro con esas condiciones. Si empezás otra, cerraremos de forma segura el intento anterior y podrás revisar la versión vigente.",
    "restart": "Empezar otra solicitud",
    "restart_ready": "Solicitud anterior cerrada. Revisá las condiciones vigentes para continuar.",
    "restart_failed": "No pudimos cerrar con seguridad el intento anterior. Revisá tus viajes antes de volver a pagar.",
    "host_title": "Revisá las nuevas condiciones",
    "host_body": "Para recibir nuevas solicitudes pagadas, revisá y aceptá la versión vigente. Tus reservas anteriores y su plazo de respuesta no cambian.",
    "host_upcoming_title": "Prepará tus próximas condiciones",
    "host_upcoming_body": "Hay una versión anunciada que todavía no está vigente. Podés leerla y aceptarla ahora para seguir recibiendo nuevas solicitudes sin interrupción cuando entre en vigor. Tus reservas actuales no cambian.",
    "host_accept": "Aceptar nuevas condiciones",
    "host_accept_upcoming": "Aceptar versión anunciada",
    "host_accepted": "Condiciones aceptadas",
    "host_error": "No pudimos guardar tu aceptación. Probá de nuevo.",
    "host_unavailable": "Este anfitrión aún no aceptó las nuevas condiciones. No cobraremos por este vehículo; elegí otro o probá más tarde."
  },
  "host_approval": {
    "payment_received": "Pago recibido",
    "waiting_title": "Esperamos al anfitrión",
    "waiting_subtitle": "Ya pagaste. Tu reserva se confirma cuando el anfitrión la acepte.",
    "deadline": "Respondé antes del {{time}}",
    "guest_deadline": "Te responderá antes del {{time}}",
    "time_remaining": "Quedan {{minutes}} min para responder",
    "host_title": "Tenés una reserva pagada",
    "host_body": "Aceptá o rechazá antes de que venza. Si no respondés, iniciaremos el reembolso completo al huésped.",
    "guest_body": "El anfitrión tiene hasta 2 horas. Te avisaremos cuando responda; si no puede aceptar, gestionaremos el reembolso completo.",
    "accept": "Aceptar reserva",
    "decline": "No puedo recibirlo",
    "decline_title": "¿No podés recibir esta reserva?",
    "decline_body": "Cancelaremos la solicitud y gestionaremos el reembolso completo al huésped.",
    "decline_body_v2": "Cancelaremos esta solicitud y gestionaremos el reembolso completo al huésped. No aplican las penalidades de una reserva confirmada. Si Wompi nos cobra un costo que no devuelve, te enviaremos el monto y la evidencia; tendrás 7 días para objetarlo antes de cualquier descuento futuro.",
    "keep_request": "Seguir con la reserva",
    "decline_confirm": "Rechazar y reembolsar",
    "accepted": "Reserva aceptada",
    "declined": "Reserva cancelada. El reembolso está en gestión.",
    "expired": "El plazo venció; actualizá para ver el estado.",
    "error": "No pudimos registrar tu respuesta. Revisá el estado y volvé a intentar."
  },
  "host_gateway_fee": {
    "title": "Costo de procesamiento",
    "load_error": "No pudimos consultar el detalle de este cargo. No se aplicará ningún descuento desde esta pantalla.",
    "status_notice_period": "Wompi retuvo este costo después del reembolso completo. Todavía no se ha descontado de ninguna liquidación.",
    "status_disputed": "Recibimos tu objeción. El cargo está detenido mientras revisamos la evidencia.",
    "status_approved": "La revisión terminó. Este costo podrá descontarse de una liquidación futura de la misma cuenta.",
    "partially_applied": "Ya descontado: {{applied}} · Saldo pendiente: {{pending}}",
    "status_applied": "Este costo ya fue incluido en una liquidación de la misma cuenta.",
    "status_waived": "Anulamos este cargo. No se descontará de ninguna liquidación.",
    "breakdown": "Cargo Wompi: {{gross}} · Crédito o reversión: −{{credit}}",
    "reference": "Referencia del comprobante: {{reference}}",
    "dispute_until": "Podés objetarlo hasta el {{date}}. No se descontará antes.",
    "dispute": "Objetar este costo",
    "reason_label": "Motivo de tu objeción",
    "reason_placeholder": "Contanos qué no coincide. Revisaremos el comprobante y te responderemos.",
    "send_dispute": "Enviar objeción",
    "dispute_saved": "Recibimos tu objeción. El cargo queda detenido.",
    "dispute_error": "No pudimos guardar la objeción. No asumás que se envió; probá otra vez o escribinos.",
    "request_statement": "Pedir el comprobante",
    "statement_error": "No pudimos abrir tu correo. Escribinos a teamtagorent@gmail.com con la referencia de tu reserva."
  },
  "listing": {
    "wizard_title": "Nuevo vehículo",
    "edit_load_failed_title": "No pudimos abrir este vehículo",
    "edit_load_failed_body": "Tu publicación no cambió en nada. Probá de nuevo o volvé a tus vehículos.",
    "step_details": "Detalles",
    "step_ownership": "Propiedad",
    "ownership_title": "¿De quién es este carro?",
    "ownership_subtitle": "Lo necesitamos para tu cobertura y para confirmar que podés publicarlo.",
    "ownership_mine_title": "Es mío",
    "ownership_mine_desc": "Está a mi nombre en la tarjeta de circulación.",
    "ownership_third_party_title": "Es de alguien más",
    "ownership_third_party_desc": "De un familiar, amigo o mi trabajo — con su permiso.",
    "ownership_company_title": "Es de una empresa",
    "ownership_company_desc": "Está a nombre de una empresa de la que soy parte.",
    "ownership_not_declared": "Sin declarar — tocá Editar para responder.",
    "ownership_authorizer_label": "¿A nombre de quién está?",
    "ownership_authorizer_placeholder": "Nombre del dueño",
    "ownership_authorizer_hint": "Debe coincidir con la tarjeta de circulación. Más adelante confirmamos tu autorización.",
    "ownership_mismatch_body": "El titular de la tarjeta no coincide con tu nombre. ¿Es de alguien más?",
    "ownership_mismatch_switch": "Es de alguien más",
    "ownership_switched_third_party": "Listo, lo cambiamos a “de alguien más”. Vas a necesitar su autorización.",
    "publish_saved_as_draft": "Guardamos tu vehículo como borrador. Completá tu verificación para publicarlo.",
    "publish_confirming": "Guardamos todo. Estamos terminando de publicarlo: revisá en un momento en Mis vehículos.",
    "tarjeta_expired": "Tu tarjeta de circulación venció el {{date}}. Refrendala en sertracen.com.sv, en un kiosco de Sertracen o en un banco autorizado (son unos minutos y $5.71 de multa por año) y volvé a escanearla acá. Guardamos todo lo demás.",
    "photo_upload_forbidden": "No pudimos subir la foto: parece un problema de permiso o sesión. Cerrá sesión, volvé a entrar y probá de nuevo.",
    "photo_upload_network": "No pudimos subir la foto. Revisá tu conexión e intentá de nuevo.",
    "step_features": "Características",
    "step_photos": "Fotos",
    "photo_pick_failed": "No pudimos abrir tu galería. Verificá los permisos y probá de nuevo.",
    "photos_live_title": "Inspección inicial en vivo",
    "photos_live_subtitle": "Capturá las {{count}} tomas con la cámara de Tago. Cada foto queda vinculada a un requisito; no se aceptan fotos de galería.",
    "capture_live_photo": "Capturar foto en vivo",
    "retake_live_photo": "Volver a tomar en vivo",
    "extra_photos_title": "Fotos adicionales (opcional)",
    "extra_photos_help": "¿Tenés cámara 360, selector 4x4 u otros extras que no caben en una sola toma? Agregá las fotos que quieras. No son obligatorias.",
    "extra_photos_add": "Agregar foto",
    "photos_missing_summary": "Te faltan {{missing}} tomas: {{list}}",
    "photos_missing_count": "Te faltan {{missing}} tomas de inspección. Están marcadas en rojo abajo.",
    "photos_upfront_notice": "Vas a necesitar {{total}} fotos del vehículo tomadas en vivo con la cámara de Tago. Tenelo a mano antes de empezar.",
    "insurance_redirect_a11y": "Abriendo el paso de documentos",
    "live_document_helper": "Colocá el documento completo dentro del marco y capturalo en vivo.",
    "photo_requirements": {
      "front_right": "Frente y costado derecho",
      "front_left": "Frente y costado izquierdo",
      "hood_open": "Área completa de motor",
      "engine_closeup": "Número de chasis",
      "rear_right": "Parte trasera y costado derecho",
      "rear_left": "Parte trasera y costado izquierdo",
      "trunk_panorama": "Panorámica del baúl",
      "spare_tire": "Llanta de repuesto",
      "tools": "Herramientas",
      "rim_complete": "Larguero y chasis izquierdo",
      "rim_serial": "Larguero y chasis derecho",
      "dashboard_panorama": "Consola, radio y timón",
      "dashboard_on": "Tablero encendido",
      "odometer": "Odómetro",
      "front_seats": "Asientos delanteros",
      "exterior_accessories": "Techo y accesorios exteriores",
      "interior_accessories": "Consola y accesorios interiores"
    },
    "photo_requirement_hints": {
      "front_right": "Tomá el frente con el costado derecho visible.",
      "front_left": "Tomá el frente con el costado izquierdo visible.",
      "hood_open": "Abrí el capó y capturá motor, tapaderas, mangueras y carrocería visible.",
      "engine_closeup": "Acercá la cámara hasta que el número de chasis sea legible.",
      "rear_right": "Mostrá la parte trasera y el costado derecho.",
      "rear_left": "Mostrá la parte trasera y el costado izquierdo.",
      "trunk_panorama": "Abrí el baúl y capturá todo el espacio.",
      "spare_tire": "Mostrá la llanta de repuesto completa.",
      "tools": "Mostrá gato, llave y herramientas incluidas.",
      "rim_complete": "Mostrá larguero y chasis del lado izquierdo desde el área del motor.",
      "rim_serial": "Mostrá larguero y chasis del lado derecho desde el área del motor.",
      "dashboard_panorama": "Mostrá consola central, radio y timón en una toma.",
      "dashboard_on": "Encendé el vehículo y mostrá marcadores/pilotos.",
      "odometer": "Acercate al kilometraje o millaje.",
      "front_seats": "Mostrá ambos asientos delanteros.",
      "exterior_accessories": "Mostrá el techo completo con sunroof, barras o estribos. Si no tiene ninguno, tomá el techo igual.",
      "interior_accessories": "Mostrá la consola con cámara, pantalla o subwoofer. Si no tiene ninguno, tomá la consola igual."
    },
    "step_location": "Ubicación",
    "step_pricing": "Precio",
    "step_insurance": "Seguro",
    "step_review": "Revisar",
    "step_of": "Paso {{current}} de {{total}}",
    "next": "Siguiente",
    "next_with_count": "Siguiente ({{current}}/{{total}})",
    "previous": "Anterior",
    "publish": "Publicar",
    "save_draft": "Guardar borrador",
    "submit_for_review": "Enviar a revisión",
    "submit_phase_saving": "Guardando datos...",
    "submit_phase_photos": "Subiendo fotos...",
    "submit_phase_photos_progress": "Subiendo fotos {{completed}}/{{total}}",
    "submit_phase_documents": "Revisando documentos...",
    "submit_phase_coverage": "Enviando revisión de cobertura...",
    "submit_phase_publishing": "Publicando...",
    "submit_timeout_location": "La conexión tardó demasiado validando la ubicación. Continuamos con la dirección ingresada.",
    "submit_timeout_saving": "No se pudo terminar de guardar a tiempo. Revisá tu conexión e intentá de nuevo.",
    "submit_timeout_photos": "No se pudo terminar de subir las fotos a tiempo. Revisá tu conexión e intentá de nuevo.",
    "submit_timeout_documents": "No se pudo terminar de guardar los documentos a tiempo. Revisá tu conexión e intentá de nuevo.",
    "submit_timeout_coverage": "No se pudo enviar la revisión de cobertura a tiempo. Revisá tu conexión e intentá de nuevo.",
    "submit_timeout_publishing": "No se pudo confirmar la publicación a tiempo. Te llevamos al panel para mostrar el estado real.",
    "coverage_review_submit_failed": "No pudimos enviar la revisión de cobertura. Intentá de nuevo.",
    "make": "Marca",
    "make_placeholder": "Seleccioná la marca",
    "model": "Modelo",
    "model_placeholder": "Seleccioná el modelo",
    "year": "Año",
    "year_placeholder": "Seleccioná el año",
    "year_hint": "Por ahora aceptamos vehículos del {{year}} en adelante.",
    "category": "Categoría",
    "color": "Color",
    "color_placeholder": "Ej: Blanco, Negro, Gris",
    "transmission": "Transmisión",
    "fuel_type": "Combustible",
    "seats": "Asientos",
    "doors": "Puertas",
    "plate_number": "Número de placa",
    "plate_placeholder": "Ej: P123456",
    "title": "Título del anuncio",
    "title_placeholder": "Ej: Toyota Corolla 2023 - Automático",
    "description": "Descripción",
    "description_placeholder": "Describe tu vehículo, condición, y lo que lo hace especial",
    "features_label": "Características",
    "features_hint": "Marcá solo lo que tenga el vehículo.",
    "instant_book": "Reserva instantánea",
    "instant_book_desc": "Los huéspedes pueden reservar sin aprobación previa",
    "daily_rate": "Tarifa diaria (USD)",
    "security_deposit": "Depósito de garantía (opcional)",
    "security_deposit_placeholder": "0.00",
    "security_deposit_help": "Se le cobra al huésped y Tago lo retiene; si no hay daños, Tago lo libera al cerrar la renta. A vos se te descuenta ~3.5% de procesamiento cuando se devuelve. Ideal para vehículos de alto valor.",
    "daily_rate_placeholder": "25.00",
    "min_rental_duration": "Duración mínima",
    "min_rental_duration_desc": "Elegí si querés evitar reservas demasiado cortas. El calendario solo permitirá fechas que cumplan esta regla.",
    "min_rental_none": "Sin mínimo",
    "min_rental_none_desc": "Acepta cualquier viaje disponible.",
    "min_rental_2_days": "2 días",
    "min_rental_2_days_desc": "Buen balance: menos rotación sin limitar demasiado.",
    "min_rental_3_days": "3 días",
    "min_rental_3_days_desc": "Ideal para viajes largos y menos entregas.",
    "hourly_rate": "Tarifa por hora (USD)",
    "weekly_discount": "Descuento semanal (%)",
    "monthly_discount": "Descuento mensual (%)",
    "cleaning_fee": "Tarifa de limpieza (USD)",
    "km_limit": "Límite de km/día",
    "km_unlimited": "Sin límite",
    "km_hint": "Dejá vacío para kilómetros ilimitados",
    "excess_km_rate": "Costo por km excedente",
    "insurance_model": "Modelo de seguro",
    "insurance_models": {
      "platform": "Plataforma",
      "fleet": "Flota",
      "hybrid": "Híbrido",
      "none": "Sin seguro"
    },
    "insurance_platform": "Plataforma",
    "insurance_fleet": "Flota",
    "insurance_hybrid": "Híbrido",
    "insurance_none": "Ninguno",
    "insurance_title": "Seguro de la publicación",
    "insurance_locked_notice": "La publicación sigue requiriendo póliza propia verificada; la cobertura se integrará como cobertura incluida en la reserva.",
    "insurance_agency_title": "Póliza propia del anfitrión",
    "insurance_agency_desc": "Subí una póliza o certificado vigente que corresponda al vehículo. Verificamos datos, vigencia y cobertura antes de publicar.",
    "insurance_agency_selected": "Requerida para publicar ahora",
    "insurance_partner_title": "Cobertura incluida",
    "insurance_partner_badge": "Incluida",
    "insurance_partner_desc": "Se integrará como una sola cobertura incluida en la reserva. Sin planes para elegir.",
    "insurance_agency_summary": "Póliza propia verificada",
    "placeholder_owner_name": "Nombre del propietario",
    "features_selected": "{{count}} seleccionada(s)",
    "review_title": "Revisar y publicar",
    "no_make_model": "Marca/modelo no seleccionado",
    "address": "Dirección de recogida",
    "use_current_location": "Usar mi ubicación actual",
    "document_scan_failed": "No pudimos abrir el escáner. Revisá tu conexión e intentá de nuevo, o tomá la foto normal.",
    "publish_needs_verification": "Para publicar vas a necesitar verificar tu identidad. Podés terminar de armar el vehículo: lo guardamos y te llevamos a verificarte al final.",
    "address_placeholder": "Ej: Col. Escalón, San Salvador",
    "map_unavailable_title": "No se pudo cargar el mapa",
    "map_unavailable_body": "Seguí con la dirección de arriba: la usamos para ubicar el carro en el mapa.",
    "delivery_radius": "Radio de entrega (km)",
    "delivery_radius_placeholder": "10",
    "step_documents": "Documentos",
    "tarjeta_circulacion": "Tarjeta de circulación",
    "documents_callout_title": "Documento del vehículo (no tu licencia)",
    "documents_callout_body": "Acá subís la tarjeta de circulación del carro: placa, propietario y VIN. La licencia de conducir personal se verifica en tu perfil, no en este paso.",
    "tarjeta_wrong_license": "Esa es una licencia de conducir. Necesitamos la tarjeta de circulación del vehículo (con placa y propietario).",
    "tarjeta_wrong_dui": "Ese es un DUI. Necesitamos la tarjeta de circulación del vehículo.",
    "tarjeta_number": "Número de tarjeta",
    "tarjeta_number_placeholder": "Ej: 00000000",
    "tarjeta_expiry": "Vencimiento",
    "tarjeta_owner": "Propietario",
    "tarjeta_scan": "Escanear tarjeta",
    "tarjeta_scanning": "Escaneando documento...",
    "tarjeta_scan_failed": "No se pudo verificar. Tomá o subí una foto más clara.",
    "tarjeta_front_photo": "Foto frontal",
    "tarjeta_back_photo": "Foto trasera",
    "tarjeta_expired_error": "La tarjeta está vencida",
    "tarjeta_required": "La tarjeta de circulación es obligatoria",
    "tarjeta_back_required": "Capturá el reverso de la tarjeta de circulación",
    "document_live_capture_required": "Capturá este documento en vivo dentro de Tago.",
    "tarjeta_mismatch_warning": "Revisaremos estos datos sin detener la publicación",
    "tarjeta_confidence_low": "No se pudieron leer todos los campos con suficiente confianza.",
    "tarjeta_confidence_ok": "Campos leídos con {{percent}}% de confianza",
    "tarjeta_confidence_warning": "Solo {{percent}}% de confianza. Revisá cada campo antes de continuar.",
    "tarjeta_ai_required": "La tarjeta debe verificarse",
    "tarjeta_back_ai_required": "El reverso de la tarjeta debe verificarse",
    "tarjeta_ai_approved": "Frente y reverso verificados",
    "tarjeta_mismatch_blocked": "Revisaremos estos datos antes de aprobar definitivamente el anuncio.",
    "policy_document": "Póliza de seguro",
    "policy_photo": "Cobertura del vehículo",
    "policy_photo_hint": "Las agencias pueden subir su póliza propia o usar la cobertura de plataforma.",
    "policy_upload_now": "Capturar póliza",
    "policy_own": "Póliza propia",
    "policy_qualitas": "Cobertura Qualitas",
    "policy_defer": "Cobertura Qualitas",
    "policy_deferred_notice": "El anuncio queda en revisión con cobertura Qualitas hasta la autorización.",
    "policy_agency_choice_hint": "Elegí cómo se cubre este vehículo: tu póliza o la cobertura de plataforma. Las reservas se habilitan cuando la cobertura esté lista.",
    "policy_qualitas_agency_notice": "Enviamos el anuncio a revisión con cobertura de plataforma. No hace falta subir póliza propia.",
    "policy_non_platform": "Cobertura por póliza propia",
    "policy_non_platform_notice": "Este vehículo no es elegible para la cobertura de plataforma disponible según su categoría o antigüedad. Podés aplicar con una póliza propia vigente y verificable.",
    "non_platform_pending_notice": "Esta categoría requiere una póliza propia vigente; la publicación seguirá pendiente hasta verificarla.",
    "non_platform_review_banner": "Esta categoría requiere póliza propia. La publicación queda pendiente hasta verificarla.",
    "individual_qualitas_title": "Cobertura Qualitas",
    "individual_qualitas_body": "Como persona natural no subís póliza. Enviamos el anuncio a revisión y la aseguradora autoriza la cobertura. Las reservas se habilitan cuando quede aprobada.",
    "individual_qualitas_pending_notice": "Anuncio listo para revisión de cobertura. No necesitás póliza propia.",
    "individual_qualitas_review_banner": "Persona natural: el anuncio queda en revisión hasta la autorización de Qualitas. No se publica al instante.",
    "auto_title_suffix": "en Tago",
    "auto_description_suffix": "Listo para rentar en El Salvador con cobertura Qualitas.",
    "policy_scanning": "Verificando póliza...",
    "policy_required": "La póliza de seguro es obligatoria",
    "policy_expired_error": "La póliza está vencida",
    "policy_ai_required": "La póliza debe verificarse",
    "policy_not_approved": "La póliza no cumple los requisitos para publicar.",
    "policy_scan_failed": "No se pudo verificar la póliza. Capturá una foto más clara del documento completo.",
    "policy_ai_approved": "Póliza verificada",
    "policy_ai_needs_review": "La póliza necesita revisión",
    "policy_number": "Número de póliza",
    "policy_expiry": "Vencimiento de póliza",
    "policy_unknown_insurer": "Aseguradora no leída",
    "policy_unknown_number": "Número no leído",
    "policy_unknown_expiry": "Vigencia no leída",
    "take_photo": "Tomar foto",
    "scan_document": "Escanear documento",
    "choose_gallery": "Elegir de galería",
    "choose_file": "Elegir archivo",
    "skip_documents": "Omitir por ahora",
    "skip_documents_hint": "Guardamos el borrador y podés subir documentos después.",
    "documents_pending_banner": "Guardamos el anuncio como borrador hasta que capturés la tarjeta de circulación.",
    "documents_partial_pending_banner": "Guardamos la tarjeta. El anuncio queda en revisión con cobertura Qualitas; las reservas se habilitan cuando esté autorizada.",
    "document_review_pending_banner": "Recibimos los documentos. El anuncio queda en revisión; las reservas se habilitan cuando la aseguradora autorice la cobertura.",
    "document_review_required_title": "Hay un documento por corregir",
    "document_review_required_desc": "Subí una nueva captura desde esta pantalla para que operaciones lo revise de nuevo.",
    "document_review_reason_fallback": "No pudimos validar este documento. Subí una foto clara del documento completo.",
    "document_review_reupload_note": "El nuevo envío reemplaza el intento anterior y mantiene el vehículo en revisión hasta que sea aprobado.",
    "document_label_tarjeta_front": "Frente de tarjeta",
    "document_label_tarjeta_back": "Reverso de tarjeta",
    "document_label_insurance_policy": "Póliza de seguro",
    "document_label_generic": "Documento",
    "draft_preserved_after_publish_error": "Guardamos el vehículo como borrador. Corregí el error y tocá Publicar de nuevo; no tenés que empezar desde cero.",
    "camera_permission_denied": "Se necesita permiso de cámara",
    "camera_permission_settings_cta": "Abrir configuración",
    "photo_progress": "Foto {{current}} de {{total}}",
    "camera_torch": "Linterna",
    "camera_need_light": "Necesitás buena luz para esta foto. Activá la linterna o tomala de día.",
    "categories": {
      "sedan": "Sedán",
      "suv": "SUV",
      "pickup": "Pick-up",
      "van": "Van",
      "microbus": "Microbús",
      "compact": "Compacto",
      "luxury": "Lujo",
      "sports": "Deportivo",
      "motorcycle": "Motocicleta",
      "heavy_duty": "Maquinaria pesada",
      "recreational": "Diversión"
    },
    "transmissions": {
      "automatic": "Automático",
      "manual": "Manual",
      "cvt": "Automático",
      "dct": "Automático"
    },
    "fuel_types": {
      "gasoline": "Gasolina",
      "diesel": "Diésel",
      "electric": "Eléctrico",
      "hybrid": "Híbrido",
      "plugin_hybrid": "Híbrido enchufable"
    },
    "vehicle_features": {
      "diesel_included": "Diésel incluido",
      "driver_included": "Motorista incluido",
      "diesel_included": "Diésel incluido",
      "driver_included": "Motorista incluido",
      "ac": "Aire acondicionado",
      "bluetooth": "Bluetooth",
      "gps": "GPS",
      "usb": "USB",
      "backup_camera": "Cámara de reversa",
      "cruise_control": "Control crucero",
      "sunroof": "Techo solar",
      "heated_seats": "Asientos calefactados",
      "leather_seats": "Asientos de cuero",
      "keyless_entry": "Entrada sin llave",
      "android_auto": "Android Auto",
      "apple_carplay": "Apple CarPlay",
      "child_seat": "Asiento de niño",
      "roof_rack": "Barras de techo",
      "tow_hitch": "Gancho de remolque",
      "spare_tire": "Llanta de repuesto",
      "dash_cam": "Dashcam",
      "first_aid_kit": "Botiquín"
    },
    "ai_generate": "Generar con IA",
    "ai_generating": "Generando...",
    "ai_generate_description": "Crear descripción atractiva con IA",
    "ai_generation_failed": "No se pudo generar. Escribí tu propia descripción.",
    "ai_regenerate": "Regenerar",
    "ai_suggested_price": "Precio sugerido",
    "ai_price_range": "Rango del mercado",
    "ai_price_budget": "Económico",
    "ai_price_competitive": "Competitivo",
    "ai_price_premium": "Premium",
    "ai_price_no_data": "Sin datos suficientes para sugerir precio",
    "ai_price_based_on": "Basado en {{count}} vehículos similares",
    "ai_use_suggestion": "Usar sugerencia",
    "validation": {
      "make_required": "Seleccioná la marca",
      "model_required": "Seleccioná el modelo",
      "year_too_old": "El año es muy antiguo",
      "year_too_new": "El año no puede ser futuro",
      "category_required": "Seleccioná la categoría",
      "color_required": "El color es obligatorio",
      "color_max": "Máximo 30 caracteres",
      "transmission_required": "Seleccioná la transmisión",
      "fuel_type_required": "Seleccioná el combustible",
      "seats_min": "Mínimo 1 asiento",
      "seats_max": "Máximo 15 asientos",
      "doors_min": "Mínimo 2 puertas",
      "doors_max": "Máximo 6 puertas",
      "plate_required": "La placa es obligatoria",
      "plate_max": "Máximo 15 caracteres",
      "vin_length": "El VIN debe tener 17 caracteres",
      "vin_format": "Formato de VIN inválido",
      "title_min": "Mínimo 10 caracteres",
      "no_contact": "No incluyas teléfonos, correos ni redes: la coordinación va por el chat de Tago.",
      "title_max": "Máximo 80 caracteres",
      "description_min": "Mínimo 30 caracteres",
      "description_max": "Máximo 1000 caracteres",
      "features_min": "Podés continuar sin marcar características",
      "features_max": "Máximo 20 características",
      "rules_max": "Máximo 500 caracteres",
      "photos_min": "Completá las 17 tomas de inspección",
      "photos_max": "Se requieren exactamente 17 tomas de inspección",
      "photos_required_all": "Completá las 17 tomas de inspección antes de continuar",
      "photos_live_only": "Todas las fotos deben capturarse en vivo dentro de Tago",
      "photos_duplicate_slot": "Cada toma de inspección debe capturarse una sola vez",
      "address_required": "La dirección es obligatoria",
      "country_required": "El país es obligatorio",
      "daily_rate_min": "Mínimo $15/día",
      "daily_rate_max": "Máximo $1,000/día",
      "security_deposit_max": "Máximo $500 de depósito",
      "security_deposit_min": "El depósito no puede ser negativo",
      "min_rental_invalid": "Elegí una duración mínima válida.",
      "plate_exists": "Ya existe un vehículo activo con esa placa. Revisá la placa o editá el vehículo existente.",
      "insurance_agency_only": "Por ahora, todas las publicaciones deben usar póliza propia verificada.",
      "location_must_be_sv": "La ubicación del vehículo debe estar dentro de El Salvador"
    }
  },
  "privacy": {
    "intro": "Esta Política de Privacidad ha sido redactada conforme a la Ley para la Protección de Datos Personales de El Salvador (Decreto 144/2024). TAKE AND GO, S.A.S. DE C.V. (en adelante, \"Tago\") describe aquí cómo recopila, usa y divulga tus datos. La versión completa está en tago.rent/es/legal/privacy-policy.",
    "data_collection_title": "Recopilación de datos",
    "data_collection_body": "Recopilamos: (a) datos que nos das directamente — nombre, correo, contraseña, teléfono, domicilio, licencia de conducir, fotos de perfil, fecha de nacimiento, datos del vehículo (NIV/VIN, ubicación, fotos), datos de pago procesados por proveedores certificados PCI-DSS, datos de verificación de identidad (DUI frente y reverso, pasaporte, NIT, historial de conducción) y datos biométricos (reconocimiento facial) únicamente con tu consentimiento expreso; (b) datos automáticos — uso, ubicación (con tu consentimiento), dispositivo, viaje, cookies; (c) datos de terceros — inicio de sesión social, dispositivos del vehículo, verificación de antecedentes en la medida permitida por ley.",
    "data_usage_title": "Uso de datos",
    "data_usage_body": "Usamos tus datos para: prestar y operar los Servicios (gestión de cuenta, reservas, soporte, comunicaciones), investigación y desarrollo (datos agregados o anonimizados), marketing con tu consentimiento expreso, seguridad y protección (verificar identidad, detectar fraude, evaluar riesgo), y cumplir la legislación salvadoreña aplicable. Nunca vendemos tus datos personales.",
    "data_sharing_title": "Compartición de datos",
    "data_sharing_body": "Solo divulgamos datos: con tu consentimiento expreso; en perfiles públicos (nombre, foto, ciudad del vehículo, reseñas); entre Anfitriones y Huéspedes al confirmar una Reserva (teléfono, licencia, dirección de entrega); con proveedores de servicio bajo confidencialidad (alojamiento, pagos, seguros, asistencia, atención al cliente) y únicamente lo necesario para operar verificación, cobertura o reclamos; con asesores profesionales; en transferencias comerciales; o ante solicitudes legales.",
    "user_rights_title": "Tus derechos ARCO-POL",
    "user_rights_body": "Conforme al Decreto 144/2024 tenés derechos ARCO-POL:\n\n• Acceso — conocer qué datos tuyos poseemos. En la app: Perfil → Descargar mis datos.\n• Rectificación — corregir datos inexactos. En la app: Perfil → Editar perfil.\n• Cancelación / Supresión — solicitar la eliminación cuando ya no sean necesarios. En la app: Perfil → Eliminar cuenta.\n• Oposición — oponerte al tratamiento para fines específicos. Se ejerce por solicitud escrita a privacy@tago.rent; todavía no hay un control para esto dentro de la app.\n• Portabilidad — recibir tus datos en formato estructurado. En la app: Perfil → Descargar mis datos.\n• Olvido — solicitar la eliminación cuando los datos sean inadecuados o excesivos. Se ejerce por solicitud escrita a privacy@tago.rent.\n• Limitación — suspensión temporal del tratamiento. Se ejerce por solicitud escrita a privacy@tago.rent; todavía no hay un control para esto dentro de la app.\n\nPara ejercerlos, escribí a privacy@tago.rent o al Delegado de Protección de Datos en dpo@tago.rent. Tu solicitud debe llevar tu nombre, tu documento de identidad, la descripción de los datos, el derecho que ejercés y tu firma (Art. 18); si le falta algo te hacemos una única prevención y tenés 10 días hábiles para completarla.\n\nRespondemos en un máximo de 20 días hábiles (Art. 20), prorrogables una sola vez por hasta 20 días hábiles más, avisándote de la prórroga. Si negamos tu solicitud, total o parcialmente, te lo notificamos por resolución motivada dentro de los 3 días hábiles siguientes (Art. 22). Es gratuito.\n\nPara cerrar tu cuenta y eliminar tus datos, usá Perfil → Eliminar cuenta o escribí a cuentas@tago.rent. Cuando una ley nos obliga a resguardar información —facturación y DTE 10 años, registros de la relación comercial 10 años— esos registros quedan bloqueados, disponibles solo para autoridades y para defender reclamos, en lugar de eliminarse (Art. 11).",
    "contact_title": "Contacto",
    "contact_body": "Privacidad general — privacy@tago.rent\nDelegado de Protección de Datos (DPO) — dpo@tago.rent\nCierre de cuenta — cuentas@tago.rent\n\nAutoridad de supervisión: Agencia de Ciberseguridad del Estado (ACE) — agenciadeciberseguridad.gob.sv"
  },
  "terms": {
    "effective_date": "Última actualización: 15 de abril de 2026",
    "intro": "Estos Términos y Condiciones rigen el uso de Tago, plataforma de alquiler de vehículos entre particulares operada en la República de El Salvador por TAKE AND GO, S.A.S. DE C.V., sociedad salvadoreña inscrita en el Registro de Comercio del CNR bajo el asiento 152, libro 4942, desde el 10 de marzo de 2026. Al crear una cuenta o confirmar una Reserva, aceptás estos Términos. La versión completa está en tago.rent/es/legal/terms-of-service.",
    "eligibility_title": "Elegibilidad y verificación",
    "eligibility_body": "Para usar Tago debés:\n\n• Ser persona natural mayor de 18 años con plena capacidad legal (Art. 1316 Código Civil).\n• Poseer licencia de conducir vigente válida para la categoría del vehículo.\n• Completar la verificación de identidad: DUI, pasaporte u otro documento oficial; verificación biométrica facial con tu consentimiento expreso; verificación de teléfono y correo.\n• Aceptar estos Términos y la Política de Privacidad.\n\nCada persona natural mantiene una única cuenta. Tago puede suspender o cancelar cuentas con información falsa, incumplimientos o indicios de fraude.",
    "platform_role_title": "Rol de la plataforma",
    "platform_role_body": "Tago es plataforma de intermediación tecnológica. Tago no es parte del contrato de arrendamiento entre Anfitrión y Huésped, que se rige por los Arts. 1703 y siguientes del Código Civil. Tago facilita el pago, la verificación y la mediación de disputas.\n\nTago se reserva el derecho de modificar estos Términos. Los cambios materiales se notificarán al menos 15 días antes de su entrada en vigor.",
    "rental_rules_title": "Reglas del alquiler",
    "rental_rules_body": "Durante el Viaje, el Huésped se obliga a:\n\n• Conducir personalmente el vehículo y no cederlo a terceros no autorizados.\n• Respetar la Ley de Transporte Terrestre, Tránsito y Seguridad Vial (Decreto 477/1995).\n• No conducir bajo efectos de alcohol u otras sustancias.\n• Reportar de inmediato accidentes, daños o incidentes.\n• No fumar dentro del vehículo ni transportar sustancias ilegales o mercancías comerciales.\n• No salir del territorio salvadoreño sin autorización escrita del Anfitrión y de Tago.\n• Devolver el vehículo con el mismo nivel de combustible, o abonar el equivalente.\n\nProhibido subarrendar el vehículo, modificarlo, remolcar otros vehículos o pagar al Anfitrión fuera de la Plataforma.",
    "payment_title": "Pagos e impuestos",
    "payment_body": "Pagos en dólares estadounidenses (USD), moneda de curso legal en El Salvador. Durante el piloto, las tarifas visibles antes del checkout muestran la tarifa base; el precio final del Huésped se presenta en el paso de pago. Tago no almacena datos de tarjetas — los procesan proveedores certificados PCI-DSS. Tago no acepta pagos en efectivo entre Anfitrión y Huésped por conceptos de la Reserva.\n\nEl Precio del Viaje incluye tarifa base, comisión de servicio de Tago y cargos adicionales opcionales. Algunos vehículos pueden requerir un depósito de garantía reembolsable definido por el Anfitrión; cuando aplica, se muestra antes del pago, se cobra junto con la Reserva, lo retiene Tago y se devuelve completo al Huésped al finalizar el Viaje si no hay daños. Las ganancias del Anfitrión se transfieren a su cuenta registrada dentro de las 48 horas siguientes a la finalización del Viaje. El Anfitrión es responsable de declarar y pagar los impuestos correspondientes a sus ingresos por arrendamiento (ISR e IVA cuando corresponda).",
    "cancellation_title": "Cancelaciones",
    "cancellation_body": "Derecho de retracto (Art. 13-A LPC): dentro de los 8 días siguientes a la reserva y antes de que inicie el Viaje, podés cancelar sin justificación ni penalidad y se te reversan todas las sumas pagadas, incluida la comisión, dentro de 15 días. Esta regla prevalece sobre los tiers de abajo.\n\nFuera de ese supuesto, la comisión de servicio de Tago no se reembolsa en cancelaciones del Huésped. Solo se reembolsa cuando cancela el Anfitrión o Tago, o cuando el Viaje no llega a prestarse.\n\nResumen del precio base del alquiler:\n\n• Cancelación con más de 48 horas de anticipación: 100% al Huésped.\n• Entre 24 y 48 horas antes: 50% al Huésped, 50% al Anfitrión.\n• Menos de 24 horas: 0% al Huésped, 100% al Anfitrión.\n• No presentación: 0% al Huésped, 100% al Anfitrión; seguro y servicios adicionales no se reembolsan.\n• Cancelación por Anfitrión: 100% al Huésped + tarifas para el Anfitrión ($25 / $50 / $150 según anticipación).\n• Cancelación por Tago: 100% al Huésped.\n\nDetalle completo en la pantalla Política de Cancelación.",
    "insurance_title": "Seguro",
    "insurance_body": "Cada vehículo publicado debe contar con póliza o certificado propio vigente y verificado, o con la cobertura de plataforma aprobada, antes de activarse. La cobertura incluida es una sola, sin planes para escoger: la prima por día se integra al total de la reserva y se paga en checkout.\n\nLa póliza debe emitirse antes de confirmar el viaje. Si no puede emitirse, Tago cancelará la reserva y procesará el reembolso correspondiente.\n\nEl depósito de garantía es opcional y lo define cada Anfitrión; cuando aplica, es reembolsable y se devuelve completo al terminar el Viaje si no hay daños.",
    "liability_title": "Limitación de responsabilidad",
    "liability_body": "Tago no asume responsabilidad directa por: el estado mecánico de los vehículos publicados, la exactitud de la información del Anfitrión, el comportamiento de los Usuarios durante el Viaje, accidentes o multas durante el Viaje, pérdida de bienes personales del Huésped, ni daños a terceros causados por el Huésped.\n\nLa responsabilidad total de Tago frente a un Usuario no superará el monto total de las comisiones de servicio pagadas por dicho Usuario en los 12 meses anteriores al evento. Estas limitaciones no aplican en caso de dolo o culpa grave de Tago, ni cuando la Ley de Protección al Consumidor las prohíba.",
    "disputes_title": "Resolución de disputas",
    "disputes_body": "Paso 1 — Comunicación directa entre las partes en la mensajería de Tago dentro de las 48 horas siguientes al evento.\n\nPaso 2 — Mediación de Tago: escalar a hola@tago.rent dentro de los 5 días calendarios siguientes al Viaje, adjuntando documentación.\n\nPaso 3 — Resolución no vinculante de Tago dentro de los 10 días hábiles.\n\nSi no satisface, las partes pueden acudir al Centro de Mediación del Ministerio de Justicia, al Centro de Arbitraje y Mediación de la CCIES, o a los tribunales civiles y mercantiles de San Salvador. Los consumidores pueden reclamar ante la Defensoría del Consumidor (defensoria.gob.sv · Tel. 910).",
    "termination_title": "Terminación y eliminación de cuenta",
    "termination_body": "Podés eliminar tu cuenta en cualquier momento desde Perfil → Eliminar cuenta (al final del menú de Perfil, junto a Cerrar sesión), o escribiendo a cuentas@tago.rent. Si antes querés una copia de tu información, usá Perfil → Descargar mis datos.\n\nAl solicitarlo abrimos un período de gracia de 30 días —una decisión nuestra, no el plazo legal para responder solicitudes de datos— durante el cual podés cancelar la eliminación. Pasados esos 30 días, los datos personales se anonimizan de forma irreversible.\n\nLos registros que una ley nos obliga a resguardar (facturación y DTE 10 años, registros de la relación comercial 10 años) no se eliminan: quedan bloqueados, disponibles únicamente para autoridades y tribunales y para la defensa de reclamos (Art. 11, Decreto 144/2024).\n\nLa cancelación no exime al Usuario del pago de obligaciones pendientes generadas antes de la cancelación.",
    "governing_law_title": "Ley aplicable y jurisdicción",
    "governing_law_body": "Estos Términos se rigen por las leyes de la República de El Salvador (Código Civil, Código de Comercio, Ley de Protección al Consumidor Decreto 776/2005, Ley para la Protección de Datos Personales Decreto 144/2024, Ley de Ciberseguridad, Ley de Transporte Terrestre Decreto 477/1995, entre otras). Las partes se someten expresamente a la jurisdicción de los tribunales civiles y mercantiles de San Salvador, renunciando a cualquier otro fuero. La versión en español de estos Términos es la versión oficial y vinculante.",
    "contact_title": "Contactos",
    "contact_body": "Atención al cliente — hola@tago.rent\nPrivacidad y datos — privacy@tago.rent\nDelegado de Protección de Datos (DPO) — dpo@tago.rent\nAsuntos legales — legal@tago.rent\nCierre de cuenta — cuentas@tago.rent"
  },
  "cancellation_policy": {
    "intro": "Esta Política regula reembolsos y atribución de fondos cuando una Reserva no se completa. Versión completa en tago.rent/es/legal/cancellation-policy.\n\nPrincipio rector: la comisión de servicio de Tago no se reembolsa en cancelaciones del Huésped ni en fuerza mayor. Solo se reembolsa cuando cancela el Anfitrión o el equipo de Confianza y Seguridad de Tago. El precio base no reembolsado al Huésped se acredita al Anfitrión.",
    "full_refund_title": "Cancelación del Huésped — más de 48 horas antes",
    "full_refund_body": "• Precio base del alquiler: 100% al Huésped.\n• Seguro y servicios adicionales no utilizados: 100%.\n• Comisión de servicio de Tago: no reembolsable.\n\nEl Anfitrión no recibe compensación porque hay tiempo suficiente para reasignar la disponibilidad.",
    "partial_refund_title": "Cancelación del Huésped — entre 24 y 48 horas antes",
    "partial_refund_body": "• Precio base del alquiler: 50% al Huésped.\n• Seguro y servicios adicionales no utilizados: 100%.\n• Comisión de servicio de Tago: no reembolsable.\n\nEl Anfitrión recibe el 50% restante del precio base como compensación por la disponibilidad bloqueada.",
    "no_refund_title": "Cancelación del Huésped — menos de 24 horas",
    "no_refund_body": "• Precio base del alquiler: 0% al Huésped.\n• Seguro y servicios adicionales no utilizados: 100%.\n• Comisión de servicio de Tago: no reembolsable.\n\nEl Anfitrión recibe el 100% del precio base como compensación por la disponibilidad bloqueada.",
    "no_show_title": "No presentación del Huésped",
    "no_show_body": "Se considera no presentación si el Huésped no cancela y no se presenta dentro de los 30 minutos posteriores al inicio programado, o si llega sin licencia válida o envía a un tercero no autorizado.\n\n• Precio base: 0% al Huésped, 100% al Anfitrión.\n• Seguro y servicios adicionales: 0% (ya activados).\n• Comisión de servicio de Tago: no reembolsable.\n\nEl Anfitrión debe reportar la no presentación dentro de las 72 horas posteriores al inicio programado.",
    "host_cancellation_title": "Cancelación del Anfitrión",
    "host_cancellation_body": "Si el Anfitrión cancela una Reserva confirmada, el Huésped recibe reembolso completo de todos los conceptos: precio base, comisión de servicio de Tago, seguro y servicios adicionales.\n\nEl Anfitrión queda sujeto a tarifas de cancelación:\n• Más de 24 horas de anticipación: $25.\n• Menos de 24 horas: $50.\n• No presentación del Anfitrión (>30 min del inicio): $150.\n\nLas cancelaciones reiteradas pueden resultar en menor posicionamiento o suspensión de la cuenta.",
    "tago_cancellation_title": "Cancelación por Tago",
    "tago_cancellation_body": "El equipo de Confianza y Seguridad puede cancelar una Reserva en casos excepcionales (incumplimiento de Términos, riesgo a la seguridad, investigación abierta).\n\n• Huésped: 100% de todos los conceptos, incluida la comisión de servicio.\n• Anfitrión: si Tago cancela con más de 24 horas, no recibe ganancias. Con menos de 24 horas, recibe compensación proporcional según la duración del Viaje.",
    "force_majeure_title": "Fuerza mayor",
    "force_majeure_body": "Para cancelaciones motivadas por fuerza mayor (desastres naturales, emergencias nacionales, pandemia declarada por autoridad competente u otros eventos imprevisibles), Tago evalúa caso a caso.\n\nPor defecto: Huésped recibe 100% del precio base, seguro y servicios adicionales; la comisión de servicio de Tago no se reembolsa; el Anfitrión no recibe compensación pero tampoco penalidad.",
    "disputes_title": "Disputas de cancelación",
    "disputes_body": "Si considerás que una cancelación se procesó incorrectamente, abrí una disputa desde tu historial de Viajes dentro de las 48 horas. La contraparte tiene 72 horas para responder con evidencia.\n\nSi no hay acuerdo, Tago revisa la evidencia y emite una resolución no vinculante dentro de los 10 días hábiles. Las disputas no resueltas internamente se rigen por la legislación salvadoreña y son competencia de los tribunales de San Salvador. También podés reclamar ante la Defensoría del Consumidor (defensoria.gob.sv · Tel. 910)."
  },
  "data_export": {
    "title": "Exportar Datos",
    "description": "Podés solicitar una copia completa de tus datos personales almacenados en Tago. Esto incluye tu perfil, historial de viajes, mensajes, reseñas y cualquier otro dato asociado a tu cuenta.",
    "arco_title": "¿Qué son los derechos ARCO?",
    "arco_body": "Los derechos ARCO-POL (Acceso, Rectificación, Cancelación, Oposición, Portabilidad, Olvido y Limitación) te permiten controlar cómo se manejan tus datos personales. Al solicitar una exportación estás ejerciendo tus derechos de Acceso y Portabilidad.",
    "request_button": "Solicitar exportación de datos",
    "processing_note": "La exportación se genera al instante y se guarda en tu dispositivo. Si pedís tus datos por escrito a privacy@tago.rent, el plazo legal de respuesta es de 20 días hábiles, prorrogable una sola vez por hasta 20 días hábiles más avisándote.",
    "saved_to_cache": "Se guardó en la caché de la app. Escribinos a privacy@tago.rent si necesitás otra forma de entrega.",
    "success": "Tu exportación de datos está lista.",
    "error": "No pudimos generar la exportación.",
    "requesting": "Generando exportación…",
    "regenerate": "Volver a descargar datos",
    "completed_note": "Tus datos fueron exportados. El archivo está en tus descargas o en el menú de compartir.",
    "email_fallback_intro": "¿Necesitás otro formato o ayuda? Escribinos:"
  },
  "payment_methods": {
    "title": "Métodos de pago",
    "trust_title": "Protegidas por Wompi",
    "trust_body": "Wompi tokeniza tus tarjetas. Tago sólo muestra marca, últimos 4 dígitos y vencimiento para que podás reconocerlas.",
    "empty_title": "Agregá tu primera tarjeta",
    "empty_desc": "Guardá tarjetas para pagar más rápido sin escribir todos los datos cada vez.",
    "add": "Agregar tarjeta",
    "add_first": "Agregar tarjeta",
    "add_desc": "La tarjeta se tokeniza con Wompi. Para pagos futuros podríamos pedirte el CVV por seguridad.",
    "nickname": "Nombre de la tarjeta",
    "nickname_placeholder": "Personal, trabajo, débito...",
    "make_default": "Usar como predeterminada",
    "save_card": "Guardar tarjeta",
    "secure_footnote": "Wompi protege la tarjeta. Tago no guarda el número completo ni el CVV.",
    "load_error": "No pudimos cargar tus tarjetas. Probá de nuevo.",
    "default_badge": "Principal",
    "set_default": "Hacer principal",
    "expiry": "vence {{expiry}}",
    "card": "Tarjeta",
    "delete_title": "Eliminar tarjeta",
    "delete_desc": "La tarjeta se quitará de tus métodos guardados. Podés agregarla otra vez cuando querás."
  },
  "org": {
    "title": "Organización",
    "settings_title": "Ajustes de la organización",
    "no_organization": "Aún no tenés una organización",
    "create": "Crear organización",
    "create_desc": "Configurá tu empresa con NIT y representante legal para gestionar vehículos, equipo y ganancias en un solo lugar.",
    "create_and_publish": "Crear agencia y publicar",
    "create_failed": "No pudimos crear la organización. Revisá los datos y probá de nuevo.",
    "created_title": "Organización creada",
    "created_desc": "Ya podés invitar miembros y agregar vehículos.",
    "join": "Unirme a una existente",
    "join_coming_soon": "Esta función estará disponible pronto.",
    "skip": "Continuar sin organización",
    "skip_hint": "Podés configurar esto después desde el panel de anfitrión.",
    "detected_title": "Este vehículo pertenece a una empresa",
    "detected_desc": "Para gestionar vehículos de empresa, podés crear una organización y administrar tu equipo.",
    "name": "Nombre de la organización",
    "name_placeholder": "Ej: Transportes Mejía",
    "legal_name": "Razón social",
    "legal_name_placeholder": "Ej: Transportes Mejía, S.A. de C.V.",
    "legal_info": "Información legal",
    "tax_id": "NIT",
    "tax_id_placeholder": "Ej: 0614-050707-104-8",
    "tax_id_helper": "NIT de la empresa o agencia registrada. Lo usamos para validación legal y facturación.",
    "tax_id_helper_empty": "Escribí los 14 dígitos; ponemos los guiones automáticamente.",
    "tax_id_helper_progress": "Faltan {{count}} dígitos para completar el NIT.",
    "tax_id_helper_valid": "NIT con formato y dígito verificador válidos.",
    "tax_id_accessibility_hint": "Ingresá el NIT de 14 dígitos. Tago agregará los guiones automáticamente.",
    "tax_id_exists": "Ya existe una organización activa con ese NIT.",
    "limit_reached": "Alcanzaste el máximo de organizaciones permitidas.",
    "legal_representative": "Representante legal",
    "legal_representative_desc": "Usaremos tu perfil verificado como representante responsable de esta empresa.",
    "email": "Correo electrónico",
    "email_placeholder": "contacto@empresa.com",
    "phone": "Teléfono",
    "phone_placeholder": "+503 0000-0000",
    "website": "Sitio web",
    "insurance_model": "Modelo de seguro",
    "insurance_platform": "Seguro de plataforma",
    "insurance_fleet": "Seguro propio de la flota",
    "insurance_hybrid": "Híbrido",
    "insurance_none": "Sin seguro",
    "members": "Miembros del equipo",
    "no_members": "Aún no hay miembros",
    "no_members_desc": "Invitá por correo o teléfono a quienes van a manejar los vehículos de la empresa.",
    "invite_member": "Invitar miembro",
    "invite_sent": "Invitación enviada. Si la persona aún no tiene Tago, se agregará al crear su cuenta.",
    "invite_already_exists": "Esta persona ya fue invitada a la organización.",
    "pending_invites": "Invitaciones pendientes",
    "invite_pending_external": "Miembro invitado",
    "invite_pending_desc": "Se agregará automáticamente cuando cree su cuenta de Tago con este contacto.",
    "invite_by_phone": "Invitar por teléfono",
    "invite_by_email": "Invitar por correo",
    "invite_method_email": "Correo",
    "invite_method_phone": "Teléfono",
    "role_label": "Rol",
    "role_manager": "Administrador",
    "role_driver": "Conductor",
    "verification": "Verificación de empresa",
    "verification_pending": "Verificación pendiente",
    "verification_desc": "Subí los documentos del representante legal y completá la información fiscal para verificar la empresa.",
    "verified": "Empresa verificada",
    "claim_vehicles": "Reclamar vehículos",
    "claim_desc": "Encontramos {{count}} vehículos registrados a nombre de tu empresa",
    "dashboard": "Panel de organización",
    "earnings": "Ganancias",
    "vehicles": "Vehículos",
    "settings": "Configuración",
    "remove_member": "Remover miembro",
    "remove_confirm": "¿Seguro que querés remover a {{name}}?",
    "member_removed": "Miembro removido",
    "prefilled_from_tarjeta": "Pre-llenado desde la tarjeta de circulación",
    "company_prompt": "¿Este vehículo pertenece a una empresa?",
    "join_search_placeholder": "Buscar por nombre de empresa...",
    "join_confirm_title": "Solicitar ingreso",
    "join_confirm_desc": "¿Solicitar ingreso a {{name}}? Un administrador deberá aprobar tu solicitud.",
    "join_request_sent": "Solicitud enviada",
    "join_no_results": "No se encontraron organizaciones",
    "fleet_mode": "Modo flota",
    "active_org": "Organización activa",
    "vehicle_claimed": "Vehículo agregado a la flota",
    "claim_vehicle_action": "Agregar",
    "not_member_title": "Esta organización no es tuya",
    "not_member_body": "No sos parte del equipo de esta organización, así que no podés ver ni cambiar sus datos. Si te acaban de invitar, aceptá la invitación desde tu correo.",
    "not_member_action": "Ver mis organizaciones",
    "not_manager_title": "Solo un administrador puede cambiar esto",
    "not_manager_body": "Sos parte del equipo, pero cambiar los datos de la organización o invitar gente lo hace un administrador. Pedile a quien administra la flota que lo haga.",
    "not_manager_action": "Volver al equipo"
  },
  "aml": {
    "title": "Cumplimiento",
    "intro_title": "Datos para {{partner}}",
    "intro_body": "Tu identidad ya está verificada y no te la volvemos a pedir. Falta la declaración que exige la ley, y la guardamos desde ya para que {{partner}} pueda emitir tu cobertura apenas se active. Son toques, no formularios.",
    "section_identity": "Esto ya lo sabemos de vos",
    "section_identity_helper": "Sale de tu documento verificado y de tu perfil. Solo confirmá que está bien; si algo cambió, tocá Editar.",
    "source_identity_document": "De tu documento verificado",
    "source_profile": "De tu perfil de Tago",
    "source_confirmed": "Lo confirmaste vos",
    "identity_edit_a11y": "Editar los datos que ya tenemos",
    "identity_edit_close_a11y": "Terminar de editar tus datos",
    "section_economic": "Tu actividad",
    "section_economic_helper": "No se publica en tu perfil ni la ven los anfitriones: {{partner}} la usa solo para cumplimiento. Todo se elige con un toque.",
    "section_declarations": "Declaraciones",
    "section_declarations_helper": "Son las preguntas que la ley obliga a hacer y protegen a los dos lados del viaje. Un “Sí” no te cierra la puerta: te pasa a revisión con una persona.",
    "section_disclaimer": "Autorización {{partner}}",
    "section_cross_border": "Envío internacional",
    "full_name": "Nombre completo",
    "phone": "Teléfono",
    "date_of_birth": "Fecha de nacimiento",
    "gender": "Género",
    "gender_option": {
      "female": "Femenino",
      "male": "Masculino",
      "other": "Otro",
      "prefer_not_to_say": "Prefiero no decir"
    },
    "nationality": "Nacionalidad",
    "nationality_placeholder": "Elegí tu nacionalidad",
    "origin_country": "País de origen",
    "origin_country_placeholder": "Elegí el país de origen",
    "residence_country": "País de domicilio",
    "residence_country_placeholder": "Elegí el país donde vivís",
    "income_range": "Rango de ingresos mensuales",
    "income_option": {
      "1_800": "$1 – $800",
      "801_2000": "$801 – $2,000",
      "2001_4500": "$2,001 – $4,500",
      "4501_6500": "$4,501 – $6,500",
      "6501_10000": "$6,501 – $10,000",
      "10001_plus": "Más de $10,001"
    },
    "economic_activity": "Actividad económica",
    "economic_activity_placeholder": "Elegí tu actividad",
    "activity_option": {
      "employee_private": "Empleado en empresa privada",
      "employee_public": "Empleado del sector público",
      "merchant": "Comerciante o negocio propio",
      "independent_professional": "Profesional independiente",
      "health": "Salud",
      "education": "Educación",
      "transport": "Transporte y logística",
      "construction": "Construcción y oficios",
      "agriculture": "Agricultura, ganadería y pesca",
      "tourism_hospitality": "Turismo, hoteles y restaurantes",
      "technology": "Tecnología y telecomunicaciones",
      "finance": "Servicios financieros y seguros",
      "security": "Seguridad y vigilancia",
      "student": "Estudiante",
      "retired": "Jubilado o pensionado",
      "homemaker": "Trabajo del hogar",
      "unemployed": "Sin actividad económica por ahora",
      "other": "Otra actividad"
    },
    "fund_origin": "Origen de los fondos",
    "fund_option": {
      "salaried": "Asalariado",
      "independent_merchant": "Comerciante independiente",
      "independent_professional": "Profesional independiente"
    },
    "is_pep": "¿Desempeñás o has desempeñado un cargo como Persona Expuesta Políticamente (PEP)?",
    "is_pep_helper": "Incluye cargos públicos de alto nivel, nacionales o internacionales.",
    "is_party_member": "¿Sos miembro de algún partido político?",
    "has_pep_family": "¿Tenés algún familiar que ocupe un cargo como Persona Expuesta Políticamente?",
    "has_pep_associate": "¿Tenés un asociado que ocupe un cargo como Persona Expuesta Políticamente?",
    "tax_haven": "¿Has mantenido relaciones laborales o comerciales con países identificados como paraísos fiscales?",
    "tax_haven_helper": "Respondé según tu mejor conocimiento.",
    "illicit_judicial": "¿Has estado en procesos judiciales o vinculado a actividades ilícitas o terroristas?",
    "illicit_judicial_helper": "Declaración obligatoria por ley. La información es confidencial.",
    "pep_review_title": "Esto lo revisa una persona",
    "pep_review_body": "Cuando hay un cargo público de por medio, {{partner}} no emite la póliza de forma automática. Enviá igual tu declaración: nuestro equipo la gestiona a mano con el asegurador y te avisa. Nada de lo que ya respondiste se pierde.",
    "disclaimer_helper": "Leé el texto completo y marcá la casilla para aceptar. Podés desmarcarla.",
    "disclaimer_scroll_hint": "Seguí bajando",
    "disclaimer_accept_label": "Leí y acepto la declaración y autorización a {{partner}}",
    "disclaimer_step_title": "Declaración {{partner}}",
    "disclaimer_step_subtitle": "Autorizá a {{partner}} a verificar lo que entregaste.",
    "disclaimer_step_submit": "Aceptar y finalizar",
    "disclaimer_step_saved": "Declaración aceptada.",
    "disclaimer_step_error": "No pudimos guardar tu declaración. Intentá de nuevo.",
    "disclaimer_step_already_accepted": "Ya aceptaste la declaración de {{partner}}. La guardamos con la fecha y la versión exacta del texto que leíste.",
    "disclaimer_step_footnote": "Tu aceptación queda registrada con la fecha y la versión del texto. {{partner}} usa esta autorización solo para validar tu información.",
    "cross_border_title": "Tus datos salen de El Salvador",
    "cross_border_body": "Cuando la cobertura se active, {{partner}} va a necesitar esta declaración y tus datos de identidad, y los procesa en sus sistemas en México. Tu autorización queda guardada desde ahora; hasta ese momento no sale nada de El Salvador. Podés retirarla cuando querás escribiendo a privacy@tago.rent.",
    "cross_border_label": "Autorizo enviar mis datos a {{partner}} en México para emitir mi cobertura",
    "cross_border_declined_title": "Sin esta autorización no hay cobertura",
    "cross_border_declined_body": "Es tu decisión y podés dejarla sin marcar. Solo que sin ella {{partner}} no va a poder emitir tu póliza cuando la cobertura se active, y la declaración es obligatoria para reservar. Cerrá esta pantalla y volvé cuando lo tengás claro, o escribinos a privacy@tago.rent.",
    "submit": "Enviar y continuar",
    "submit_manual_review": "Enviar para revisión",
    "success_title": "Datos enviados",
    "success_body": "Quedan en revisión con nuestro socio de cobertura. Te avisamos si hace falta algo.",
    "status_pending_title": "En revisión de cumplimiento",
    "status_pending_body": "Tu declaración quedó guardada con la fecha y la versión exacta del texto que leíste. {{partner}} la revisa y valida la información contra listas como OFAC. Tu identidad y selfie ya quedaron registrados.",
    "status_pending_note": "No tenés que reenviar el formulario.",
    "status_approved_title": "Cumplimiento aprobado",
    "status_approved_body": "Tu declaración con {{partner}} está completa. Ya podés reservar y publicar con normalidad.",
    "needs_update_body": "Necesitamos que actualicés tu declaración de cumplimiento. Revisá los datos y volvé a enviar.",
    "gate_required_toast": "Completá el formulario de cumplimiento para continuar.",
    "error_incomplete": "Revisá los campos marcados para continuar.",
    "error_submit": "No pudimos guardar tu declaración. Intentá de nuevo.",
    "error_required": "Esta respuesta es obligatoria",
    "error_full_name": "Ingresá tu nombre completo",
    "error_phone": "Ingresá un teléfono válido",
    "error_date_of_birth": "Ingresá tu fecha de nacimiento",
    "error_gender": "Elegí una opción",
    "error_nationality": "Elegí tu nacionalidad",
    "error_origin_country": "Indicá tu país de origen",
    "error_residence": "Elegí tu país de domicilio",
    "error_income": "Elegí un rango de ingresos",
    "error_economic_activity": "Elegí tu actividad económica",
    "error_fund_origin": "Elegí el origen de los fondos",
    "error_disclaimer": "Tenés que aceptar la declaración",
    "error_disclaimer_scroll": "Deslizá el texto completo antes de aceptar",
    "error_cross_border": "Falta tu autorización para enviar los datos a México",
    "step_title": "Cumplimiento {{partner}}",
    "step_subtitle": "Formulario AML y autorización de cobertura",
    "step_locked": "Completá identidad y selfie primero",
    "partner_generic": "la aseguradora"
  },
  "updates": {
    "available": "Hay una mejora disponible",
    "restart": "Reiniciar ahora",
    "later": "Más tarde",
    "ota_ready_title": "Mejora lista",
    "ota_ready_body": "Ya se descargó una mejora de Tago. Reiniciá cuando te quede bien para aplicarla.",
    "mandatory_title": "Tago",
    "checking_body": "Preparando la app.",
    "downloading_body": "Descargando la mejora más reciente. La app se reiniciará automáticamente.",
    "restarting_body": "Aplicando la actualización. Esto tarda unos segundos.",
    "store_required_title": "Actualización requerida",
    "store_required_body": "Esta versión ya no es compatible. Actualizá Tago para seguir usando reservas, pagos y verificaciones con seguridad.",
    "store_available_title": "Hay una versión nueva de Tago",
    "store_available_body": "Se descarga sola en segundo plano y podés seguir usando la app. Te avisamos cuando esté lista para reiniciar.",
    "store_prompt_body": "Hay una versión nueva de Tago. Actualizá para recibir correcciones de seguridad y estabilidad.",
    "native_capability_required_body": "Esta versión no trae el módulo nativo de verificación biométrica. Actualizá Tago y volvé a intentar.",
    "blocked_error_title": "No se pudo abrir Tago",
    "blocked_error_body": "No pudimos completar una comprobación interna. Revisá tu conexión e intentá de nuevo.",
    "open_store": "Actualizar Tago",
    "open_store_failed": "No pudimos abrir la tienda desde acá. Abrí App Store o Play Store, buscá «Tago» e instalá la última versión.",
    "retry": "Intentar de nuevo",
    "please_wait": "Esperá un momento",
    "step_checking": "Verificando",
    "step_policy": "Validando",
    "step_ready": "Entrando",
    "step_downloading": "Descargando",
    "step_restarting": "Aplicando",
    "step_store": "Tienda",
    "step_retry": "Reintento",
    "build_requirement": "Build actual: {{current}} · Requerido: {{required}}",
    "ready_title": "Hay una versión nueva lista",
    "ready_action": "Actualizar",
    "ready_a11y": "Hay una versión nueva de Tago lista. Tocá Actualizar para reiniciar y aplicarla."
  },
  "coverage": {
    "already_issued": "Ya existe una póliza para este vehículo en estas fechas. No se cobró de nuevo.",
    "not_available_yet": "La cobertura todavía no está disponible para este vehículo. Ya lo estamos resolviendo.",
    "person_not_eligible": "No podemos emitir la cobertura para esta persona por este medio. Escribinos y te ayudamos.",
    "temporarily_unavailable": "No pudimos emitir la cobertura en este momento. Intentá de nuevo en unos minutos.",
    "vehicle_not_eligible": "Este vehículo no califica para la cobertura. Contactanos y lo revisamos."
  },
  "inspection": {
    "signatures_title": "Firmas",
    "signature_area": "Área de firma de {{who}}",
    "signature_hint": "Firmá acá, {{who}}",
    "signature_clear": "Borrar y firmar de nuevo",
    "signature_guest": "huésped",
    "signature_host": "anfitrión",
    "signatures_help": "Las dos personas firman en este teléfono, junto al carro.",
    "mark_damage": "Marcar daño",
    "damage_marked": "Daño marcado",
    "damage_hint": "Tocá y mantené una foto para marcar un daño.",
    "not_available_title": "Esta reserva ya no está disponible",
    "not_available_body": "Puede que se haya cancelado, vencido o que no sea tuya. Revisá tus viajes activos.",
    "not_available_action": "Volver a viajes",
    "session_needed_title": "Necesitás iniciar sesión",
    "session_needed_body": "Volvé a entrar a tu cuenta para completar la entrega.",
    "stage": {
      "cancelled_title": "Esta reserva se canceló",
      "cancelled_body": "No hay entrega ni devolución que hacer. Si creés que es un error, escribinos.",
      "completed_title": "Este viaje ya terminó",
      "completed_body": "La devolución ya se registró. Podés ver el detalle del viaje.",
      "already_handed_over_title": "El carro ya se entregó",
      "already_handed_over_body": "La entrega ya quedó registrada. Lo que sigue es la devolución.",
      "not_paid_title": "Falta completar el pago",
      "not_paid_body": "La entrega se habilita apenas se confirme el pago de la reserva.",
      "checkin_first_title": "Primero hay que hacer la entrega",
      "checkin_first_body": "La devolución compara contra las fotos de la entrega, así que esa va primero.",
      "go_to_checkout": "Ir a la devolución",
      "go_to_trip": "Ver el viaje"
    },
    "invalid": {
      "condition": "Elegí el estado del vehículo.",
      "photo_uri": "Una de las fotos no se guardó bien. Volvé a tomarla.",
      "photo_area": "Hay una foto de un tipo que no reconocemos. Volvé a tomarla.",
      "photo_size": "Una de las fotos salió dañada. Volvé a tomarla.",
      "photo_captured_at": "Una de las fotos perdió su fecha. Volvé a tomarla.",
      "photo_source": "Las fotos tienen que tomarse con la cámara de Tago.",
      "photos_min": "Faltan fotos del vehículo.",
      "photos_duplicated": "Hay dos fotos del mismo ángulo. Quitá una.",
      "fuel_range": "El combustible va de 0 a 100%.",
      "odometer_range": "Revisá el kilometraje.",
      "odometer_whole": "El kilometraje va sin decimales.",
      "notes_long": "Las notas no pueden pasar de 500 caracteres."
    },
    "evidence_incomplete": "Falta evidencia del traspaso: se necesitan las fotos del vehículo y las dos firmas.",
    "pickup_missing_body": "Falta registrar la entrega del vehículo antes de poder marcarla como en curso."
  },
  "steps": {
    "phone": {
      "label": "Confirmá tu teléfono",
      "eta": "30 seg"
    },
    "email": {
      "label": "Confirmá tu correo",
      "eta": "1 min"
    },
    "identity_document": {
      "label": "Foto de tu DUI",
      "eta": "2 min"
    },
    "selfie": {
      "label": "Una selfie",
      "eta": "30 seg"
    },
    "driver_license": {
      "label": "Foto de tu licencia",
      "eta": "1 min"
    },
    "aml_declaration": {
      "label": "Unas preguntas del seguro",
      "eta": "2 min"
    },
    "unknown_one": "Un paso más que tu versión de la app no reconoce",
    "unknown_other": "{{count}} pasos más que tu versión de la app no reconoce"
  },
  "review_gate": {
    "kicker": "Viaje completado",
    "title_guest": "¿Cómo estuvo tu viaje?",
    "title_host": "¿Cómo estuvo el viaje con {{name}}?",
    "title_fallback": "¿Cómo estuvo el viaje?",
    "context_guest": "{{vehicle}} · con {{name}}",
    "context_host": "{{name}} · viajó en {{vehicle}}",
    "context_fallback": "{{vehicle}}",
    "stars_label": "Tu experiencia",
    "add_comment": "Agregar un comentario",
    "comment_label": "Comentario (opcional)",
    "comment_placeholder": "¿Hay algo más que querás contar?",
    "defer": "Ahora no",
    "submit": "Enviar",
    "rating_1": "Muy mala",
    "rating_2": "Mala",
    "rating_3": "Regular",
    "rating_4": "Buena",
    "rating_5": "Excelente",
    "error_title": "No se pudo enviar la reseña",
    "error_later": "Lo intentamos de nuevo la próxima vez que abrás la app."
  },
  "inspection_evidence": {
    "title": "Evidencia del traspaso",
    "checkin": "Entrega",
    "checkout": "Devolución",
    "photos": "{{count}} fotos",
    "damages": "{{count}} con daño marcado",
    "no_damages": "Sin daños marcados",
    "signed_both": "Firmada por las dos partes",
    "signed_one": "Falta una firma",
    "signed_none": "Sin firmas",
    "signature_host": "Anfitrión",
    "signature_guest": "Huésped",
    "pending": "Todavía no se hizo",
    "signature_unavailable": "Firma guardada (no se pudo mostrar)"
  },
  "handover_presence": {
    "kicker": "Confirmación de presencia",
    "host_hint": "El huésped ingresa el código en su teléfono: queda probado que estuvieron en el mismo lugar y momento.",
    "mint_cta": "Mostrar código de presencia",
    "mint_again": "Generar otro código",
    "mint_failed": "No pudimos generar el código. Probá de nuevo.",
    "expires": "Vence en {{minutes}}:{{seconds}}",
    "code_a11y": "Código de presencia: {{code}}",
    "guest_label": "Código que muestra el anfitrión",
    "guest_placeholder": "6 caracteres",
    "guest_cta": "Verificar presencia",
    "verify_failed": "El código no coincide, ya se usó o venció. Pedí otro.",
    "verified": "Presencia verificada: ambas partes estuvieron acá.",
    "verified_a11y": "Presencia verificada",
    "scan_cta": "Escanear código QR",
    "scan_title": "Apuntá al código del anfitrión",
    "scan_body": "El QR solo vive unos minutos. Si no se lee, escribí los 6 caracteres.",
    "scan_permission_cta": "Activar cámara"
  },
  "services": {
    "coming_soon_title": "Servicios: próximamente",
    "coming_soon_body": "Estamos habilitando grúas, maquinaria y construcción. Mientras tanto, el resto de Tago sigue funcionando igual.",
    "hero_eyebrow": "Servicios Tago",
    "hero_title": "Soluciones para que el trabajo no se detenga.",
    "hero_body": "Pedí grúa, maquinaria, construcción o flete desde un solo lugar. Tago coordina la propuesta antes de cualquier cobro.",
    "hero_cta": "Solicitar un servicio",
    "secondary_cta": "No encontré lo que necesito",
    "active_request_title": "Tu solicitud activa",
    "open_request_accessibility": "Abrir solicitud de {{category}}",
    "category_title": "¿Qué necesitás resolver?",
    "category_subtitle": "Empezá con una categoría; después solo te pedimos lo esencial.",
    "how_it_works_title": "Simple, incluso si nunca pediste esto",
    "how_it_works": {
      "tell_us": {
        "title": "Contanos lo esencial",
        "body": "Servicio, ubicación y cuándo lo necesitás. Nada más para arrancar."
      },
      "we_coordinate": {
        "title": "Tago coordina",
        "body": "Validamos el alcance y te presentamos disponibilidad y precio claros."
      },
      "you_confirm": {
        "title": "Vos confirmás",
        "body": "No hay cobro hasta que revisés y aceptés la propuesta."
      }
    },
    "categories": {
      "tow": {
        "title": "Grúa y auxilio",
        "description": "Remolque, plataforma o ayuda en carretera.",
        "action": "Solicitar grúa y auxilio",
        "badge": "Atención ahora"
      },
      "heavy_equipment": {
        "title": "Maquinaria pesada",
        "description": "Excavación, carga y elevación.",
        "action": "Solicitar maquinaria pesada",
        "badge": "Cotización guiada"
      },
      "construction": {
        "title": "Construcción",
        "description": "Obra, terreno y oficios.",
        "action": "Solicitar construcción",
        "badge": "Cotización guiada"
      },
      "materials": {
        "title": "Flete y materiales",
        "description": "Carga, agregados y suministros.",
        "action": "Solicitar flete y materiales",
        "badge": "Cotización guiada"
      }
    },
    "needs": {
      "tow_vehicle": "Remolque de vehículo",
      "roadside_assistance": "Auxilio en carretera",
      "flatbed_tow": "Grúa de plataforma",
      "excavation": "Excavación",
      "earthmoving": "Movimiento de tierra",
      "lifting": "Grúa y elevación",
      "compaction": "Compactación",
      "concrete": "Concreto",
      "demolition": "Demolición",
      "site_labor": "Mano de obra",
      "site_preparation": "Preparación de terreno",
      "material_delivery": "Entrega de materiales",
      "dump_truck": "Camión de volteo",
      "load_transport": "Transporte de carga",
      "other": "Otro"
    },
    "status": {
      "submitted": "Solicitud recibida",
      "matching": "Buscando disponibilidad",
      "quoted": "Propuesta lista",
      "confirmed": "Confirmado",
      "in_progress": "En camino",
      "completed": "Completado",
      "cancelled": "Cancelado"
    },
    "status_detail": {
      "submitted": "Recibimos tu solicitud. Tago revisará los datos antes de coordinar una propuesta.",
      "matching": "Estamos validando proveedores y disponibilidad para este alcance.",
      "quoted": "Tu propuesta está lista para que la revisés antes de confirmar.",
      "confirmed": "El servicio fue confirmado con los detalles acordados.",
      "in_progress": "El proveedor confirmó que está en camino o trabajando en tu solicitud.",
      "completed": "Este servicio se marcó como completado.",
      "cancelled": "Esta solicitud fue cancelada y no generará ningún cobro."
    },
    "timeline": {
      "submitted": "Registramos los detalles para coordinarlo.",
      "matching": "Buscamos la mejor disponibilidad para tu necesidad.",
      "quoted": "Ya podés revisar el alcance y precio propuesto.",
      "confirmed": "Quedó confirmado con la propuesta aceptada.",
      "in_progress": "El servicio está avanzando.",
      "completed": "El servicio terminó.",
      "cancelled": "La solicitud se cerró sin cobro."
    },
    "requests_load_error_title": "No pudimos cargar tus solicitudes",
    "requests_load_error_body": "Tus categorías siguen disponibles. Probá de nuevo para ver el seguimiento.",
    "form": {
      "title": "Solicitar servicio",
      "subtitle": "Contanos lo mínimo. Tago confirma alcance y precio antes de cobrar.",
      "service_label": "Servicio",
      "need_label": "¿Qué necesitás?",
      "location_label": "¿Dónde lo necesitás?",
      "location_hint": "Punto de servicio",
      "location_placeholder": "Buscá una dirección o lugar",
      "destination_label": "¿A dónde lo llevamos?",
      "destination_hint": "Destino de la grúa",
      "destination_placeholder": "Buscá el taller o destino final",
      "when_label": "¿Cuándo lo necesitás?",
      "timing_now": "Lo necesito ahora",
      "timing_scheduled": "Quiero programarlo",
      "date_label": "Fecha preferida",
      "window_morning": "Mañana",
      "window_afternoon": "Tarde",
      "window_flexible": "Horario flexible",
      "now_note": "Mandamos esta solicitud a coordinación ahora. La llegada y el precio se confirman antes de que aceptés.",
      "details_label": "Contanos un poco más",
      "details_placeholder": "Ej.: el vehículo no enciende, necesito excavar un terreno de 200 m² o mover 10 sacos de cemento.",
      "contact_note": "Usaremos los datos de contacto de tu cuenta solo para coordinar esta solicitud. No hay cobro todavía.",
      "submit": "Enviar solicitud",
      "location_picker_title": "Elegí el punto de servicio",
      "destination_picker_title": "Elegí el destino",
      "location_search_placeholder": "Buscá una dirección, colonia o lugar",
      "location_searching": "Buscando lugares…",
      "location_empty": "No encontramos ese lugar. Probá con una dirección más específica.",
      "location_search_error": "No pudimos buscar lugares ahora. Revisá tu conexión e intentá de nuevo.",
      "error_incomplete": "Revisá el servicio, las ubicaciones necesarias y los detalles antes de enviarla.",
      "error_national": "Por ahora Servicios solo opera dentro de El Salvador.",
      "error_location": "No pudimos confirmar esa ubicación. Elegí otra o intentá de nuevo.",
      "error_rate_limited": "Recibimos varias solicitudes muy rápido. Esperá un momento e intentá de nuevo.",
      "error_submit": "No pudimos enviar tu solicitud. Tus datos siguen aquí para que podás intentarlo otra vez."
    },
    "detail": {
      "title": "Seguimiento del servicio",
      "request_title": "Tu solicitud",
      "location_label": "Ubicación",
      "destination_label": "Destino",
      "when_label": "Cuándo",
      "details_label": "Detalles",
      "now": "Lo necesitás ahora",
      "scheduled": "{{date}} · {{window}}",
      "progress_title": "Seguimiento",
      "quote_title": "Propuesta de Tago",
      "quote_confirm_note": "Al confirmar, Tago coordina los detalles contigo. El pago se acuerda antes de ejecutar el servicio.",
      "accept_quote_cta": "Confirmar propuesta",
      "quote_accepted": "Propuesta confirmada",
      "accept_quote_dialog_title": "¿Confirmar esta propuesta?",
      "accept_quote_dialog_body": "Confirmarás el alcance y precio de {{amount}}. Tago coordinará los siguientes detalles contigo antes de ejecutar el servicio.",
      "accept_quote_confirm": "Sí, confirmar",
      "cancel_cta": "Cancelar solicitud",
      "cancel_dialog_title": "¿Cancelar esta solicitud?",
      "cancel_dialog_body": "La coordinación se detiene y no habrá ningún cobro por esta solicitud.",
      "cancel_confirm": "Sí, cancelar",
      "cancel_error": "No pudimos cancelar esta solicitud. Revisá el estado e intentá de nuevo.",
      "accept_error": "No pudimos confirmar esta propuesta. Revisá el estado e intentá de nuevo.",
      "not_found_title": "No encontramos esta solicitud",
      "not_found_body": "Puede que se haya cerrado o que el enlace ya no sea válido.",
      "back_to_services": "Volver a Servicios"
    }
  },
  "retention": {
    "pair_fee_first_kicker": "Primera reserva con este anfitrión",
    "pair_fee_repeat_kicker": "Volvés con el mismo anfitrión",
    "pair_fee_first_title": "La primera reserva incluye protección y servicio de Tago",
    "pair_fee_repeat_title": "Tu tarifa de Tago ahora es {{pct}}%",
    "pair_fee_body": "No es un descuento sobre el carro. Es la comisión de Tago, más baja porque el encuentro ya existía.",
    "pair_fee_next": "Si repetís, la siguiente baja a {{pct}}%.",
    "pair_fee_floor": "Este es el piso: 5% de aquí en adelante con este anfitrión.",
    "tier_first": "1ª",
    "tier_second": "2ª",
    "tier_rest": "3ª+",
    "coverage_kicker": "Lo que WhatsApp no replica",
    "coverage_title": "Cobertura, depósito, reputación y pagos",
    "coverage_body": "Fuera de Tago el anfitrión asume colisión, robo y disputa. Adentro hay póliza, escrow, reseñas y liquidación.",
    "coverage_point_insurance": "Cobertura y proceso de siniestro dentro de Tago",
    "coverage_point_escrow": "Depósito custodiado contra daños menores",
    "coverage_point_reputation": "Reseñas que solo existen en la plataforma",
    "coverage_point_payments": "Pago trazable, no un acuerdo informal"
  }
}
